
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4uyp4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2cc1f4c2e655a1a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $e9YVH = parcelRequire("e9YVH");

var $lw2HC = parcelRequire("lw2HC");

var $ghVG7 = parcelRequire("ghVG7");

var $epm3G = parcelRequire("epm3G");

var $2riGj = parcelRequire("2riGj");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");
const $2cc1f4c2e655a1a2$var$View = ()=>{
    const [, { resetDraftArticleData: resetDraftArticleData }] = (0, $lw2HC.useArticleId)();
    (0, $5uXOq.useEffect)(()=>()=>{
            // We want to reset deleted so that this flag doesn't show up in any other component
            resetDraftArticleData(true);
        }, [
        resetDraftArticleData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "knowledge-hub-browse-all-articles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2riGj.KnowledgeHubAppBase), {
        appName: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
        shouldRemoveMargin: (0, $3HwlS.getWillShowNav4)()
    }, ({ match: match, query: query, pageContext: pageContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghVG7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epm3G.default), {
            page: match?.params?.pageId,
            sortBy: query?.sortBy,
            cursor: query?.cursor,
            searchQuery: query?.searchQuery,
            spaceKey: query?.spaceKey,
            activationId: pageContext?.activationId
        }))));
};
var $2cc1f4c2e655a1a2$export$2e2bcd8739ae039 = $2cc1f4c2e655a1a2$var$View;

});
parcelRegister("lw2HC", function(module, exports) {

$parcel$export(module.exports, "initialCreateCategoryData", () => $ba746da67c53f4b3$export$4947e9942a5d137c);
$parcel$export(module.exports, "KnowledgeCommonSubscriber", () => $ba746da67c53f4b3$export$d226f0c95b79366b);
$parcel$export(module.exports, "UserCapabilitiesSubscriber", () => $ba746da67c53f4b3$export$42b7b5df8c1dee52);
$parcel$export(module.exports, "useFlagData", () => $ba746da67c53f4b3$export$a9ac4a6dcb7104bf);
$parcel$export(module.exports, "useGetCategory", () => $ba746da67c53f4b3$export$3fa52226f8fff61e);
$parcel$export(module.exports, "useDraftShareId", () => $ba746da67c53f4b3$export$2602997fd4d9b312);
$parcel$export(module.exports, "useArticleId", () => $ba746da67c53f4b3$export$a5eb46485735066a);
$parcel$export(module.exports, "useIsFetchingDraftDetails", () => $ba746da67c53f4b3$export$428db75bed41f9d);
$parcel$export(module.exports, "useRedirectionData", () => $ba746da67c53f4b3$export$e30071c464cba7f9);
$parcel$export(module.exports, "useUserCapabilities", () => $ba746da67c53f4b3$export$7ae10e817e068c57);
$parcel$export(module.exports, "useIsPermittedSpaces", () => $ba746da67c53f4b3$export$60270d772f1f3c76);
$parcel$export(module.exports, "useCategoriesData", () => $ba746da67c53f4b3$export$56b47c5ebac10997);
$parcel$export(module.exports, "useCreateCategoryData", () => $ba746da67c53f4b3$export$1e7300097c003415);
$parcel$export(module.exports, "useSuggestedTopics", () => $ba746da67c53f4b3$export$2328a37d3e371b67);
$parcel$export(module.exports, "usePageNumber", () => $ba746da67c53f4b3$export$1571508029b597f4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $kz5Uo = parcelRequire("kz5Uo");

var $cSB1I = parcelRequire("cSB1I");
const $ba746da67c53f4b3$export$61e797cf03b496e1 = {
    hasConfluenceLicense: false,
    articleUserCapabilities: {
        canCreateArticle: false
    },
    spaceUserCapabilities: {
        editableSpaces: [],
        readableSpaces: []
    }
};
const $ba746da67c53f4b3$export$4947e9942a5d137c = {
    isSubmitting: false,
    formValues: {
        name: '',
        description: ''
    },
    error: {
        formError: undefined,
        fieldErrors: undefined
    },
    createdCategory: null
};
const $ba746da67c53f4b3$export$d4c72bab9d6cc13a = {
    draftShareId: '',
    articleId: '',
    published: false,
    closed: false,
    deleted: false,
    redirectionData: {
        onPublishRedirectUrl: '',
        onCloseRedirectUrl: ''
    },
    isFetchingDraftDetails: false,
    spacesPermitted: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    permittedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    userCapabilities: {
        isLoading: false,
        error: null,
        data: {
            ...$ba746da67c53f4b3$export$61e797cf03b496e1
        }
    },
    linkedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    showConfluenceCreatePageError: false,
    categoriesData: {
        isLoading: true,
        categories: [],
        isCategoriesSupported: false,
        error: null
    },
    createCategoryData: {
        ...$ba746da67c53f4b3$export$4947e9942a5d137c
    },
    spaceKey: '',
    flags: [],
    topics: {
        data: [],
        loading: false,
        error: null
    },
    page: 1
};
const $ba746da67c53f4b3$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $ba746da67c53f4b3$export$d4c72bab9d6cc13a,
    actions: $kz5Uo.actions,
    name: 'KnowledgeCommonStore'
});
const $ba746da67c53f4b3$export$d226f0c95b79366b = (0, $51nlc.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9);
const $ba746da67c53f4b3$export$42b7b5df8c1dee52 = (0, $51nlc.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    displayName: 'UserCapabilitiesSubscriber',
    selector: (0, $cSB1I.getUserCapabilities)
});
const $ba746da67c53f4b3$export$a3c47cea95d8bbd1 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCommonFlags)
});
const $ba746da67c53f4b3$export$a9ac4a6dcb7104bf = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getKnowledgeCommonFlags)
});
const $ba746da67c53f4b3$export$3fa52226f8fff61e = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCategory)
});
const $ba746da67c53f4b3$export$2602997fd4d9b312 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getDraftShareId)
});
const $ba746da67c53f4b3$export$a5eb46485735066a = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getArticleId)
});
const $ba746da67c53f4b3$export$428db75bed41f9d = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getIsFetchingDraftDetails)
});
const $ba746da67c53f4b3$export$e30071c464cba7f9 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getRedirectionData)
});
const $ba746da67c53f4b3$export$7ae10e817e068c57 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getUserCapabilities)
});
const $ba746da67c53f4b3$export$60270d772f1f3c76 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getPermittedSpaces)
});
const $ba746da67c53f4b3$export$40685b8df387d08 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getLinkedSpaces)
});
const $ba746da67c53f4b3$export$56b47c5ebac10997 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCategoriesData)
});
const $ba746da67c53f4b3$export$1e7300097c003415 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getCreateCategoryData)
});
const $ba746da67c53f4b3$export$2328a37d3e371b67 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getSuggestedTopics)
});
const $ba746da67c53f4b3$export$1571508029b597f4 = (0, $3sQ5x.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
    selector: (0, $cSB1I.getPageNumber)
});

});
parcelRegister("kz5Uo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $78ea76781fae4c5f$export$e324594224ef24da);

var $lx7EO = parcelRequire("lx7EO");

var $heXZI = parcelRequire("heXZI");

var $dsFMC = parcelRequire("dsFMC");

var $aInVL = parcelRequire("aInVL");

var $3twc2 = parcelRequire("3twc2");

var $klUDT = parcelRequire("klUDT");

var $2tTYZ = parcelRequire("2tTYZ");

var $ik7FP = parcelRequire("ik7FP");

var $dAXEk = parcelRequire("dAXEk");

var $fMz1O = parcelRequire("fMz1O");

var $dIiIO = parcelRequire("dIiIO");

var $gpe3Z = parcelRequire("gpe3Z");

var $1TU0Q = parcelRequire("1TU0Q");

var $jIuZj = parcelRequire("jIuZj");

var $eP4xZ = parcelRequire("eP4xZ");

var $8QyFO = parcelRequire("8QyFO");

var $6ThCP = parcelRequire("6ThCP");

var $1VmcQ = parcelRequire("1VmcQ");
const $78ea76781fae4c5f$export$e324594224ef24da = {
    setRedirectionData: $1TU0Q.setRedirectionData,
    resetRedirectionData: $1TU0Q.resetRedirectionData,
    publishSuccess: $aInVL.publishSuccess,
    savedSuccess: $3twc2.savedSuccess,
    fetchDraftAndNavigateToEditor: $ik7FP.fetchDraftAndNavigateToEditor,
    navigateCreateDraftRoute: $gpe3Z.navigateCreateDraftRoute,
    fetchCreateArticlePermission: $2tTYZ.fetchCreateArticlePermission,
    fetchLinkedSpaces: $dAXEk.fetchLinkedSpaces,
    resetDraftArticleData: $8QyFO.resetDraftArticleData,
    articleDeleteSuccess: $lx7EO.articleDeleteSuccess,
    fetchUserCapabilities: $dIiIO.fetchUserCapabilities,
    fetchCategories: $klUDT.fetchCategories,
    reorderCategories: $eP4xZ.reorderCategories,
    createCategory: $heXZI.createCategory,
    handleFormInputChange: $heXZI.handleFormInputChange,
    resetCreatedCategory: $heXZI.resetCreatedCategory,
    updateCategorySuccess: $1VmcQ.updateCategorySuccess,
    deleteCategorySuccess: $dsFMC.deleteCategorySuccess,
    removeCommonFlag: $jIuZj.removeCommonFlag,
    fetchSuggestedTopics: $fMz1O.fetchSuggestedTopics,
    setPagination: $6ThCP.setPagination
};

});
parcelRegister("lx7EO", function(module, exports) {

$parcel$export(module.exports, "articleDeleteSuccess", () => $cfa855108534d4c5$export$7e6f4a244457270c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cfa855108534d4c5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            deleted: true,
            articleId: articleId
        });
    };

});

parcelRegister("heXZI", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $015500bcb6a585cb$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "handleFormInputChange", () => $015500bcb6a585cb$export$8e52c4bd9075cb96);
$parcel$export(module.exports, "resetCreatedCategory", () => $015500bcb6a585cb$export$98485bfbe8c8269a);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $fPjip = parcelRequire("fPjip");


var $j8qrr = parcelRequire("j8qrr");

var $lw2HC = parcelRequire("lw2HC");
const $015500bcb6a585cb$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const { formValues: formValues } = {
            ...getState().createCategoryData
        };
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                isSubmitting: true
            }
        });
        try {
            const category = await (0, $j8qrr.createCategory)(projectId, formValues, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories,
                        category
                    ]
                },
                createCategoryData: {
                    ...(0, $lw2HC.initialCreateCategoryData),
                    createdCategory: category
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const { fieldErrors: fieldErrors, formError: formError } = (0, $fPjip.toErrors)(error);
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: false,
                    error: {
                        formError: formError,
                        fieldErrors: fieldErrors
                    }
                }
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'categoryCreate',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };
const $015500bcb6a585cb$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                formValues: {
                    ...getState().createCategoryData.formValues,
                    [field]: value
                }
            }
        });
    };
const $015500bcb6a585cb$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                createdCategory: null
            }
        });
    };

});
parcelRegister("fPjip", function(module, exports) {

$parcel$export(module.exports, "toErrors", () => $fdef67eb1eab7980$export$b0ccdd1765e7cb42);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $i2U8h = parcelRequire("i2U8h");

var $guSo6 = parcelRequire("guSo6");
// Ideally JSD Apollo would have i18n in their error messages, however in the absence of that
// we do a conversion here.
const $fdef67eb1eab7980$var$errorKeyToMessage = {
    'jsd.apollo.error.limit.exceeded': (0, $i2U8h.default).categoriesLimitExceeded,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $i2U8h.default).categoriesNoPermission,
    'jsd.apollo.field.error.category.name.cannot.be.blank': (0, $i2U8h.default).categoriesNameFieldBlank,
    'jsd.apollo.field.error.category.exceeded.name.length': (0, $i2U8h.default).categoriesNameFieldTooLong,
    'jsd.apollo.field.error.category.description.cannot.be.blank': (0, $i2U8h.default).categoriesDescriptionFieldBlank,
    'jsd.apollo.field.error.category.exceeded.description.length': (0, $i2U8h.default).categoriesDescriptionFieldTooLong
};
const $fdef67eb1eab7980$export$b0ccdd1765e7cb42 = (errorResponse)=>{
    const fieldErrorsResponse = errorResponse.fieldErrors || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [field]: {
                message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
                $fdef67eb1eab7980$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, $i2U8h.default).categoriesGenericMessage
            }
        }), {});
    const formError = errorResponse.errorKey ? {
        message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
        $fdef67eb1eab7980$var$errorKeyToMessage[errorResponse.errorKey] || (0, $i2U8h.default).categoriesGenericMessage
    } : undefined;
    return {
        formError: formError,
        fieldErrors: fieldErrors
    };
};
const $fdef67eb1eab7980$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, $guSo6.createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw({
            nativeError: errorResponse,
            formattedError: $fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)
        }));
const $fdef67eb1eab7980$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, $guSo6.updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw($fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)));

});
parcelRegister("i2U8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed327d012ea36dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6ed327d012ea36dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    categoriesGenericMessage: {
        "id": "servicedesk-knowledge-services.categories-generic-message",
        "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
    },
    categoriesNoPermission: {
        "id": "servicedesk-knowledge-services.categories-no-permission",
        "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
    },
    categoriesLimitExceeded: {
        "id": "servicedesk-knowledge-services.categories-limit-exceeded",
        "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
    },
    categoriesNameFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-name-field-blank",
        "defaultMessage": "Name cannot be blank"
    },
    categoriesDescriptionFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-description-field-blank",
        "defaultMessage": "Description cannot be blank"
    },
    categoriesNameFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-name-field-too-long",
        "defaultMessage": "Name cannot be longer than 100 characters"
    },
    categoriesDescriptionFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-description-field-too-long",
        "defaultMessage": "Description cannot be longer than 150 characters"
    }
});

});

parcelRegister("guSo6", function(module, exports) {

$parcel$export(module.exports, "listCategories", () => $61a0664d6d43d351$export$db54be5b1772ef4b);
$parcel$export(module.exports, "createCategory", () => $61a0664d6d43d351$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "updateCategory", () => $61a0664d6d43d351$export$daaacb0271870c9);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $5OrSA = parcelRequire("5OrSA");

var $2Lj35 = parcelRequire("2Lj35");

const $61a0664d6d43d351$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
};
const $61a0664d6d43d351$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category/`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, $2Lj35.categoryGuidToString)(categoryId)}`, {
        method: 'DELETE'
    });
};
const $61a0664d6d43d351$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
        method: 'POST',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $61a0664d6d43d351$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    let body = {
        articleId: articleId,
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; articleId: string; featured: boolean | undefined; }' is not assignable to type '{ articleId: string; featured: boolean | undefined; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article`, {
        method: 'POST',
        body: JSON.stringify(body)
    });
};
const $61a0664d6d43d351$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
        method: 'DELETE'
    });
const $61a0664d6d43d351$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
const $61a0664d6d43d351$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    let body = {
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; featured: boolean; }' is not assignable to type '{ featured: boolean; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article/${articleId}`, {
        method: 'PUT',
        body: JSON.stringify(body)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $61a0664d6d43d351$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, $5OrSA.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
        method: 'PUT',
        body: JSON.stringify(categories)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));

});
parcelRegister("5OrSA", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $f90c86f7d1f72b9b$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $f90c86f7d1f72b9b$export$64ab95a52860b608);
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $561FV = parcelRequire("561FV");

var $kVLXA = parcelRequire("kVLXA");

var $487fd = parcelRequire("487fd");

var $7f4tk = parcelRequire("7f4tk");

var $7zmUm = parcelRequire("7zmUm");
const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode,
        traceId: traceId
    });
const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
    const traceId = error.traceId;
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
        return {
            response: response,
            statusCode: error.statusCode,
            traceId: traceId
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
    }
};
const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, $7f4tk.default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, $487fd.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, $7zmUm.default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});


parcelRegister("2Lj35", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $6a4fff955a10b2dc$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $6a4fff955a10b2dc$export$be5c80c4ad1faf99);
const $6a4fff955a10b2dc$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
const $6a4fff955a10b2dc$export$43162cfd3260b2fe = (guid)=>guid;
const $6a4fff955a10b2dc$export$be5c80c4ad1faf99 = (guid)=>guid;

});

const $45c806b56a43da0e$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $45c806b56a43da0e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';



const $d7e8e0de2b5415e5$export$d42203c46ecda0b5 = 'ncs';
const $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c = 'JSM';
const $d7e8e0de2b5415e5$export$a40257481ddef37e = 'atlassianAccount';
const $d7e8e0de2b5415e5$export$d57b6b390e78d90f = 'jsm-nebula';
const $d7e8e0de2b5415e5$export$85314a8fbb8155e1 = 'MONTHLY';
const $d7e8e0de2b5415e5$export$d1eb58f682ad65ad = 'ANNUAL';
const $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4 = 'INACTIVE';

parcelRegister("j8qrr", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $50b96e14ac428fad$export$7ce9dbcc6d544b1);

var $7f4tk = parcelRequire("7f4tk");

const $50b96e14ac428fad$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $50b96e14ac428fad$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
    const url = $50b96e14ac428fad$export$f0b37505cff627e3(projectId, activationId);
    return (0, $7f4tk.default)(url, {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("dsFMC", function(module, exports) {

$parcel$export(module.exports, "deleteCategorySuccess", () => $3c95377777bb5342$export$aa2eaa46022bd60b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3c95377777bb5342$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: [
                    ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                ]
            }
        });
    };

});

parcelRegister("aInVL", function(module, exports) {

$parcel$export(module.exports, "publishSuccess", () => $7490ef4194dfdc47$export$a435a3808fe5155f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7490ef4194dfdc47$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            published: true,
            articleId: articleId,
            draftShareId: draftShareId,
            spaceKey: spaceKey
        });
    };

});

parcelRegister("3twc2", function(module, exports) {

$parcel$export(module.exports, "savedSuccess", () => $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            closed: true,
            articleId: articleId,
            draftShareId: draftShareId
        });
    };

});

parcelRegister("klUDT", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $1022d05f23af34ff$export$416ec9f5729de215);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $1d66W = parcelRequire("1d66W");
const $1022d05f23af34ff$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            categoriesData: {
                ...initialState.categoriesData,
                isLoading: true
            }
        });
        try {
            const { categories: categories, categoriesSupported: categoriesSupported } = await (0, $1d66W.fetchCategories)(projectId, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    categories: categories,
                    isCategoriesSupported: categoriesSupported,
                    isLoading: false,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: false,
                    error: error
                }
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'onFetchCategoriesFailure',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("1d66W", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $b7d9de4ee333d2ce$export$416ec9f5729de215);

var $7f4tk = parcelRequire("7f4tk");

const $b7d9de4ee333d2ce$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $b7d9de4ee333d2ce$export$416ec9f5729de215 = (projectId, activationId)=>{
    const url = $b7d9de4ee333d2ce$export$5cf4b2ebebe43941(projectId, activationId);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("2tTYZ", function(module, exports) {

$parcel$export(module.exports, "fetchCreateArticlePermission", () => $ac71c34762d51de0$export$c5bf032e1fb1ad18);

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $5ukFp = parcelRequire("5ukFp");
const $ac71c34762d51de0$var$EVENT_NAME = 'createPermissionsForSpace';
const $ac71c34762d51de0$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            spacesPermitted: {
                ...initialState.spacesPermitted,
                isLoading: true
            }
        });
        try {
            const { promotedSpaces: promotedSpaces } = await (0, $5ukFp.getCreatePermissionsForSpace)(cloudId, spaceKeys);
            const permittedSpaces = promotedSpaces.spaces.map(// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'text' implicitly has an 'any' type.
            ({ id: id, text: text })=>({
                    spaceKey: id,
                    spaceName: text
                }));
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    data: permittedSpaces,
                    totalSize: promotedSpaces.spaces.length
                }
            });
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${$ac71c34762d51de0$var$EVENT_NAME} succedded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    error: error
                }
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
        }
    };

});
parcelRegister("cVUDi", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsEvents", () => $9d8927ca77b8220f$export$b84e314c48e09c44);
$parcel$export(module.exports, "getPageOnDelete", () => $9d8927ca77b8220f$export$99689dbe56145ad5);
$parcel$export(module.exports, "fireCustomErrorAnalytics", () => $9d8927ca77b8220f$export$3d13cbe76aeaf5e8);
$parcel$export(module.exports, "getViewArticleUrl", () => $9d8927ca77b8220f$export$4b1de73aa951498c);
$parcel$export(module.exports, "getJcsViewArticleUrl", () => $9d8927ca77b8220f$export$adfe9025f8369589);
$parcel$export(module.exports, "getAllDraftsUrl", () => $9d8927ca77b8220f$export$939c0821a1193768);
$parcel$export(module.exports, "getAllArticlesUrl", () => $9d8927ca77b8220f$export$240e98bbb8304c52);
$parcel$export(module.exports, "getAllJcsArticlesUrl", () => $9d8927ca77b8220f$export$35dca3e17444a3e5);
$parcel$export(module.exports, "getFlag", () => $9d8927ca77b8220f$export$a19b74191e00c5e);
$parcel$export(module.exports, "getCommonFlagData", () => $9d8927ca77b8220f$export$f44d45dc3db56277);
$parcel$export(module.exports, "filterSupportedBillingPeriod", () => $9d8927ca77b8220f$export$9f13ed259dc4b1bf);
$parcel$export(module.exports, "formatTrialEndDate", () => $9d8927ca77b8220f$export$da56c66ce2766e02);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");


var $fyKAM = parcelRequire("fyKAM");

const $9d8927ca77b8220f$var$TEAM_NAME = 'jsm-nebula';
const $9d8927ca77b8220f$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $9d8927ca77b8220f$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $9d8927ca77b8220f$export$53ee51427129200c = (statusCode)=>$9d8927ca77b8220f$export$1a5a4674dd906e7e(statusCode) || $9d8927ca77b8220f$export$d31fd506ce75fa65(statusCode);
const $9d8927ca77b8220f$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    if (error && typeof error.statusCode === 'number') {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
        const { statusCode: statusCode } = error;
        const lowPriorityError = statusCode >= 400 && statusCode < 500;
        const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
        const transformedError = error instanceof (0, $jJZqs.default) ? error : new (0, $jJZqs.default)(statusCode);
        const errorObj = {
            error: transformedError,
            meta: {
                id: errorMetaId,
                packageName: packageName,
                teamName: $9d8927ca77b8220f$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        };
        (0, $jcw0u.default)(errorObj);
    } else (0, $jcw0u.default)({
        // Note there should not be a case of circular object for error , if there is it will be handled by fireErrorAnalytics
        error: error instanceof Error ? error : new Error(JSON.stringify(error)),
        meta: {
            id: `${id}__JS_ERROR`,
            packageName: packageName,
            teamName: $9d8927ca77b8220f$var$TEAM_NAME
        },
        ...attributes && {
            attributes: attributes
        }
    });
};
const $9d8927ca77b8220f$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
    const lastPage = Math.ceil(updateDataSize / perPage);
    return currentPage > lastPage ? lastPage : currentPage;
};
const $9d8927ca77b8220f$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
    if (error && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    typeof error.statusCode === 'number' && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    !$9d8927ca77b8220f$export$53ee51427129200c(error.statusCode)) event && (0, $8zOmE.fireOperationalAnalytics)(event, id);
    $9d8927ca77b8220f$export$b84e314c48e09c44(error, id, packageName, attributes);
};
const $9d8927ca77b8220f$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
const $9d8927ca77b8220f$export$adfe9025f8369589 = (projectKey, contentId, spaceKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles/${contentId}?spaceKey=${spaceKey}`;
const $9d8927ca77b8220f$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
const $9d8927ca77b8220f$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
const $9d8927ca77b8220f$export$35dca3e17444a3e5 = (projectKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles`;
const $9d8927ca77b8220f$export$a19b74191e00c5e = (title, description, flagType)=>({
        title: title,
        description: description,
        id: (0, $fyKAM.generateNanoId)(),
        flagType: flagType
    });
const $9d8927ca77b8220f$export$a6125e21263de883 = (state)=>{
    const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
    const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
    const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
    const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
    const isArticleDeleted = Boolean(articleId && deleted);
    return {
        isDraftPublished: isDraftPublished,
        isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
        isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
        isArticleDeleted: isArticleDeleted
    };
};
const $9d8927ca77b8220f$export$f44d45dc3db56277 = (state, messages)=>{
    let flag = {
        id: '',
        title: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        description: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
    };
    const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
    // if confluence get content api fails
    if (showConfluenceCreatePageError) {
        flag = {
            id: 'draftErrorFlag',
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            title: messages.confluenceCreatePageFailureTitle,
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            description: messages.confluenceCreatePageFailureDescription,
            type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
        };
        return flag;
    }
    const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $9d8927ca77b8220f$export$a6125e21263de883(state);
    // case when new article is published --> Article View
    if (isDraftPublished) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when draft is saved with unpublished changes --> Browse All Articles Page
    if (isDraftSavedWithUnpublishedChanges) flag = {
        id: 'draftSavedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'string | MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessSavedFlagDescription || '',
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when older article is saved with unpublished changes --> Article View
    if (isArticleSavedWithUnpublishedChanges) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleSuccessSavedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    // case when article is deleted --> Browse All Articles Page
    if (isArticleDeleted) flag = {
        id: 'articleDeletedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleDeletedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleDeletedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
    };
    return flag;
};
const $9d8927ca77b8220f$export$9f13ed259dc4b1bf = (billingPeriod)=>{
    if (billingPeriod === (0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1)) return 0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1;
    if (billingPeriod === (0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad)) return 0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad;
    return 0, $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4;
};
const $9d8927ca77b8220f$export$da56c66ce2766e02 = (trialEndDate)=>{
    if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
    return null;
};

});
const $3026c2757a468eb7$export$516433e8a6db7503 = 'SUCCESS';
const $3026c2757a468eb7$export$a0a5e05447abb018 = 'WARNING';
const $3026c2757a468eb7$export$f215947b3d76a6b7 = 'ERROR';
const $3026c2757a468eb7$export$21bdd502a5302e06 = 'INFO';

parcelRegister("fyKAM", function(module, exports) {

$parcel$export(module.exports, "generateNanoId", () => $ef446b866ecb6566$export$a4f5444a5996c185);

var $9J4h7 = parcelRequire("9J4h7");
const $ef446b866ecb6566$export$a4f5444a5996c185 = ()=>(0, $9J4h7.nanoid)(12);
const $ef446b866ecb6566$export$e73c8bd0f20705a = ()=>(0, $9J4h7.nanoid)();

});
parcelRegister("9J4h7", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $714ba1f43c1bc4b0$export$ac4959f4f1338dfc);

let $714ba1f43c1bc4b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $714ba1f43c1bc4b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $714ba1f43c1bc4b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$714ba1f43c1bc4b0$export$a5cee9e955a615e5(alphabet, size, $714ba1f43c1bc4b0$export$4385e60b38654f68);
let $714ba1f43c1bc4b0$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--)id += (0, $11cc6b8f5f8db98c$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};

});
const $11cc6b8f5f8db98c$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';




parcelRegister("5ukFp", function(module, exports) {

$parcel$export(module.exports, "getCreatePermissionsForSpace", () => $4d7a1d82dc21430a$export$a4d40fb662e5fd46);
$parcel$export(module.exports, "getLinkedSpaces", () => $4d7a1d82dc21430a$export$b764c9ef97480a8e);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $4d7a1d82dc21430a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
    const queryString = (0, $ebyGx.stringify)({
        promotedSpaceKey: spaceKeys,
        promotedSpacesLimit: spaceKeys.length,
        otherSpacesLimit: 0
    });
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
};
const $4d7a1d82dc21430a$export$b764c9ef97480a8e = (projectKey)=>(0, $7f4tk.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);

});


parcelRegister("ik7FP", function(module, exports) {

$parcel$export(module.exports, "fetchDraftAndNavigateToEditor", () => $76ec8efa1f92f234$export$e8292dc9536b9de8);

var $77CfE = parcelRequire("77CfE");

var $8zOmE = parcelRequire("8zOmE");


var $cVUDi = parcelRequire("cVUDi");

var $gpe3Z = parcelRequire("gpe3Z");

var $1TU0Q = parcelRequire("1TU0Q");
const $76ec8efa1f92f234$var$EVENT_NAME = 'createNewConfluencePage';
const $76ec8efa1f92f234$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName, bodyText: bodyText, isJcs: isJcs, helpCenterId: helpCenterId })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        try {
            setState({
                ...getState(),
                isFetchingDraftDetails: true
            });
            const bodyADFText = (content)=>{
                return {
                    atlas_doc_format: {
                        value: JSON.stringify(JSON.parse(content)),
                        representation: 'atlas_doc_format'
                    }
                };
            };
            const createContentParams = {
                spaceKey: spaceKey,
                parentProductContentContainerId: String(projectId),
                parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
                title: topicName,
                body: bodyText ? bodyADFText(bodyText) : undefined
            };
            const { contentId: contentId, draftShareId: draftShareId } = await (0, $77CfE.createContent)(createContentParams);
            setState({
                ...getState(),
                articleId: contentId,
                draftShareId: draftShareId,
                isFetchingDraftDetails: false
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${$76ec8efa1f92f234$var$EVENT_NAME} succedded`, {
                topicId: topicId,
                articleId: contentId
            });
            dispatch((0, $1TU0Q.setRedirectionData)({
                onCloseRedirectUrl: onCloseRedirectUrl,
                onPublishRedirectUrl: onPublishRedirectUrl
            }));
            dispatch((0, $gpe3Z.navigateCreateDraftRoute)({
                routerActions: routerActions,
                projectKey: projectKey,
                topicId: topicId,
                selectedSpaceKey: spaceKey,
                isJcs: isJcs,
                helpCenterId: helpCenterId
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isFetchingDraftDetails: false,
                showConfluenceCreatePageError: true
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, $76ec8efa1f92f234$var$EVENT_NAME, 'knowledgeCommon');
        }
    };

});
parcelRegister("77CfE", function(module, exports) {

$parcel$export(module.exports, "createContent", () => $bac7f90f30e23006$export$41c7a4cacf5bab80);
/**
 * This function would be used by Embedding product to create Confluence Content. Content created by this function will be tagged with "embedded" flag.
 * At the moment we only support creating a blank page and does not support cross domain request (Parent Product must be in same domain as Confluence)
 * To enable unlicensed user to create a page, parentProduct & parentProductContentContainerId are required.
 */ 
var $jcS9K = parcelRequire("jcS9K");
const $bac7f90f30e23006$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
    'parentProduct',
    'parentProductContentContainerId',
    'spaceKey'
];
const $bac7f90f30e23006$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
const $bac7f90f30e23006$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
    const payload = {
        type: 'page',
        status: 'draft',
        metadata: {
            properties: {
                editor: {
                    value: 'v2'
                }
            },
            frontend: {
                embedded: true
            }
        },
        space: {
            key: spaceKey
        },
        title: title,
        body: body
    };
    if (parentPageId) payload.ancestors = [
        {
            id: parentPageId
        }
    ];
    const baseurl = domain ? `https://${domain}` : domain;
    const unlicensedAccessHeader = $bac7f90f30e23006$var$getUnlicensedAccessHeader({
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    });
    let response;
    try {
        response = await fetch(`${baseurl}/wiki/rest/api/content`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                credentials: 'include',
                ...unlicensedAccessHeader
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // Promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side else resolve
        throw new Error(`Network failure ${e}`);
    }
    const responseJson = await response.json();
    if (!response.ok) throw new (0, $jcS9K.CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
    return {
        draftShareId: $bac7f90f30e23006$var$getDraftShareId(responseJson),
        spaceKey: responseJson?.space?.key,
        contentId: responseJson?.id,
        status: responseJson?.status,
        subType: responseJson?.subType
    };
};
const $bac7f90f30e23006$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
const $bac7f90f30e23006$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
    const headerValue = {
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    };
    const isValidHeader = $bac7f90f30e23006$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$bac7f90f30e23006$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
};

});
parcelRegister("jcS9K", function(module, exports) {

$parcel$export(module.exports, "CreateError", () => $fc26f064cb865ebe$export$91ee1703d5a5ab8b);
class $fc26f064cb865ebe$export$91ee1703d5a5ab8b extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("gpe3Z", function(module, exports) {

$parcel$export(module.exports, "navigateCreateDraftRoute", () => $4f804a011e2794bb$export$4e7c7ad076f5f5fc);

var $4R6GH = parcelRequire("4R6GH");

var $6udl5 = parcelRequire("6udl5");
const $4f804a011e2794bb$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey, topicId: topicId, isJcs: isJcs, helpCenterId: helpCenterId })=>async ({ getState: getState })=>{
        const { articleId: articleId, draftShareId: draftShareId } = {
            ...getState()
        };
        const EDIT_DRAFT_ROUTE = isJcs && (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $6udl5.getJcsDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId, helpCenterId) : (0, $6udl5.getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId);
        routerActions.push(EDIT_DRAFT_ROUTE);
    };

});
parcelRegister("6udl5", function(module, exports) {

$parcel$export(module.exports, "getDraftEditUrl", () => $ed1cffe35d42c3de$export$5e8433ae3ce7c696);
$parcel$export(module.exports, "getJcsDraftEditUrl", () => $ed1cffe35d42c3de$export$cc7720c915c05b63);
$parcel$export(module.exports, "isDraftCreatedWithNCS", () => $ed1cffe35d42c3de$export$fc0fa1dc4749f854);
$parcel$export(module.exports, "findCategory", () => $ed1cffe35d42c3de$export$93e9d221203aed67);

const $ed1cffe35d42c3de$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId)=>{
    let draftEditUrl = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
    if (topicId) draftEditUrl += `&topicId=${topicId}`;
    return draftEditUrl;
};
const $ed1cffe35d42c3de$export$cc7720c915c05b63 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId, helpCenterId)=>{
    let draftEditUrl = `/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles/${articleId}/space/${selectedSpaceKey}/edit?draftShareId=${draftShareId}`;
    if (topicId) draftEditUrl += `&topicId=${topicId}`;
    return draftEditUrl;
};
const $ed1cffe35d42c3de$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $d7e8e0de2b5415e5$export$d42203c46ecda0b5);
const $ed1cffe35d42c3de$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
    if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
    return undefined;
};

});


parcelRegister("1TU0Q", function(module, exports) {

$parcel$export(module.exports, "setRedirectionData", () => $35239289cee1669b$export$c026d4a8850c302d);
$parcel$export(module.exports, "resetRedirectionData", () => $35239289cee1669b$export$7c6d6762f8b5b4db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $35239289cee1669b$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: redirectionData
        });
    };
const $35239289cee1669b$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: {
                onPublishRedirectUrl: '',
                onCloseRedirectUrl: ''
            }
        });
    };

});


parcelRegister("dAXEk", function(module, exports) {

$parcel$export(module.exports, "fetchLinkedSpaces", () => $1976703425aa0479$export$1999596e4ea30c16);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ukFp = parcelRequire("5ukFp");
const $1976703425aa0479$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            linkedSpaces: {
                ...initialState.linkedSpaces,
                isLoading: true
            }
        });
        try {
            const response = await (0, $5ukFp.getLinkedSpaces)(projectKey);
            const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                    spaceKey: spaceKey,
                    spaceName: spaceName
                }));
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    data: linkedSpaces,
                    totalSize: linkedSpaces.length
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    error: error
                }
            });
        }
    };

});

parcelRegister("fMz1O", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedTopics", () => $6568c1fa79c58aad$export$c5eac5039f8d8a0);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $l5XOm = parcelRequire("l5XOm");
const $6568c1fa79c58aad$export$c5eac5039f8d8a0 = (projectId, analyticsEvent, activationId)=>async ({ getState: getState, setState: setState })=>{
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            const response = projectId && await (0, $l5XOm.fetchSuggestedTopics)(projectId, activationId) || null;
            setState({
                ...getState(),
                topics: {
                    data: response && response?.topics || [],
                    loading: false,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'fetchTopics succeeded', {
                projectId: projectId,
                noOfTopics: response?.topics.length
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    data: [],
                    loading: false,
                    error: error
                }
            });
        }
    };

});
parcelRegister("l5XOm", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestedTopics", () => $e690efbbdbde2892$export$c5eac5039f8d8a0);

var $eusud = parcelRequire("eusud");
const $e690efbbdbde2892$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $e690efbbdbde2892$var$getSuggestedTopicsUrl = (projectId, activationId)=>`${$e690efbbdbde2892$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics`;
const $e690efbbdbde2892$export$c5eac5039f8d8a0 = (projectId, activationId)=>{
    const url = $e690efbbdbde2892$var$getSuggestedTopicsUrl(projectId, activationId);
    return (0, $eusud.performGetRequest)(url, {
        method: 'GET'
    });
};

});


parcelRegister("dIiIO", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $c701340a34445280$export$d1eac56717011ed4);

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $8FVnr = parcelRequire("8FVnr");
const $c701340a34445280$var$EVENT_NAME = 'fetchUserCapabilities';
const $c701340a34445280$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            userCapabilities: {
                ...initialState.userCapabilities,
                isLoading: true
            }
        });
        try {
            const data = await (0, $8FVnr.fetchUserCapabilities)(projectId, activationId);
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    data: data,
                    error: null
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${$c701340a34445280$var$EVENT_NAME} succeeded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    error: error
                }
            });
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, `${$c701340a34445280$var$EVENT_NAME} failed`, 'knowledgeCommon');
        }
    };

});
parcelRegister("8FVnr", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $11ef201d32e47a4e$export$d1eac56717011ed4);

var $7f4tk = parcelRequire("7f4tk");

const $11ef201d32e47a4e$export$d1eac56717011ed4 = (projectId, activationId)=>{
    const url = `${(0, $45c806b56a43da0e$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("jIuZj", function(module, exports) {

$parcel$export(module.exports, "removeCommonFlag", () => $3807c62af5ab354f$export$a2af96a4f99f3900);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3807c62af5ab354f$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
        const { flags: currentFlags } = getState();
        const flags = currentFlags.filter(({ id: id })=>id !== flagId);
        setState({
            ...getState(),
            flags: flags
        });
    };

});

parcelRegister("eP4xZ", function(module, exports) {

$parcel$export(module.exports, "reorderCategories", () => $d1c7d54ec7e0876f$export$32f957e287d37daa);

var $ajpes = parcelRequire("ajpes");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $261Bl = parcelRequire("261Bl");

var $1wnS6 = parcelRequire("1wnS6");
const $d1c7d54ec7e0876f$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
    const newCategories = [
        ...categories
    ];
    const movedItem = newCategories.splice(fromIndex, 1)[0];
    if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
    return newCategories;
};
const $d1c7d54ec7e0876f$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
        const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
        const initiallyOrderedCategories = [
            ...getState().categoriesData.categories
        ];
        const newlyOrderedCategories = $d1c7d54ec7e0876f$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: newlyOrderedCategories
            }
        });
        try {
            const { categories: categories } = await (0, $1wnS6.orderCategories)({
                projectId: projectId,
                activationId: activationId,
                categories: [
                    {
                        categoryId: categoryToBeMovedId,
                        order: toIndex
                    }
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                id: (0, $261Bl.categoryGuidToString)(categoryToBeMovedId)
            });
            const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
            const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                // Something about the category information in apollo is different to our store
                // e.g. another user has reordered categories, added a category, deleted a category
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: categories
                    }
                });
                onReorderMismatch();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'reorderCategories',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...initiallyOrderedCategories
                    ]
                }
            });
            onReorderFailure();
        }
    };

});
parcelRegister("261Bl", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $21d0c574129f0705$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $21d0c574129f0705$export$be5c80c4ad1faf99);
const $21d0c574129f0705$export$43162cfd3260b2fe = (guid)=>guid;
const $21d0c574129f0705$export$be5c80c4ad1faf99 = (guid)=>guid;

});

parcelRegister("1wnS6", function(module, exports) {

$parcel$export(module.exports, "orderCategories", () => $56b61b6811b7fda7$export$e90b3dc42a0ddf96);

var $7f4tk = parcelRequire("7f4tk");

const $56b61b6811b7fda7$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
    return (0, $7f4tk.default)(url, {
        method: 'PUT',
        body: JSON.stringify(categories)
    });
};

});


parcelRegister("8QyFO", function(module, exports) {

$parcel$export(module.exports, "resetDraftArticleData", () => $c895191ddea664b2$export$e4dbf2710e8c685d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $c895191ddea664b2$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            draftShareId: '',
            closed: false,
            published: false,
            showConfluenceCreatePageError: false,
            spaceKey: '',
            ...resetDelete && {
                deleted: false,
                articleId: ''
            }
        });
    };

});

parcelRegister("6ThCP", function(module, exports) {

$parcel$export(module.exports, "setPagination", () => $373ed0b89949e59d$export$347aea62317e2398);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $373ed0b89949e59d$export$347aea62317e2398 = (currentPage)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: currentPage
        });
    };

});

parcelRegister("1VmcQ", function(module, exports) {

$parcel$export(module.exports, "updateCategorySuccess", () => $10ef8418d41dbca6$export$7d46e556893bba77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $10ef8418d41dbca6$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
            }
        });
    };

});


parcelRegister("cSB1I", function(module, exports) {

$parcel$export(module.exports, "getDraftShareId", () => $b10361f0e26ced23$export$f31b9480a5e4fdcf);
$parcel$export(module.exports, "getArticleId", () => $b10361f0e26ced23$export$2d21c0faccc1d33f);
$parcel$export(module.exports, "getIsFetchingDraftDetails", () => $b10361f0e26ced23$export$19d926b900e1c065);
$parcel$export(module.exports, "getRedirectionData", () => $b10361f0e26ced23$export$fdde4bb390e025db);
$parcel$export(module.exports, "getPermittedSpaces", () => $b10361f0e26ced23$export$4a419b2d3bb6a3fc);
$parcel$export(module.exports, "getLinkedSpaces", () => $b10361f0e26ced23$export$b764c9ef97480a8e);
$parcel$export(module.exports, "getUserCapabilities", () => $b10361f0e26ced23$export$f7db3ef62579b328);
$parcel$export(module.exports, "getCategoriesData", () => $b10361f0e26ced23$export$b416461ac52d8504);
$parcel$export(module.exports, "getCreateCategoryData", () => $b10361f0e26ced23$export$e0cf4a4b69bbc694);
$parcel$export(module.exports, "getCategory", () => $b10361f0e26ced23$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCommonFlags", () => $b10361f0e26ced23$export$b94d9d28300025a9);
$parcel$export(module.exports, "getKnowledgeCommonFlags", () => $b10361f0e26ced23$export$1a5b9662b382779c);
$parcel$export(module.exports, "getSuggestedTopics", () => $b10361f0e26ced23$export$d95ddf26dc427cbd);
$parcel$export(module.exports, "getPageNumber", () => $b10361f0e26ced23$export$c173ad1c1111eb41);

var $cVUDi = parcelRequire("cVUDi");

var $6udl5 = parcelRequire("6udl5");
const $b10361f0e26ced23$export$c9cab98530df1a79 = ({ published: published })=>published;
const $b10361f0e26ced23$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
const $b10361f0e26ced23$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
const $b10361f0e26ced23$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
const $b10361f0e26ced23$export$fdde4bb390e025db = (state)=>state.redirectionData;
const $b10361f0e26ced23$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
const $b10361f0e26ced23$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
const $b10361f0e26ced23$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
const $b10361f0e26ced23$export$b416461ac52d8504 = (state)=>state.categoriesData;
const $b10361f0e26ced23$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
const $b10361f0e26ced23$export$410364bbb673ddbc = (state, categoryId)=>(0, $6udl5.findCategory)(state.categoriesData, categoryId);
const $b10361f0e26ced23$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
const $b10361f0e26ced23$export$1a5b9662b382779c = (state, messages)=>(0, $cVUDi.getCommonFlagData)({
        ...state
    }, messages);
const $b10361f0e26ced23$export$d95ddf26dc427cbd = (state)=>state.topics;
const $b10361f0e26ced23$export$c173ad1c1111eb41 = (state)=>state.page;

});


parcelRegister("ghVG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $271aace1fac64940$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $bC2fB = parcelRequire("bC2fB");

var $gLt7z = parcelRequire("gLt7z");

var $ealBh = parcelRequire("ealBh");
const $271aace1fac64940$var$mapStateToProps = (state)=>({
        projectKey: (0, $gLt7z.getProjectKey)(state),
        baseUrl: (0, $gLt7z.getBaseUrl)(state)
    });
var $271aace1fac64940$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($271aace1fac64940$var$mapStateToProps, {})((0, $8RXs9.default)((0, $ealBh.default)));

});
parcelRegister("gLt7z", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $5ee05ac4f84233bf$export$f654b28f82155665);
$parcel$export(module.exports, "getLocale", () => $5ee05ac4f84233bf$export$180605366c04f0cd);
$parcel$export(module.exports, "getProjectKey", () => $5ee05ac4f84233bf$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $5ee05ac4f84233bf$export$89040d072f281f85);
$parcel$export(module.exports, "getIsProjectSimplified", () => $5ee05ac4f84233bf$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getIsAdmin", () => $5ee05ac4f84233bf$export$7d046765d192af80);
$parcel$export(module.exports, "getActivationId", () => $5ee05ac4f84233bf$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getCloudId", () => $5ee05ac4f84233bf$export$fdd2c0ba94025c3c);
const $5ee05ac4f84233bf$export$f654b28f82155665 = (_)=>'';
const $5ee05ac4f84233bf$export$180605366c04f0cd = (state)=>state.app.locale;
const $5ee05ac4f84233bf$export$667f2a0f99c75faa = (state)=>state.app.projectKey;
const $5ee05ac4f84233bf$export$89040d072f281f85 = (state)=>state.app.projectId;
const $5ee05ac4f84233bf$export$5bde43fbba6edf90 = (state)=>state.app.isProjectSimplified;
const $5ee05ac4f84233bf$export$7d046765d192af80 = (state)=>state.app.isAdmin;
const $5ee05ac4f84233bf$export$3ad4bb31a1816ff6 = (state)=>state.app.activationId;
const $5ee05ac4f84233bf$export$fdd2c0ba94025c3c = (state)=>state.app.cloudId;

});

parcelRegister("ealBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7526018970629bef$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $jbwMx = parcelRequire("jbwMx");
class $7526018970629bef$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    renderKnowledgeBaseBreadcrumb() {
        const { children: children, baseUrl: baseUrl, projectKey: projectKey, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge`,
                text: formatMessage((0, $jbwMx.default).knowledgeBase),
                type: 'jsd-knowledge-base'
            }
        }, children);
    }
    render() {
        return this.renderKnowledgeBaseBreadcrumb();
    }
}

});
parcelRegister("jbwMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7699cc1a8f21589$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7699cc1a8f21589$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    articlesPageHeader: {
        "id": "servicedesk.knowledge-hub.common.i18n.articles-page-header",
        "defaultMessage": "Articles"
    },
    knowledgeBase: {
        "id": "servicedesk.knowledge-hub.common.i18n.knowledge-base",
        "defaultMessage": "Knowledge base"
    },
    noCategoryText: {
        "id": "servicedesk.knowledge-hub.common.i18n.no-category-text",
        "defaultMessage": "Uncategorized"
    },
    editInConfluence: {
        "id": "servicedesk.knowledge-hub.common.i18n.edit-in-confluence",
        "defaultMessage": "Edit in Confluence"
    }
});

});



parcelRegister("epm3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa860c7f19dc37d$export$2e2bcd8739ae039);

var $ickBu = parcelRequire("ickBu");

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $8Uumt = parcelRequire("8Uumt");

var $3TR0I = parcelRequire("3TR0I");

var $kkd2O = parcelRequire("kkd2O");

var $9tOEo = parcelRequire("9tOEo");

var $jzjy1 = parcelRequire("jzjy1");

var $iQv12 = parcelRequire("iQv12");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $bC2fB = parcelRequire("bC2fB");

var $6z7Gx = parcelRequire("6z7Gx");

var $akqdW = parcelRequire("akqdW");

var $l1emQ = parcelRequire("l1emQ");

var $4R6GH = parcelRequire("4R6GH");

var $koeKL = parcelRequire("koeKL");

var $bzFSU = parcelRequire("bzFSU");

var $acxy1 = parcelRequire("acxy1");

var $b71gk = parcelRequire("b71gk");

var $kb4zh = parcelRequire("kb4zh");

var $7tQej = parcelRequire("7tQej");

var $jcw0u = parcelRequire("jcw0u");

var $kHzxc = parcelRequire("kHzxc");

var $gMZw6 = parcelRequire("gMZw6");

var $goH2j = parcelRequire("goH2j");

var $fCYod = parcelRequire("fCYod");

var $gXg4u = parcelRequire("gXg4u");

var $gLt7z = parcelRequire("gLt7z");

var $fhG9v = parcelRequire("fhG9v");

var $knU3A = parcelRequire("knU3A");

var $k5cJw = parcelRequire("k5cJw");

var $z7Rc8 = parcelRequire("z7Rc8");

var $kpAEt = parcelRequire("kpAEt");

var $9LHpK = parcelRequire("9LHpK");

var $d8ryz = parcelRequire("d8ryz");

var $8VBLT = parcelRequire("8VBLT");

var $15yEh = parcelRequire("15yEh");

var $9QKdY = parcelRequire("9QKdY");

var $82xR8 = parcelRequire("82xR8");


var $l7HvK = parcelRequire("l7HvK");

var $6oq8N = parcelRequire("6oq8N");

var $eyGOx = parcelRequire("eyGOx");
const $9aa860c7f19dc37d$var$KnowledgeHubBrowseAllArticlesChecker = (props)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const container = (0, $bzFSU.useContainerAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const knowledgeBaseSource = (0, $8Uumt.useLazyLoadQuery)((0, $ickBu.default), {
        cloudId: cloudId,
        container: container,
        isEnabled: (0, $4R6GH.fg)('kb-cross-site-enabled') || (0, $4R6GH.fg)('3p-integration-enabled_t5ysh')
    });
    (0, $5uXOq.useEffect)(()=>{
        if (knowledgeBaseSource?.knowledgeBase?.knowledgeBase?.__typename === 'QueryError') (0, $jcw0u.default)({
            meta: {
                id: 'knowledgeHubArticlesTypeChecker',
                packageName: (0, $b078eb7289614d21$export$b8b9d90f9e5bd72b),
                teamName: (0, $b078eb7289614d21$export$d57b6b390e78d90f)
            },
            attributes: {
                message: knowledgeBaseSource.knowledgeBase.knowledgeBase.message
            }
        });
        else if (knowledgeBaseSource?.knowledgeBase?.knowledgeBase?.__typename === 'KnowledgeBaseSources') {
            const sourceType = knowledgeBaseSource.knowledgeBase.knowledgeBase.edge[0]?.node.sourceType;
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'knowledgeHubArticlesTypeChecker succeeded', {
                sourceType: sourceType
            });
        }
    }, [
        knowledgeBaseSource,
        createAnalyticsEvent
    ]);
    if (knowledgeBaseSource?.knowledgeBase?.knowledgeBase?.__typename === 'QueryError' && ((0, $4R6GH.fg)('kb-cross-site-enabled') || (0, $4R6GH.fg)('3p-integration-enabled_t5ysh'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acxy1.default), {
        projectKey: props.projectKey,
        enableHeader: false
    });
    if (knowledgeBaseSource?.knowledgeBase?.knowledgeBase?.__typename === 'KnowledgeBaseSources' && ((0, $4R6GH.fg)('kb-cross-site-enabled') || (0, $4R6GH.fg)('3p-integration-enabled_t5ysh'))) {
        const sourceType = knowledgeBaseSource.knowledgeBase.knowledgeBase.edge[0]?.node.sourceType;
        if (!sourceType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/servicedesk/projects/${props.projectKey}/knowledge/setup`
        });
        if (sourceType === 'CROSS_SITE_CONFLUENCE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akqdW.default), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9QKdY.KnowledgeHubCrossSiteArticles), {
                ...props,
                push: push
            }));
        if ([
            'SHAREPOINT',
            'GOOGLE_DRIVE'
        ].includes(sourceType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82xR8.ThirdPartyNoAccessScreeen), {
            sourceType: sourceType
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akqdW.default), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyGOx.default), {
            ...props,
            push: push
        }));
};
const $9aa860c7f19dc37d$var$KnowledgeHubBrowseAllArticlesWithPush = (props)=>{
    const renderer = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acxy1.default), {
            projectKey: props.projectKey,
            enableHeader: false
        });
    }, [
        props.projectKey
    ]);
    const onError = ()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'knowledgeHubArticlesTypeCheckerQuery',
                packageName: (0, $b078eb7289614d21$export$b8b9d90f9e5bd72b),
                teamName: (0, $b078eb7289614d21$export$d57b6b390e78d90f)
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "knowledgeHubBrowseAllArticles",
        packageName: "jira-servicedesk-knowledge-hub",
        render: renderer,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "knowledgeHubBrowseAllArticles",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9aa860c7f19dc37d$var$KnowledgeHubBrowseAllArticlesChecker, props)));
};
const $9aa860c7f19dc37d$var$withRouterPush = (0, $l1emQ.withRouter)($9aa860c7f19dc37d$var$KnowledgeHubBrowseAllArticlesWithPush);
const $9aa860c7f19dc37d$var$mapStateToPropsFactory = ()=>{
    const spaceKeysFactory = (0, $8QpSo.default)((spaceKey)=>spaceKey ? JSON.parse(spaceKey) : {});
    const articlesPageFactory = (0, $8QpSo.default)((state, articleIds)=>({
            totalSize: (0, $fhG9v.getCategoryTotalSize)(state, 'all-articles'),
            // @ts-expect-error - TS2322 - Type 'Article | GenericError' is not assignable to type 'Article[]'. | TS2345 - Argument of type 'string[] | GenericError' is not assignable to parameter of type 'string[]'.
            articles: (0, $gXg4u.getArticlesByIds)(state, articleIds).reduce(/* eslint-disable-next-line jira/js/no-reduce-accumulator-spread */ (acc, curr)=>curr.error ? acc : [
                    ...acc,
                    curr
                ], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [])
        }));
    return (state, ownProps)=>{
        const page = (0, $6oq8N.default)(ownProps.page, 1);
        const { cursor: cursor } = ownProps;
        const sortBy = ownProps.sortBy ?? '-lastModified';
        const searchQuery = ownProps.searchQuery ? ownProps.searchQuery : '';
        const spaceKeys = spaceKeysFactory(ownProps.spaceKey);
        const articleIds = (0, $fhG9v.getArticleIdsForCategory)(state, 'all-articles', page);
        const activationId = (0, $gLt7z.getActivationId)(state);
        let error;
        let articlesPage;
        if (!articleIds) articlesPage = undefined;
        else if (articleIds.error && !Array.isArray(articleIds)) error = articleIds;
        else // @ts-expect-error - TS2322 - Type 'Article' is not assignable to type 'Article[]'.
        articlesPage = articlesPageFactory(state, articleIds);
        return {
            appLinkOrError: (0, $fCYod.getAppLinkOrError)(state),
            linkedState: (0, $knU3A.getHubLinkedState)(state),
            topics: (0, $8VBLT.getTopics)(state),
            spaceKey: (0, $knU3A.getLinkedConfluenceSpace)(state),
            confluenceUrl: (0, $knU3A.getLinkedConfluenceUrl)(state),
            limit: (0, $fhG9v.getBrowseLimit)(state),
            isLoading: (0, $fhG9v.isBrowseLoading)(state, 'all-articles'),
            categoriesSupported: (0, $fhG9v.isCategoriesSupported)(state, 'all-articles'),
            page: page,
            sortBy: sortBy,
            error: error,
            articlesPage: articlesPage,
            ReadyForUser: $z7Rc8.default,
            activationId: activationId,
            SearchKnowledgeInline: $kpAEt.default,
            ArticlesTable: (0, $l7HvK.default),
            projectId: (0, $gLt7z.getProjectId)(state),
            projectKey: (0, $gLt7z.getProjectKey)(state),
            linkedSpaces: (0, $k5cJw.getLinkedSpaces)(state),
            cursor: cursor,
            searchQuery: searchQuery,
            spaceKeys: spaceKeys,
            prevCursor: (0, $fhG9v.getBrowsePrevCursor)(state, 'all-articles'),
            nextCursor: (0, $fhG9v.getBrowseNextCursor)(state, 'all-articles'),
            isAdmin: (0, $gLt7z.getIsAdmin)(state)
        };
    };
};
var $9aa860c7f19dc37d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
    (0, $jzjy1.AnalyticsSource)('knowledgeBrowseAllArticles', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)),
    (0, $9tOEo.default)({
        attributes: {
            context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    }),
    (0, $3TR0I.default)(),
    (0, $iQv12.default)({
        onCreateArticleHeaderClicked: 'createArticleHeaderLink',
        onCreateArticleEmptyStateClicked: 'createArticleEmptyStateLink'
    }),
    (0, $bC2fB.connect)($9aa860c7f19dc37d$var$mapStateToPropsFactory, {
        onBrowseArticles: (0, $kHzxc.browseKnowledge),
        getSuggestedTopics: (0, $9LHpK.fetchSuggestedTopics),
        onTriggerArticleGenerationForTopics: (0, $d8ryz.triggerArticleGenerationForTopics),
        getAiDraftPreviewContent: (0, $15yEh.fetchAIDraftContent),
        getLinkedSpaces: (0, $goH2j.fetchLinkedSpaces),
        onFetchAppLink: (0, $gMZw6.fetchAppLink)
    })
])($9aa860c7f19dc37d$var$withRouterPush);

});
parcelRegister("ickBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $004d60d6aba7eff2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f829963c827e73ddfbc27c6788940676>>
 * @relayHash e72cea2ac8cb40f73f08d8ae16d4f2bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c3bd9f4a5c012ec5e3c61663d66576fcbb2608ae32decce798a6ac0159b5e111
const $004d60d6aba7eff2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "container"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "container",
            "variableName": "container"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "sourceType"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
            "selections": [
                {
                    "condition": "isEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "KnowledgeBaseQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBase",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "KnowledgeBaseSourceEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edge",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "KnowledgeBaseSource",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "knowledgeBase.knowledgeBase.edge"
                                                }
                                            ],
                                            "type": "KnowledgeBaseSources"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
            "selections": [
                {
                    "condition": "isEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "KnowledgeBaseQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBase",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeBaseSourceEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeBaseSource",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeBaseSources"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c3bd9f4a5c012ec5e3c61663d66576fcbb2608ae32decce798a6ac0159b5e111",
            "metadata": {},
            "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$004d60d6aba7eff2$var$node.hash = "5b37546d5291f5fef61c0f9513ec0455";
var $004d60d6aba7eff2$export$2e2bcd8739ae039 = $004d60d6aba7eff2$var$node;

});

parcelRegister("9tOEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2220d181f8eca1$export$2e2bcd8739ae039);

var $asiGE = parcelRequire("asiGE");

var $i4iBk = parcelRequire("i4iBk");
var /**
 * @deprecated - Just provide the data when firing analytics events.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d2220d181f8eca1$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, $asiGE.default)((0, $i4iBk.default)(payload))(WrappedComponent);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("6z7Gx", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $c0766aa675d05766$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $c0766aa675d05766$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $c0766aa675d05766$export$ebdbd98df5a27905);

var $jcw0u = parcelRequire("jcw0u");

var $a7EYT = parcelRequire("a7EYT");
const $c0766aa675d05766$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $c0766aa675d05766$export$cca3c4e11cb0a5ce = 1000;
const $c0766aa675d05766$export$dc391c7d81907d3a = 4000;
const $c0766aa675d05766$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $a7EYT.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $jcw0u.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $jcw0u.trackFetchErrors)(payload);
};

});
parcelRegister("a7EYT", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $99def0fa5fc488a1$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $99def0fa5fc488a1$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $99def0fa5fc488a1$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $99def0fa5fc488a1$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $99def0fa5fc488a1$export$8ef51cba9d28f819);

var $gccSB = parcelRequire("gccSB");

var $cjFoH = parcelRequire("cjFoH");

var $5HnTq = parcelRequire("5HnTq");


var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, $jJZqs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(response)) this.response = response;
    }
}
const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $99def0fa5fc488a1$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $99def0fa5fc488a1$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $99def0fa5fc488a1$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $99def0fa5fc488a1$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
const $99def0fa5fc488a1$var$processResponse = async (response)=>{
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, $eusud.transformValidationErrorFromServer)(jsonResponse);
        const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
        throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$putOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$postOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$deleteOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);
const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$99def0fa5fc488a1$var$patchOptions,
        ...options
    }).then($99def0fa5fc488a1$var$processResponse);

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;



parcelRegister("akqdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e0f2e289decb82$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5y0F0 = parcelRequire("5y0F0");
var $jDDFr = parcelRequire("jDDFr");
const $32e0f2e289decb82$var$pushWithSpaCompatibleUrl = (push, projectKey)=>(path)=>{
        push(`/jira/servicedesk/projects/${projectKey}${// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        path.charAt(0) === '/' ? `${path}` : `/${path}`}`);
    };
/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */ const $32e0f2e289decb82$var$KnowledgeHubPushProvider = (props)=>{
    const { RouterActions: RouterActions, RouterSubscriber: RouterSubscriber, children: children } = props;
    return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouterActions, null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match?.params?.projectKey ? children({
                push: $32e0f2e289decb82$var$pushWithSpaCompatibleUrl(push, match.params.projectKey)
            }) : children({
                push: undefined
            }))) : children({
        push: undefined
    });
};
$32e0f2e289decb82$var$KnowledgeHubPushProvider.defaultProps = {
    RouterActions: (0, $5y0F0.RouterActions),
    RouterSubscriber: (0, $jDDFr.RouterSubscriber)
};
var $32e0f2e289decb82$export$2e2bcd8739ae039 = $32e0f2e289decb82$var$KnowledgeHubPushProvider;

});

parcelRegister("l1emQ", function(module, exports) {

$parcel$export(module.exports, "withRouter", () => $a6b74978c4f20eda$export$369b6b2b30582e8e);

var $EYDed = parcelRequire("EYDed");

var $1bQGJ = parcelRequire("1bQGJ");
const $a6b74978c4f20eda$export$369b6b2b30582e8e = (WrappedComponent)=>__SPA__ ? (0, $1bQGJ.withRouter)(WrappedComponent) : (0, $EYDed.default)(WrappedComponent);

});
parcelRegister("EYDed", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b2c4bc94d9b7fd$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $flKR9 = parcelRequire("flKR9");
var $07b2c4bc94d9b7fd$export$2e2bcd8739ae039 = (0, $flKR9.default);

});
parcelRegister("flKR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2cd29d7e6963c56$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $bsYC3 = parcelRequire("bsYC3");

var $e0XoQ = parcelRequire("e0XoQ");
var $b2cd29d7e6963c56$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $b2cd29d7e6963c56$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A public higher-order component to access the imperative API
 */ var $b2cd29d7e6963c56$var$withRouter = function withRouter(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = $b2cd29d7e6963c56$var$_objectWithoutProperties(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0XoQ.default), {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, $b2cd29d7e6963c56$var$_extends({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bsYC3)))(C, Component);
};
var $b2cd29d7e6963c56$export$2e2bcd8739ae039 = $b2cd29d7e6963c56$var$withRouter;

});
parcelRegister("bsYC3", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $859153a97cf95ca0$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $859153a97cf95ca0$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $859153a97cf95ca0$var$defineProperty = Object.defineProperty;
var $859153a97cf95ca0$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $859153a97cf95ca0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $859153a97cf95ca0$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $859153a97cf95ca0$var$getPrototypeOf = Object.getPrototypeOf;
var $859153a97cf95ca0$var$objectPrototype = $859153a97cf95ca0$var$getPrototypeOf && $859153a97cf95ca0$var$getPrototypeOf(Object);
function $859153a97cf95ca0$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($859153a97cf95ca0$var$objectPrototype) {
            var inheritedComponent = $859153a97cf95ca0$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $859153a97cf95ca0$var$objectPrototype) $859153a97cf95ca0$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $859153a97cf95ca0$var$getOwnPropertyNames(sourceComponent);
        if ($859153a97cf95ca0$var$getOwnPropertySymbols) keys = keys.concat($859153a97cf95ca0$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$859153a97cf95ca0$var$REACT_STATICS[key] && !$859153a97cf95ca0$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $859153a97cf95ca0$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $859153a97cf95ca0$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $859153a97cf95ca0$var$hoistNonReactStatics;

});

parcelRegister("e0XoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33f2454f0f795a6$export$2e2bcd8739ae039);

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $70VoX = parcelRequire("70VoX");
var $a33f2454f0f795a6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $a33f2454f0f795a6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a33f2454f0f795a6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a33f2454f0f795a6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a33f2454f0f795a6$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $a33f2454f0f795a6$var$Route = function(_React$Component) {
    $a33f2454f0f795a6$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $a33f2454f0f795a6$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a33f2454f0f795a6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $a33f2454f0f795a6$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $a33f2454f0f795a6$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $70VoX.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.render && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$a33f2454f0f795a6$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$a33f2454f0f795a6$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
$a33f2454f0f795a6$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    })
};
$a33f2454f0f795a6$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
};
var $a33f2454f0f795a6$export$2e2bcd8739ae039 = $a33f2454f0f795a6$var$Route;

});
parcelRegister("70VoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b50f39010f1f0a$export$2e2bcd8739ae039);

var $d4Ora = parcelRequire("d4Ora");
var $51b50f39010f1f0a$var$patternCache = {};
var $51b50f39010f1f0a$var$cacheLimit = 10000;
var $51b50f39010f1f0a$var$cacheCount = 0;
var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($d4Ora)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $51b50f39010f1f0a$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;

});
parcelRegister("d4Ora", function(module, exports) {

var $oJ7gO = parcelRequire("oJ7gO");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $9852c5da38ba91d1$var$pathToRegexp;
module.exports.parse = $9852c5da38ba91d1$var$parse;
module.exports.compile = $9852c5da38ba91d1$var$compile;
module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $9852c5da38ba91d1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
    return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $9852c5da38ba91d1$var$compile(str, options) {
    return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($oJ7gO(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $9852c5da38ba91d1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $9852c5da38ba91d1$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
    return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
    return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
        else {
            var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $9852c5da38ba91d1$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("oJ7gO", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});







parcelRegister("bzFSU", function(module, exports) {

$parcel$export(module.exports, "useContainerAri", () => $0787e19ae54403b2$export$fa482684d80284db);

var $5uXOq = parcelRequire("5uXOq");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $gq0sA = parcelRequire("gq0sA");
const $0787e19ae54403b2$export$fa482684d80284db = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext } = pageContextData || {};
    return (0, $5uXOq.useMemo)(()=>{
        return (0, $dXq4S.createAri)({
            cloudId: cloudId,
            resourceId: projectContext?.projectId?.toString() ?? '',
            resourceType: 'project',
            resourceOwner: 'jira'
        });
    }, [
        cloudId,
        projectContext?.projectId
    ]);
};

});
parcelRegister("gq0sA", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $2299d7a4f1092420$export$9c25024bdfe755f7);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");

var $9OXo1 = parcelRequire("9OXo1");

var $dFOAR = parcelRequire("dFOAR");
const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, $dxCvy.projectContextResourceWithCache);
const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $324W5.useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $dFOAR.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $5uXOq.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});



parcelRegister("acxy1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $32f35bbe42ed846d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $basmW = parcelRequire("basmW");

var $9tOEo = parcelRequire("9tOEo");

var $jzjy1 = parcelRequire("jzjy1");


var $bC2fB = parcelRequire("bC2fB");

var $6z7Gx = parcelRequire("6z7Gx");

var $gLt7z = parcelRequire("gLt7z");

var $cQ984 = parcelRequire("cQ984");
var $32f35bbe42ed846d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
    (0, $9tOEo.default)({
        attributes: {
            context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    }),
    (0, $jzjy1.AnalyticsSource)('knowledgeLoadingError', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)),
    (0, $bC2fB.connect)((state)=>({
            projectKey: (0, $gLt7z.getProjectKey)(state)
        }), {})
])((0, $cQ984.default));

});
parcelRegister("cQ984", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be642b2370adff2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cigQb = parcelRequire("cigQb");
var $4KBRy = parcelRequire("4KBRy");

var $hZHze = parcelRequire("hZHze");

var $8RXs9 = parcelRequire("8RXs9");

var $75gFv = parcelRequire("75gFv");

var $13x0I = parcelRequire("13x0I");

var $6geWD = parcelRequire("6geWD");

var $22kKJ = parcelRequire("22kKJ");
function $9be642b2370adff2$export$77ebd69dfb098ae4({ intl: intl, projectKey: projectKey, enableHeader: enableHeader = true }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cigQb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4KBRy.default), null, enableHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default), {
        truncateTitle: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75gFv))),
        header: intl.formatMessage((0, $22kKJ.default).errorTitle),
        description: intl.formatMessage((0, $22kKJ.default).errorBody),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: `/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`
        }, intl.formatMessage((0, $22kKJ.default).errorCta))
    })));
}
var $9be642b2370adff2$export$2e2bcd8739ae039 = (0, $8RXs9.default)($9be642b2370adff2$export$77ebd69dfb098ae4);

});
parcelRegister("cigQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $be71958c43737a5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ggIgZ = parcelRequire("ggIgZ");

var $gUAUI = parcelRequire("gUAUI");

var $4KBRy = parcelRequire("4KBRy");

var $4VG9W = parcelRequire("4VG9W");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $be71958c43737a5a$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $4KBRy.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $ggIgZ.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $ggIgZ.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4VG9W.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gUAUI.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $be71958c43737a5a$export$2e2bcd8739ae039 = $be71958c43737a5a$var$GridWrapper;

});
parcelRegister("ggIgZ", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $fdd4dd9b7cc1a587$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $fdd4dd9b7cc1a587$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $fdd4dd9b7cc1a587$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $fdd4dd9b7cc1a587$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $fdd4dd9b7cc1a587$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $fdd4dd9b7cc1a587$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $fdd4dd9b7cc1a587$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $fdd4dd9b7cc1a587$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $fdd4dd9b7cc1a587$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $fdd4dd9b7cc1a587$export$936829b4511db3e4);
const $fdd4dd9b7cc1a587$var$defaultGridSize = 8;
const $fdd4dd9b7cc1a587$export$74797698e12f8baa = 12;
const $fdd4dd9b7cc1a587$export$b8241a1616ab1b96 = $fdd4dd9b7cc1a587$var$defaultGridSize * 10;
const $fdd4dd9b7cc1a587$export$2a89a65a43bab52d = {
    comfortable: $fdd4dd9b7cc1a587$var$defaultGridSize * 5,
    cosy: $fdd4dd9b7cc1a587$var$defaultGridSize * 2,
    compact: $fdd4dd9b7cc1a587$var$defaultGridSize * 0.5
};
const $fdd4dd9b7cc1a587$export$8ec7372efd74b753 = 'cosy';
const $fdd4dd9b7cc1a587$export$d77f83c3d17a7b8a = 52;
const $fdd4dd9b7cc1a587$export$f8725d21f81f3e01 = 0;
const $fdd4dd9b7cc1a587$export$2303d2bd9eeff99a = 'fixed';
const $fdd4dd9b7cc1a587$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $fdd4dd9b7cc1a587$export$8b7e31f391e6e681 = '--ds-column-span';
const $fdd4dd9b7cc1a587$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gUAUI", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $dfafdfc07e588f65$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");

var $4VG9W = parcelRequire("4VG9W");
function $dfafdfc07e588f65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dfafdfc07e588f65$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $ggIgZ.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $dfafdfc07e588f65$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $ggIgZ.varColumnsNum)}) * ${(0, $ggIgZ.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $dfafdfc07e588f65$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $ggIgZ.varGridSpacing)}))`
});
const $dfafdfc07e588f65$export$ef2184bd89960b14 = ({ layout: layout = (0, $ggIgZ.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $dfafdfc07e588f65$var$gridStyles,
            $dfafdfc07e588f65$var$gridLayoutStyles[layout],
            isNested && $dfafdfc07e588f65$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varGridSpacing)]: `${(0, $ggIgZ.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("4VG9W", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $6da7ed7449613c9c$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $ggIgZ = parcelRequire("ggIgZ");
const $6da7ed7449613c9c$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $ggIgZ.defaultSpacing),
    columns: (0, $ggIgZ.defaultGridColumns)
});

});


parcelRegister("4KBRy", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $da4ea2268815c5f0$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $da4ea2268815c5f0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");

var $4VG9W = parcelRequire("4VG9W");
/**
 * Determines the method by which column width is calculated.
 */ var $da4ea2268815c5f0$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($da4ea2268815c5f0$var$ColumnVariant || {});
const $da4ea2268815c5f0$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $ggIgZ.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $da4ea2268815c5f0$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $da4ea2268815c5f0$var$singleColumnWidth = `(${$da4ea2268815c5f0$var$availableWidth} / var(${(0, $ggIgZ.varColumnsNum)}))`;
const $da4ea2268815c5f0$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$da4ea2268815c5f0$var$singleColumnWidth} - var(${(0, $ggIgZ.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $ggIgZ.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $da4ea2268815c5f0$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$da4ea2268815c5f0$var$singleColumnWidth} *  var(${(0, $ggIgZ.varColumnSpan)}) - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $da4ea2268815c5f0$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $ggIgZ.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $da4ea2268815c5f0$var$GridColumn = ({ medium: medium = (0, $ggIgZ.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $da4ea2268815c5f0$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($da4ea2268815c5f0$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $da4ea2268815c5f0$var$gridColumnStyles,
            $da4ea2268815c5f0$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $da4ea2268815c5f0$export$2e2bcd8739ae039 = $da4ea2268815c5f0$var$GridColumn;

});


parcelRegister("75gFv", function(module, exports) {
module.exports = new URL("error.5b530682.svg", import.meta.url).toString();

});

parcelRegister("13x0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $13dd6aa4f4b38a0c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3s0xG = parcelRequire("3s0xG");

var $gwIPs = parcelRequire("gwIPs");
function $13dd6aa4f4b38a0c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        maxImageWidth: $13dd6aa4f4b38a0c$export$7e3df82ee760448c,
        maxImageHeight: $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a,
        ...props
    }));
}
$13dd6aa4f4b38a0c$export$2e2bcd8739ae039.defaultProps = {
    isLoading: false,
    primaryAction: undefined,
    secondaryAction: undefined,
    tertiaryAction: undefined
};
const $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a = (0, $gwIPs.gridSize) * 20.5;
const $13dd6aa4f4b38a0c$export$7e3df82ee760448c = (0, $gwIPs.gridSize) * 48;
const $13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ik51pl1 _bhl91wug _qci81jje",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6geWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $805b9f255efa1904$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jS4lj = parcelRequire("jS4lj");

var $cS37j = parcelRequire("cS37j");

var $koVbs = parcelRequire("koVbs");

var $jbwMx = parcelRequire("jbwMx");
function $805b9f255efa1904$export$fea23bd0b48d9710(props) {
    const { children: children, description: description, showDefaultTitle: showDefaultTitle, bottomBar: bottomBar, ...restProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        bottomBar: description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($805b9f255efa1904$var$Description, null, description) : bottomBar,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null),
        ...restProps
    }, children || (showDefaultTitle ? formatMessage((0, $jbwMx.default).knowledgeBase) : null));
}
$805b9f255efa1904$export$fea23bd0b48d9710.defaultProps = {
    actions: undefined,
    bottomBar: undefined,
    children: null,
    showDefaultTitle: true,
    description: undefined,
    onBreadcrumbClicked: undefined
};
var $805b9f255efa1904$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $805b9f255efa1904$export$fea23bd0b48d9710;
const $805b9f255efa1904$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkmgjw _1i4q1hna",
            __cmplp.className
        ])
    });
});

});

parcelRegister("22kKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b57b2a353f770dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b57b2a353f770dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-loading-error.error-title",
        "defaultMessage": "Could not load knowledge base"
    },
    errorBody: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-loading-error.error-body",
        "defaultMessage": "Please refresh and try again. If that does not work your link to Confluence might be corrupt, try re-linking it in settings."
    },
    errorCta: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-loading-error.error-cta",
        "defaultMessage": "Go to Settings"
    }
});

});



parcelRegister("kHzxc", function(module, exports) {

$parcel$export(module.exports, "BROWSE_KNOWLEDGE", () => $e17bf0108bb950f1$export$8b6d2338550bad51);
$parcel$export(module.exports, "browseKnowledge", () => $e17bf0108bb950f1$export$66132e21cee3da17);
const $e17bf0108bb950f1$export$8b6d2338550bad51 = 'state.actions.browse-knowledge.BROWSE_KNOWLEDGE';
const $e17bf0108bb950f1$export$66132e21cee3da17 = (payload)=>({
        type: $e17bf0108bb950f1$export$8b6d2338550bad51,
        payload: payload
    });

});

parcelRegister("gMZw6", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINK", () => $ed5b7c76bdf86da2$export$da6ab0fd0c34565f);
$parcel$export(module.exports, "fetchAppLink", () => $ed5b7c76bdf86da2$export$6bb78bb661cf0859);
const $ed5b7c76bdf86da2$export$da6ab0fd0c34565f = 'state.actions.fetch-applink.FETCH_APPLINK';
const $ed5b7c76bdf86da2$export$6bb78bb661cf0859 = ()=>({
        type: $ed5b7c76bdf86da2$export$da6ab0fd0c34565f
    });

});

parcelRegister("goH2j", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => $c793be7dffec599b$export$3d78263a729bb91);
$parcel$export(module.exports, "fetchLinkedSpaces", () => $c793be7dffec599b$export$1999596e4ea30c16);
const $c793be7dffec599b$export$3d78263a729bb91 = 'state.actions.fetch-linked-spaces.FETCH_LINKED_SPACES';
const $c793be7dffec599b$export$1999596e4ea30c16 = (payload)=>({
        type: $c793be7dffec599b$export$3d78263a729bb91,
        payload: payload
    });

});

parcelRegister("fCYod", function(module, exports) {

$parcel$export(module.exports, "getAppLinkState", () => $681898a3e978aa85$export$5017a5295f2c0e75);
$parcel$export(module.exports, "getAppLinkOrError", () => $681898a3e978aa85$export$f313f4d9202e0f4e);
const $681898a3e978aa85$export$5017a5295f2c0e75 = (state)=>state.entities.appLink;
const $681898a3e978aa85$export$7d919ca1f3c09dd = (state)=>state.entities.appLink?.appLink;
const $681898a3e978aa85$export$56510b4953c6542b = (state)=>state.entities.appLink?.isLoaded || false;
const $681898a3e978aa85$export$f313f4d9202e0f4e = (state)=>{
    const { isLoaded: isLoaded, error: error, appLink: appLink } = state.entities.appLink || {};
    if (isLoaded && appLink) return appLink;
    if (error) return {
        error: error
    };
    return undefined;
};

});

parcelRegister("gXg4u", function(module, exports) {

$parcel$export(module.exports, "getFeaturedInCategoryIds", () => $daacc015e0475ec6$export$413b305383a0e001);
$parcel$export(module.exports, "getArticle", () => $daacc015e0475ec6$export$f8c0d0a39b0d7d4e);
$parcel$export(module.exports, "getCategoriesForArticle", () => $daacc015e0475ec6$export$458f158173f65de8);
$parcel$export(module.exports, "getCategoriesForArticleBulkUpdate", () => $daacc015e0475ec6$export$360e12e07ffc1cb0);
$parcel$export(module.exports, "getArticlesByIds", () => $daacc015e0475ec6$export$ba941551d0dc160c);
$parcel$export(module.exports, "getIsShowingBulkCategoryAdder", () => $daacc015e0475ec6$export$483e222b9f194c8a);
$parcel$export(module.exports, "getCategoriesInBulkCategoryAdder", () => $daacc015e0475ec6$export$d1f02a9ddd87bcc6);
$parcel$export(module.exports, "getSpaceKeyForArticle", () => $daacc015e0475ec6$export$ccf898e36d51a9bc);

var $dGvGJ = parcelRequire("dGvGJ");

var $7qDUb = parcelRequire("7qDUb");

var $5fBrW = parcelRequire("5fBrW");
const $daacc015e0475ec6$export$413b305383a0e001 = (state, articleId)=>state.entities.articles[articleId] && // @ts-expect-error - TS2339 - Property 'featuredInCategories' does not exist on type 'ArticleState'.
    state.entities.articles[articleId].featuredInCategories && // @ts-expect-error - TS2339 - Property 'featuredInCategories' does not exist on type 'ArticleState'.
    state.entities.articles[articleId].featuredInCategories;
const $daacc015e0475ec6$var$getArticleCategories = (allCategories, article)=>{
    if (article.categories) {
        const categories = article.categories.map((categoryId)=>allCategories.categories.find((category)=>category.id === categoryId)).filter(Boolean);
        const featuredInCategoryIds = article.featuredInCategories || [];
        if (featuredInCategoryIds.length === 0) return categories;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(categories, (cat)=>!featuredInCategoryIds.includes(cat.id));
    }
    return undefined;
};
const $daacc015e0475ec6$export$f8c0d0a39b0d7d4e = (0, $dGvGJ.createSelector)((state, articleId)=>state.entities.articles[articleId], (state)=>state.entities.categories, (articleOrError, allCategories)=>{
    if (!articleOrError) return undefined;
    if ('error' in articleOrError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return articleOrError;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const article = articleOrError;
    const categories = $daacc015e0475ec6$var$getArticleCategories(allCategories, article);
    const { categories: _, ...articleWithoutCategory } = article;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...articleWithoutCategory,
        categories: categories
    };
});
const $daacc015e0475ec6$var$getUpdatingCategoriesForArticle = (state, articleId)=>state.ui.articles[articleId] && state.ui.articles[articleId].categoryIds && state.ui.articles[articleId].categoryIds.map((id)=>(0, $5fBrW.getCategory)(state, id)).filter(Boolean);
const $daacc015e0475ec6$export$458f158173f65de8 = (state, articleId)=>{
    const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
    if (!article) return [];
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'Article | GenericError'.
    if (article.error) return [];
    // @ts-expect-error - TS2339 - Property 'categories' does not exist on type 'Article | GenericError'.
    return article.categories || [];
};
const $daacc015e0475ec6$export$360e12e07ffc1cb0 = (state, articleId)=>{
    const updatingCategories = $daacc015e0475ec6$var$getUpdatingCategoriesForArticle(state, articleId);
    // if there are updating categories value, we will use the updating state so it will
    // always reflect the latest categories for article
    if (updatingCategories) return updatingCategories;
    // retrieve from persisted state if there is no updating value available
    return $daacc015e0475ec6$export$458f158173f65de8(state, articleId);
};
const $daacc015e0475ec6$export$ba941551d0dc160c = (state, articleIds)=>articleIds.map((articleId)=>$daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId)).filter(Boolean);
const $daacc015e0475ec6$export$483e222b9f194c8a = (state, articleId)=>state.ui.articles[articleId] && !!state.ui.articles[articleId].isShowingBulkCategoryAdder;
const $daacc015e0475ec6$export$d1f02a9ddd87bcc6 = (state, articleId)=>{
    if (!state.ui.articles[articleId]) return [];
    return state.ui.articles[articleId].categoriesInBulkCategoryAdder || [];
};
const $daacc015e0475ec6$export$ccf898e36d51a9bc = (state, articleId)=>{
    const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
    if (!article) return '';
    // @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'Article | GenericError'.
    if (article.spaceKey) // @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'Article | GenericError'.
    return article.spaceKey;
    return '';
};

});
parcelRegister("5fBrW", function(module, exports) {

$parcel$export(module.exports, "getCategory", () => $45a4a0df582a0d3a$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCategoryName", () => $45a4a0df582a0d3a$export$67267455149572c9);
$parcel$export(module.exports, "getAllCategories", () => $45a4a0df582a0d3a$export$36bfd9279b3a24b7);
const $45a4a0df582a0d3a$export$410364bbb673ddbc = (state, id)=>state.entities.categories.categories.find((category)=>category.id === id);
const $45a4a0df582a0d3a$export$67267455149572c9 = (state, id)=>{
    const category = $45a4a0df582a0d3a$export$410364bbb673ddbc(state, id);
    if (category) return category.name;
    return undefined;
};
const $45a4a0df582a0d3a$export$36bfd9279b3a24b7 = (state)=>state.entities.categories.categories;

});


parcelRegister("fhG9v", function(module, exports) {

$parcel$export(module.exports, "getArticleIdsForCategory", () => $da36dd250036e782$export$bb874ade4016b878);
$parcel$export(module.exports, "getCategoryTotalSize", () => $da36dd250036e782$export$165fede49970bd0c);
$parcel$export(module.exports, "getBrowseLimit", () => $da36dd250036e782$export$adc0ce73adb3dc4a);
$parcel$export(module.exports, "getBrowseNextCursor", () => $da36dd250036e782$export$4b2e4efe9c0df2cd);
$parcel$export(module.exports, "getBrowsePrevCursor", () => $da36dd250036e782$export$f7e999777526d95e);
$parcel$export(module.exports, "isCategoriesSupported", () => $da36dd250036e782$export$cfb809beeaa82062);
$parcel$export(module.exports, "isBrowseLoading", () => $da36dd250036e782$export$aecf0fb6e785d5e0);
$parcel$export(module.exports, "getArticlesLoading", () => $da36dd250036e782$export$327a4e3439ce6c6a);
const $da36dd250036e782$export$bb874ade4016b878 = (state, categoryId, page = 1)=>state.entities.browse[categoryId] ? state.entities.browse[categoryId].pages[`${page}`] : undefined;
const $da36dd250036e782$export$165fede49970bd0c = (state, categoryId)=>state.entities.browse[categoryId].totalSize;
const $da36dd250036e782$export$adc0ce73adb3dc4a = (state)=>state.entities.browse.limit;
const $da36dd250036e782$export$4b2e4efe9c0df2cd = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].nextCursor ?? '' : '';
const $da36dd250036e782$export$f7e999777526d95e = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].prevCursor ?? '' : '';
const $da36dd250036e782$export$cfb809beeaa82062 = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].categoriesSupported ?? true : true;
const $da36dd250036e782$export$aecf0fb6e785d5e0 = (state, categoryId)=>state.entities.browse[categoryId] === undefined;
const $da36dd250036e782$export$327a4e3439ce6c6a = (state)=>!!state.entities.browse.loading;

});

parcelRegister("knU3A", function(module, exports) {

$parcel$export(module.exports, "getHubLinkedState", () => $13b0808aee851dca$export$9b336974117966dd);
$parcel$export(module.exports, "getLinkedConfluenceUrl", () => $13b0808aee851dca$export$fea8defd3093e8e3);
$parcel$export(module.exports, "getLinkedConfluenceSpace", () => $13b0808aee851dca$export$6c88aaaf8fc8b7f1);
const $13b0808aee851dca$export$9b336974117966dd = (state)=>state.entities.hub.linkedState;
const $13b0808aee851dca$export$fea8defd3093e8e3 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.confluenceUrl : undefined;
const $13b0808aee851dca$export$6c88aaaf8fc8b7f1 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.spaceKey : undefined;

});

parcelRegister("k5cJw", function(module, exports) {

$parcel$export(module.exports, "getLinkedSpaces", () => $3fcb02b524b089b3$export$b764c9ef97480a8e);
const $3fcb02b524b089b3$export$b764c9ef97480a8e = (state)=>state.entities.spaces?.linkedSpaces.data ?? [];

});

parcelRegister("z7Rc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fded4bd8c6152b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $bC2fB = parcelRequire("bC2fB");

var $gLt7z = parcelRequire("gLt7z");

var $l0ai2 = parcelRequire("l0ai2");
const $59fded4bd8c6152b$var$mapStateToProps = (state)=>({
        baseUrl: (0, $gLt7z.getBaseUrl)(state)
    });
const $59fded4bd8c6152b$var$ConnectedReadyForUser = (0, $bC2fB.connect)($59fded4bd8c6152b$var$mapStateToProps, {})((0, $l0ai2.default));
var $59fded4bd8c6152b$export$2e2bcd8739ae039 = $59fded4bd8c6152b$var$ConnectedReadyForUser;

});
parcelRegister("l0ai2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aadd6b14b3dca3c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8PRuf = parcelRequire("8PRuf");

var $3TpKp = parcelRequire("3TpKp");
const $0aadd6b14b3dca3c$var$ConnectedReadyForUser = ({ metricKey: metricKey, metric: metric })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), {
        metricKey: metricKey,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark)
        ],
        appName: "servicedesk.knowledge.hub",
        metric: metric
    });
var $0aadd6b14b3dca3c$export$2e2bcd8739ae039 = $0aadd6b14b3dca3c$var$ConnectedReadyForUser;

});
parcelRegister("3TpKp", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $bbb7386cf97044f2$export$c4ba40c380ee9a11);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");
const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), args);
$bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $eyWK5 = parcelRequire("eyWK5");

var $307qF = parcelRequire("307qF");

var $32M8E = parcelRequire("32M8E");

var $iLrcb = parcelRequire("iLrcb");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $iLrcb.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $307qF.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $32M8E.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("307qF", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $60b371e0a217cca9$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $60b371e0a217cca9$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $60b371e0a217cca9$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $60b371e0a217cca9$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $60b371e0a217cca9$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $aatTc.default));
    const interactionId = (0, $32M8E.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $60b371e0a217cca9$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $32M8E.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timingsConfig);
        (0, $lAOer.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $bl6ih = parcelRequire("bl6ih");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $bl6ih.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $aatTc.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $iLrcb = parcelRequire("iLrcb");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $iLrcb.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $iLrcb.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $aatTc.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $lAOer.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $iLrcb = parcelRequire("iLrcb");
var $kYARE = parcelRequire("kYARE");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $iLrcb.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $kYARE.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $lAOer.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $32M8E = parcelRequire("32M8E");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});





parcelRegister("kpAEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e382948a1087984$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $9tOEo = parcelRequire("9tOEo");

var $jzjy1 = parcelRequire("jzjy1");


var $bC2fB = parcelRequire("bC2fB");

var $6z7Gx = parcelRequire("6z7Gx");

var $gLt7z = parcelRequire("gLt7z");

var $6XOVk = parcelRequire("6XOVk");
var $2e382948a1087984$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSource)('knowledgeInlineSearch', (0, $4d5e0871c06cee03$export$cae2783c9279926)), (0, $9tOEo.default)({
    attributes: {
        context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
    }
}), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $bC2fB.connect)((state)=>({
        projectId: (0, $gLt7z.getProjectId)(state),
        activationId: (0, $gLt7z.getActivationId)(state)
    }), {}))((0, $6XOVk.default));

});
parcelRegister("6XOVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb028f0fac9a044$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hZHze = parcelRequire("hZHze");

var $h5R5L = parcelRequire("h5R5L");

var $8eHQf = parcelRequire("8eHQf");
class $beb028f0fac9a044$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            searchScreenPath: ''
        };
    }
    render() {
        const { transitionToSearchPage: transitionToSearchPage, ...state } = this.state;
        const { searchScreenPath: searchScreenPath, projectId: projectId, SearchKnowledge: SearchKnowledge, SearchResultComponent: SearchResultComponent, placeholder: placeholder, activationId: activationId } = this.props;
        const searchScreenRedirectUrl = searchScreenPath ? `${searchScreenPath}?q=${state.value}` : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, transitionToSearchPage && searchScreenRedirectUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5R5L.default), {
            to: searchScreenRedirectUrl,
            push: true
        }), state.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8eHQf.default), {
            ...state,
            projectId: projectId,
            onChange: this.onChange,
            onFieldSearchFocus: this.onOpen,
            onClose: this.onClose,
            onSubmit: this.onSubmit,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            searchScreenRedirectUrl: searchScreenRedirectUrl,
            SearchResultComponent: SearchResultComponent,
            SearchKnowledge: SearchKnowledge,
            placeholder: placeholder,
            activationId: activationId
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            value: '',
            isOpen: false,
            transitionToSearchPage: false
        }, this.onChange = (value)=>this.setState({
                value: value
            }), this.onOpen = ()=>this.setState({
                isOpen: true
            }), this.onClose = ()=>this.setState({
                isOpen: false
            }), this.onSubmit = ()=>this.setState({
                transitionToSearchPage: true
            });
    }
}

});
parcelRegister("h5R5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $1afb69c0012e46a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eWMrk = parcelRequire("eWMrk");

var $7tQej = parcelRequire("7tQej");
var $jDDFr = parcelRequire("jDDFr");
const $1afb69c0012e46a4$var$ServicedeskSpaRedirect = (props)=>{
    const { RouterSubscriber: RouterSubscriber, to: to, push: push } = props;
    const path = to.charAt(0) === '/' ? to : `/${to}`;
    return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match && match.params && match.params.projectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            push: push,
            to: `/jira/servicedesk/projects/${match.params.projectKey}${path}`
        }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWMrk.default), {
        to: to,
        push: push
    });
};
$1afb69c0012e46a4$var$ServicedeskSpaRedirect.defaultProps = {
    push: false,
    RouterSubscriber: (0, $jDDFr.RouterSubscriber)
};
var $1afb69c0012e46a4$export$2e2bcd8739ae039 = $1afb69c0012e46a4$var$ServicedeskSpaRedirect;

});
parcelRegister("eWMrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1c0e9472109838$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $7vfpQ = parcelRequire("7vfpQ");
var $ae1c0e9472109838$export$2e2bcd8739ae039 = (0, $7vfpQ.default);

});
parcelRegister("7vfpQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $576762e7df8b2249$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $7bpAK = parcelRequire("7bpAK");

var $8RxWw = parcelRequire("8RxWw");
var $576762e7df8b2249$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $576762e7df8b2249$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $576762e7df8b2249$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $576762e7df8b2249$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */ var $576762e7df8b2249$var$Redirect = function(_React$Component) {
    $576762e7df8b2249$var$_inherits(Redirect, _React$Component);
    function Redirect() {
        $576762e7df8b2249$var$_classCallCheck(this, Redirect);
        return $576762e7df8b2249$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Redirect.prototype.isStatic = function isStatic() {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Redirect> outside a <Router>");
        if (this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidMount = function componentDidMount() {
        if (!this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevTo = (0, $7bpAK.createLocation)(prevProps.to);
        var nextTo = (0, $7bpAK.createLocation)(this.props.to);
        if ((0, $7bpAK.locationsAreEqual)(prevTo, nextTo)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
            return;
        }
        this.perform();
    };
    Redirect.prototype.computeTo = function computeTo(_ref) {
        var computedMatch = _ref.computedMatch, to = _ref.to;
        if (computedMatch) {
            if (typeof to === "string") return (0, $8RxWw.default)(to, computedMatch.params);
            else return $576762e7df8b2249$var$_extends({}, to, {
                pathname: (0, $8RxWw.default)(to.pathname, computedMatch.params)
            });
        }
        return to;
    };
    Redirect.prototype.perform = function perform() {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) history.push(to);
        else history.replace(to);
    };
    Redirect.prototype.render = function render() {
        return null;
    };
    return Redirect;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$576762e7df8b2249$var$Redirect.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    ]).isRequired
};
$576762e7df8b2249$var$Redirect.defaultProps = {
    push: false
};
$576762e7df8b2249$var$Redirect.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired
        }).isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    }).isRequired
};
var $576762e7df8b2249$export$2e2bcd8739ae039 = $576762e7df8b2249$var$Redirect;

});
parcelRegister("8RxWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $673d9a4f97fe136d$export$2e2bcd8739ae039);

var $d4Ora = parcelRequire("d4Ora");
var $673d9a4f97fe136d$var$patternCache = {};
var $673d9a4f97fe136d$var$cacheLimit = 10000;
var $673d9a4f97fe136d$var$cacheCount = 0;
var $673d9a4f97fe136d$var$compileGenerator = function compileGenerator(pattern) {
    var cacheKey = pattern;
    var cache = $673d9a4f97fe136d$var$patternCache[cacheKey] || ($673d9a4f97fe136d$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var compiledGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($d4Ora))).compile(pattern);
    if ($673d9a4f97fe136d$var$cacheCount < $673d9a4f97fe136d$var$cacheLimit) {
        cache[pattern] = compiledGenerator;
        $673d9a4f97fe136d$var$cacheCount++;
    }
    return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */ var $673d9a4f97fe136d$var$generatePath = function generatePath() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (pattern === "/") return pattern;
    var generator = $673d9a4f97fe136d$var$compileGenerator(pattern);
    return generator(params, {
        pretty: true
    });
};
var $673d9a4f97fe136d$export$2e2bcd8739ae039 = $673d9a4f97fe136d$var$generatePath;

});




parcelRegister("8eHQf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a229f676f8882ed$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4QlcP = parcelRequire("4QlcP");

var $6eFvr = parcelRequire("6eFvr");

var $eHJxW = parcelRequire("eHJxW");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $2xSAL = parcelRequire("2xSAL");

var $iDMMZ = parcelRequire("iDMMZ");

var $5QGsG = parcelRequire("5QGsG");
class $4a229f676f8882ed$export$cd3c7d9047f30827 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            value: ''
        };
    }
    render() {
        const { value: value, SearchKnowledge: SearchKnowledge, onChange: onChange, placeholder: placeholder, onSubmit: onSubmit, intl: intl, isOpen: isOpen, onFieldSearchFocus: onFieldSearchFocus, onClose: onClose, searchScreenRedirectUrl: searchScreenRedirectUrl, SearchResultComponent: _, activationId: activationId, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$InlineDialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            isOpen: !!value && isOpen,
            onClose: onClose,
            messageId: "servicedesk-knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.inline-dialog",
            messageType: "transactional",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchKnowledge, {
                ...props,
                limit: 3,
                value: value,
                renderResult: this.renderResult,
                activationId: activationId ?? '',
                successCtaComponent: searchScreenRedirectUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$LinkToSearchPage, {
                    to: searchScreenRedirectUrl
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $5QGsG.default).searchAllArticlesCta,
                    values: {
                        term: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                            as: "strong"
                        }, value)
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QlcP))), {
                    spacing: "spacious",
                    label: intl.formatMessage((0, $5QGsG.default).searchIconLabel)
                })) : null
            }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            isAlwaysExpanded: true,
            onEnter: onSubmit,
            onFocus: onFieldSearchFocus,
            value: value,
            onChange: onChange,
            placeholder: placeholder,
            shouldFitContainerWidth: true,
            isAutocompleteDisabled: true
        }))));
    }
    constructor(...args){
        super(...args), this.renderResult = (article)=>{
            const { SearchResultComponent: SearchResultComponent } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchResultComponent, {
                id: article.id,
                title: article.titleExcerpt || '',
                description: article.summaryExcerpt || '',
                categories: article.categories,
                lineClamp: 2
            });
        };
    }
}
var $4a229f676f8882ed$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($4a229f676f8882ed$export$cd3c7d9047f30827);
const $4a229f676f8882ed$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbnklw _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a229f676f8882ed$var$FieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a229f676f8882ed$var$InlineDialogContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a229f676f8882ed$var$LinkToSearchPage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $iDMMZ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1fff _vchhusvi _1e0c1txw _1bah1yb4 _4cvr1h6o _19pkpxbi _2hwx10v4 _otyrmgjw _18u010v4 _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb _syaz1fxt _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $55tuP = parcelRequire("55tuP");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55tuP.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $55tuP = parcelRequire("55tuP");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $55tuP.default), 'isOpen', 'content');

});


parcelRegister("iDMMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8906b3331e8371f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS0Qm = parcelRequire("cS0Qm");

var $hjSul = parcelRequire("hjSul");
var $jDDFr = parcelRequire("jDDFr");
const $8906b3331e8371f5$var$KnowledgeHubSpaLink = (props)=>{
    const { RouterSubscriber: RouterSubscriber, to: to, children: children, innerRef: innerRef, style: style, replace: replace } = props;
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const path = to.charAt(0) === '/' ? to : `/${to}`;
    return __SPA__ ? // @ts-expect-error - TS2604 - JSX element type 'RouterSubscriber' does not have any construct or call signatures.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match && match.params && match.params.projectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            href: `/jira/servicedesk/projects/${match.params.projectKey}${path}`,
            replace: replace
        }, children || null) : null) : // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS0Qm.default), {
        to: to,
        innerRef: innerRef,
        style: style,
        replace: replace
    }, children);
};
$8906b3331e8371f5$var$KnowledgeHubSpaLink.defaultProps = {
    RouterSubscriber: (0, $jDDFr.RouterSubscriber)
};
var $8906b3331e8371f5$export$2e2bcd8739ae039 = $8906b3331e8371f5$var$KnowledgeHubSpaLink;

});
parcelRegister("cS0Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $95eb2eaf9d2a8414$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $aE1Lc = parcelRequire("aE1Lc");

var $7bpAK = parcelRequire("7bpAK");
var $95eb2eaf9d2a8414$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $95eb2eaf9d2a8414$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $95eb2eaf9d2a8414$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95eb2eaf9d2a8414$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95eb2eaf9d2a8414$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $95eb2eaf9d2a8414$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $95eb2eaf9d2a8414$var$Link = function(_React$Component) {
    $95eb2eaf9d2a8414$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $95eb2eaf9d2a8414$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95eb2eaf9d2a8414$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$95eb2eaf9d2a8414$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $95eb2eaf9d2a8414$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $95eb2eaf9d2a8414$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $7bpAK.createLocation)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", $95eb2eaf9d2a8414$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$95eb2eaf9d2a8414$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
    ])
};
$95eb2eaf9d2a8414$var$Link.defaultProps = {
    replace: false
};
$95eb2eaf9d2a8414$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired
        }).isRequired
    }).isRequired
};
var $95eb2eaf9d2a8414$export$2e2bcd8739ae039 = $95eb2eaf9d2a8414$var$Link;

});


parcelRegister("5QGsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a65d1ad7406dbd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81a65d1ad7406dbd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchAllArticlesCta: {
        "id": "servicedesk.knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.search-all-articles-cta",
        "defaultMessage": "Search all articles for {term}"
    },
    searchIconLabel: {
        "id": "servicedesk.knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.search-icon-label",
        "defaultMessage": "search icon"
    }
});

});




parcelRegister("9LHpK", function(module, exports) {

$parcel$export(module.exports, "FETCH_SUGGESTED_TOPICS", () => $42a50acb6cd44870$export$6a35d5452bde6081);
$parcel$export(module.exports, "fetchSuggestedTopics", () => $42a50acb6cd44870$export$c5eac5039f8d8a0);
const $42a50acb6cd44870$export$6a35d5452bde6081 = 'state.actions.fetch-suggested-topics.FETCH_SUGGESTED_TOPICS';
const $42a50acb6cd44870$export$c5eac5039f8d8a0 = (payload)=>({
        type: $42a50acb6cd44870$export$6a35d5452bde6081,
        payload: payload
    });

});

parcelRegister("d8ryz", function(module, exports) {

$parcel$export(module.exports, "TRIGGER_ARTICLE_GENERATION_FOR_TOPICS", () => $44e012bd8f17802e$export$28fa39f049e21f01);
$parcel$export(module.exports, "triggerArticleGenerationForTopics", () => $44e012bd8f17802e$export$7bd57fc6c7a6dd3d);
const $44e012bd8f17802e$export$28fa39f049e21f01 = 'state.actions.trigger-article-generation-for-topics.TRIGGER_ARTICLE_GENERATION_FOR_TOPICS';
const $44e012bd8f17802e$export$7bd57fc6c7a6dd3d = (payload)=>({
        type: $44e012bd8f17802e$export$28fa39f049e21f01,
        payload: payload
    });

});

parcelRegister("8VBLT", function(module, exports) {

$parcel$export(module.exports, "getTopics", () => $9278caa119fd3937$export$2487e21a8b62a016);
const $9278caa119fd3937$export$2487e21a8b62a016 = (state)=>state.entities.topics?.topics;

});

parcelRegister("15yEh", function(module, exports) {

$parcel$export(module.exports, "FETCH_AI_DRAFT_CONTENT", () => $04e4c720d7f6de71$export$b4a1835d4a993402);
$parcel$export(module.exports, "fetchAIDraftContent", () => $04e4c720d7f6de71$export$992f7a1e2aa7843);
const $04e4c720d7f6de71$export$b4a1835d4a993402 = 'state.actions.fetch-ai-draft-content.FETCH_AI_DRAFT_CONTENT';
const $04e4c720d7f6de71$export$992f7a1e2aa7843 = (payload)=>({
        type: $04e4c720d7f6de71$export$b4a1835d4a993402,
        payload: payload
    });

});

parcelRegister("9QKdY", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubCrossSiteArticles", () => $579b6edc19c2ddc0$export$57d8faee45e05329);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $kb4zh = parcelRequire("kb4zh");

var $b71gk = parcelRequire("b71gk");

var $jcw0u = parcelRequire("jcw0u");

var $acxy1 = parcelRequire("acxy1");



var $b4nKA = parcelRequire("b4nKA");
const $579b6edc19c2ddc0$export$57d8faee45e05329 = (props)=>{
    const renderer = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acxy1.default), {
            projectKey: props.projectKey
        });
    }, [
        props.projectKey
    ]);
    const onError = ()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchCrossSiteSpacesQuery',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b),
                teamName: (0, $b078eb7289614d21$export$d57b6b390e78d90f)
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b),
        id: "KnowledgeHubCrossSiteArticles",
        render: renderer,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "KnowledgeHubCrossSiteArticles",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b4nKA.default), props)));
};

});
const $aaa081f4160162a5$export$b8b9d90f9e5bd72b = 'jiraServiceDeskKnowledgeHub';
const $aaa081f4160162a5$export$1b63ba606d8ecfaa = 'NATIVE_CONFLUENCE';
const $aaa081f4160162a5$export$ce410195c34d61ac = 'SERVER_CONFLUENCE';
const $aaa081f4160162a5$export$2a7e16e321f5b7a0 = 'CROSS_SITE_CONFLUENCE';
const $aaa081f4160162a5$export$bc7192bfce222457 = 'SHAREPOINT';
const $aaa081f4160162a5$export$a9b78a3a2613c33a = 'GOOGLE_DRIVE';

const $b078eb7289614d21$export$b8b9d90f9e5bd72b = 'jiraServicedeskKnowledgeHub';
const $b078eb7289614d21$export$d57b6b390e78d90f = 'JSM nebula';

parcelRegister("b4nKA", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3de334d99e70f9$export$2e2bcd8739ae039);

var $ldRlQ = parcelRequire("ldRlQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6tzHJ = parcelRequire("6tzHJ");

var $htBRZ = parcelRequire("htBRZ");

var $bMFGq = parcelRequire("bMFGq");

var $j7m8K = parcelRequire("j7m8K");
var $7OX7J = parcelRequire("7OX7J");
var $5d9qL = parcelRequire("5d9qL");

var $dGKFs = parcelRequire("dGKFs");

var $8zIDr = parcelRequire("8zIDr");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");

var $3s0xG = parcelRequire("3s0xG");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dAfqg = parcelRequire("dAfqg");

var $2bFEE = parcelRequire("2bFEE");

var $5RVjC = parcelRequire("5RVjC");

var $lnrq2 = parcelRequire("lnrq2");

var $9mT3w = parcelRequire("9mT3w");

var $koeKL = parcelRequire("koeKL");

var $2xSAL = parcelRequire("2xSAL");

var $7Mned = parcelRequire("7Mned");

var $acxy1 = parcelRequire("acxy1");

var $l8ruj = parcelRequire("l8ruj");

var $jcw0u = parcelRequire("jcw0u");

var $6geWD = parcelRequire("6geWD");

var $c9JME = parcelRequire("c9JME");

var $jbwMx = parcelRequire("jbwMx");

var $1ydSB = parcelRequire("1ydSB");

var $hAcT9 = parcelRequire("hAcT9");


var $4gYN1 = parcelRequire("4gYN1");
const $df3de334d99e70f9$var$KnowledgeHubCrossSiteAllArticles = ({ isAdmin: isAdmin, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const triggerText = (0, $5uXOq.useCallback)((spaces)=>{
        const { length: length } = Object.keys(spaces);
        let spaceName = '';
        if (length === 1) {
            const key = Object.keys(spaces)[0];
            spaceName = spaces[key].length > 15 ? `${spaces[key].substring(0, 15)}...` : spaces[key];
        }
        return formatMessage((0, $1ydSB.default).spacesDropdownText, {
            count: length,
            spaceName: spaceName
        });
    }, [
        formatMessage
    ]);
    const [searchQuery, setSearchQuery] = (0, $5uXOq.useState)('');
    const [selectedSpaces, setSelectedSpaces] = (0, $5uXOq.useState)({});
    const [dropdownText, setDropDownText] = (0, $5uXOq.useState)(triggerText(selectedSpaces));
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const container = (0, $5uXOq.useMemo)(()=>{
        return (0, $dXq4S.createAri)({
            cloudId: cloudId,
            resourceId: projectContext?.projectId?.toString() ?? '',
            resourceType: 'project',
            resourceOwner: 'jira'
        });
    }, [
        cloudId,
        projectContext?.projectId
    ]);
    const knowledgeBaseMeta = (0, $8Uumt.useLazyLoadQuery)((0, $ldRlQ.default), {
        cloudId: cloudId,
        container: container
    });
    (0, $5uXOq.useEffect)(()=>{
        if (knowledgeBaseMeta.knowledgeBase?.knowledgeBase?.__typename === 'QueryError') (0, $jcw0u.default)({
            meta: {
                id: 'fetchCrossSiteSpaces',
                packageName: (0, $b078eb7289614d21$export$b8b9d90f9e5bd72b),
                teamName: (0, $b078eb7289614d21$export$d57b6b390e78d90f)
            },
            attributes: {
                message: knowledgeBaseMeta.knowledgeBase.knowledgeBase.message
            }
        });
        else if (knowledgeBaseMeta.knowledgeBase?.knowledgeBase?.__typename === 'KnowledgeBaseSources') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchCrossSiteSpaces succeeded');
    }, [
        createAnalyticsEvent,
        knowledgeBaseMeta.knowledgeBase?.knowledgeBase
    ]);
    const linkedSpaces = (0, $5uXOq.useMemo)(()=>{
        if (knowledgeBaseMeta.knowledgeBase?.knowledgeBase?.__typename !== 'KnowledgeBaseSources') return [];
        return knowledgeBaseMeta.knowledgeBase?.knowledgeBase?.edge.map((knowledgeSource)=>{
            const node = knowledgeSource?.node;
            if (!node) return null;
            return {
                spaceName: node.name,
                id: node.entityReference
            };
        }).filter(Boolean);
    }, [
        knowledgeBaseMeta
    ]);
    const [debouncedCallback] = (0, $jDrwg.default)((newValue)=>{
        setSearchQuery(newValue);
    }, 300);
    const onSearch = (0, $5uXOq.useCallback)((value)=>{
        debouncedCallback(value);
    }, [
        debouncedCallback
    ]);
    (0, $5uXOq.useMemo)(()=>{
        setDropDownText(triggerText(selectedSpaces));
    }, [
        selectedSpaces,
        triggerText
    ]);
    const onSpacesToggled = (0, $5uXOq.useCallback)((e)=>{
        const id = e.currentTarget.id;
        const spaceName = e.currentTarget.textContent;
        if (!spaceName || !id) return;
        setSelectedSpaces((spaces)=>{
            if (id in spaces) {
                const newSpaces = {
                    ...spaces
                };
                delete newSpaces[id];
                return newSpaces;
            }
            return {
                ...spaces,
                [id]: spaceName
            };
        });
    }, []);
    const noSearchResultsComponent = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
            header: formatMessage((0, $1ydSB.default).noArticlesTitleMultipleSpaces),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7Mned)))
        });
    }, [
        formatMessage
    ]);
    const emptyStateComponent = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
            header: formatMessage((0, $1ydSB.default).noArticlesTitle),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hAcT9)))
        });
    }, [
        formatMessage
    ]);
    const DropdownItems = (0, $5uXOq.useMemo)(()=>{
        return linkedSpaces?.map((space, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OX7J.default), {
                key: index,
                id: space.id,
                onClick: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onSpacesToggled,
                isSelected: space.id in selectedSpaces
            }, space.spaceName));
    }, [
        linkedSpaces,
        onSpacesToggled,
        selectedSpaces
    ]);
    const renderBottomBar = (0, $5uXOq.useMemo)(()=>{
        const settingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: (0, $6tzHJ.cx)((0, $3HwlS.getWillShowNav4)() ? $df3de334d99e70f9$var$styles.DescriptionNew : $df3de334d99e70f9$var$styles.DescriptionOld)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            alignBlock: "start",
            spread: "space-between",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "span"
        }, formatMessage((0, $1ydSB.default).welcomeDescriptionCrossSiteArticlesTable)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "p"
        }, formatMessage((0, $1ydSB.default).welcomeDescriptionCrossSiteArticlesTable)), isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            href: settingsUrl
        }, formatMessage((0, $1ydSB.default).welcomeDescriptionCrossSiteArticlesTableLink)) : null), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9mT3w.VirtualServiceAgentTouchpoint), null)));
    }, [
        formatMessage,
        isAdmin,
        projectKey
    ]);
    const renderSearchAndFilterContainer = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: (0, $6tzHJ.cx)((0, $3HwlS.getWillShowNav4)() ? $df3de334d99e70f9$var$styles.SearchContainerNew : $df3de334d99e70f9$var$styles.SearchContainerOld)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: (0, $6tzHJ.cx)($df3de334d99e70f9$var$styles.TextFieldContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            placeholderAlwaysVisible: true,
            shouldFitContainerWidth: true,
            isAlwaysExpanded: true,
            isAutocompleteDisabled: true,
            isCompact: true,
            placeholder: formatMessage((0, $1ydSB.default).searchPlaceholder),
            value: searchQuery,
            onChange: onSearch,
            "aria-describedby": "hintText",
            "aria-label": formatMessage((0, $1ydSB.default).searchLabelText)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "span",
            id: "hintText",
            xcss: (0, $6tzHJ.cx)($df3de334d99e70f9$var$styles.hiddenText)
        }, formatMessage((0, $1ydSB.default).searchArticlesHintText))), linkedSpaces?.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: (0, $6tzHJ.cx)($df3de334d99e70f9$var$styles.DropdownContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default // eslint-disable-next-line jira/react-no-inline-function-prop
        ), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
                    ...props,
                    ref: triggerRef,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($dGKFs)))
                }, dropdownText)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5d9qL.default), {
            id: "spaces-dropdown"
        }, DropdownItems))) : null);
    }, [
        DropdownItems,
        dropdownText,
        formatMessage,
        linkedSpaces?.length,
        onSearch,
        searchQuery
    ]);
    if (knowledgeBaseMeta.knowledgeBase?.knowledgeBase?.__typename === 'QueryError') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acxy1.default), {
        projectKey: projectKey,
        enableHeader: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "knowledge-base-cross-site-articles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
        data: {
            source: `knowledgeBrowseCrossSiteAllArticleSuccess${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bFEE.KbContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: (0, $6tzHJ.cx)($df3de334d99e70f9$var$styles.confluenceUpsellContainerStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnrq2.ConfluenceUpsellMessage), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "knowledge-base-cross-site-articles-headers"
    }, (0, $3HwlS.getWillShowNav4)() ? renderBottomBar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default // @ts-expect-error - TS2769 - No overload matches this call.
    ), {
        truncateTitle: true,
        bottomBar: renderBottomBar
    }, formatMessage((0, $jbwMx.default).articlesPageHeader)), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5RVjC.KnowledgeBaseActionsGroup), null, renderSearchAndFilterContainer()) : renderSearchAndFilterContainer()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4gYN1.KnowledgeBaseHubArticlesTable), {
        searchQuery: searchQuery,
        showSpaceColumn: linkedSpaces.length > 1,
        spaceAriList: Object.keys(selectedSpaces),
        canViewSpaceUrl: true,
        emptyStateComponent: emptyStateComponent,
        noSearchResultsComponent: noSearchResultsComponent,
        projectId: projectContext?.projectId?.toString()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9JME.DraftArticleSuccessFlags), null))));
};
var $df3de334d99e70f9$export$2e2bcd8739ae039 = $df3de334d99e70f9$var$KnowledgeHubCrossSiteAllArticles;
const $df3de334d99e70f9$var$styles = {
    DescriptionOld: "_p12fbxu3",
    DescriptionNew: "_19pkpxbi",
    hiddenText: "_1e0cglyw",
    IconWrapper: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _80omtlke _syaz1gjq _2hwx1b66",
    confluenceUpsellContainerStyles: "_19pk1ejb",
    TextFieldContainer: "_1bsbp3fh _4t3izwfg",
    SearchContainerNew: "_1e0c1txw",
    SearchContainerOld: "_1e0c1txw _19pk1ejb _2hwxidpf _otyrv47k _18u0idpf",
    DropdownContainer: "_ca0qze3t _u5f31b66 _n3tdze3t _19bv1b66 _18u0u2gc"
};

});
parcelRegister("ldRlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d846e2666e3695$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9b738d12a20a1b7fe56cf4b38e86ac1>>
 * @relayHash 17ed6464b32619a274982be7d610369f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ef2b60415898b3aa402166cc7720f109119c31148cac81ede6c004ec20b1ca7
const $52d846e2666e3695$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "container"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "container",
            "variableName": "container"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "entityReference"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewKBSpacesQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "KnowledgeBaseQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeBase",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeBaseSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeBaseSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeBaseSources"
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewKBSpacesQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "KnowledgeBaseQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeBase",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeBaseSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeBaseSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeBaseSources"
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9ef2b60415898b3aa402166cc7720f109119c31148cac81ede6c004ec20b1ca7",
            "metadata": {},
            "name": "viewKBSpacesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52d846e2666e3695$var$node.hash = "0960c1971ae57c2404a0c0edbb506f9e";
var $52d846e2666e3695$export$2e2bcd8739ae039 = $52d846e2666e3695$var$node;

});

parcelRegister("7OX7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b80104715345f5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $8ZVfC = parcelRequire("8ZVfC");

var $7H980 = parcelRequire("7H980");

var $fHpHg = parcelRequire("fHpHg");

var $44rdn = parcelRequire("44rdn");

var $fS6hq = parcelRequire("fS6hq");

var $9uB2U = parcelRequire("9uB2U");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $2b80104715345f5a$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $bKnKN.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $fS6hq.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $9uB2U.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44rdn.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            ...(0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest,
            children: children
        })
    });
};
var $2b80104715345f5a$export$2e2bcd8739ae039 = $2b80104715345f5a$var$DropdownItemCheckbox;

});
parcelRegister("44rdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e1dd72d8bd99c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2SY35 = parcelRequire("2SY35");

var $fHpHg = parcelRequire("fHpHg");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $62e1dd72d8bd99c2$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        stroke: checked ? `var(--ds-border-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$d6447c357493214f})`,
                        x: "5.5",
                        y: "5.5",
                        width: "13",
                        height: "13",
                        rx: "1.5",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        fill: "currentColor",
                        x: "6",
                        y: "6",
                        width: "12",
                        height: "12",
                        rx: "2",
                        stroke: checked ? `var(--ds-border-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
                        fill: "inherit"
                    })
                ]
            })
        })
    });
};
var $62e1dd72d8bd99c2$export$2e2bcd8739ae039 = $62e1dd72d8bd99c2$var$CheckboxIcon;

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';


parcelRegister("fS6hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a6dc48124b2988$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2gxZP = parcelRequire("2gxZP");

var $7eFf2 = parcelRequire("7eFf2");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $89a6dc48124b2988$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, $7eFf2.SelectionStoreContext));
    const groupId = (0, $5uXOq.useContext)((0, $2gxZP.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $89a6dc48124b2988$export$2e2bcd8739ae039 = $89a6dc48124b2988$var$useCheckboxState;

});
parcelRegister("2gxZP", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $619eda3d5e4db696$export$baf37c4be89255b8);

var $5uXOq = parcelRequire("5uXOq");
const $619eda3d5e4db696$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5uXOq.createContext)('');

});



parcelRegister("5d9qL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45bbfbfac32ec8c8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $70rf1 = parcelRequire("70rf1");

var $c320O = parcelRequire("c320O");

var $2gxZP = parcelRequire("2gxZP");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $45bbfbfac32ec8c8$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $jJsBW.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2gxZP.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $70rf1.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c320O.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $45bbfbfac32ec8c8$export$2e2bcd8739ae039 = $45bbfbfac32ec8c8$var$DropdownItemCheckboxGroup;

});

parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("2bFEE", function(module, exports) {

$parcel$export(module.exports, "KbContentContainer", () => $50c210293a065a94$export$e934deb0c7d071e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $76Pt6 = parcelRequire("76Pt6");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $50c210293a065a94$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $76Pt6.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ylp _n3tdidpf _19bv1ylp _c71ln9zg _1tkevzbd _18m91wug",
            __cmplp.className
        ])
    });
});
const $50c210293a065a94$export$e934deb0c7d071e3 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $50c210293a065a94$var$ContentContainer, (0, $76Pt6.default));

});
parcelRegister("76Pt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e8f5c76234b0565$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e8f5c76234b0565$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1kx0 _n3tdxy5q",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5RVjC", function(module, exports) {

$parcel$export(module.exports, "KnowledgeBaseActionsGroup", () => $7a0c98ae5ac88dec$export$dfa8c27f632e3d83);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7a0c98ae5ac88dec$export$dfa8c27f632e3d83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1bah1yb4 _19pkpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lnrq2", function(module, exports) {

$parcel$export(module.exports, "ConfluenceUpsellMessage", () => $088998d382619c87$export$ca7f6480275ab29d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $088998d382619c87$export$e1d31e559621e077 = (0, $b7Svb.lazy)(()=>(parcelRequire("dtmN6")).then((module)=>module.ConfluenceUpsellMessage), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/knowledge-common/src/ui/confluence-upsell-message/main.tsx"
});
const $088998d382619c87$export$ca7f6480275ab29d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-jsm-kb-confluence-upsell-message",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($088998d382619c87$export$e1d31e559621e077, props));

});
parcelRegister("dtmN6", function(module, exports) {

let $9cefa9985a15a8e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9cefa9985a15a8e2$var$load("8DfwA").then(()=>parcelRequire('lxp3d'));

});


parcelRegister("9mT3w", function(module, exports) {

$parcel$export(module.exports, "VirtualServiceAgentTouchpoint", () => $81c1873e0374ece9$export$a75e853598bb1971);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $ao2h1 = parcelRequire("ao2h1");

var $coVHe = parcelRequire("coVHe");

var $jEJ7g = parcelRequire("jEJ7g");

var $b4PzF = parcelRequire("b4PzF");

var $dAfqg = parcelRequire("dAfqg");

var $i5IHp = parcelRequire("i5IHp");
const $81c1873e0374ece9$export$a75e853598bb1971 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(project?.projectType);
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $coVHe.virtualAgentKnowledgebaseTouchpointResource));
    if (isJCS || (0, $b4PzF.isFedRamp)() || queryReference == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
        sourceName: "servicedeskVirtualAgentKnowledgeBaseTouchpoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "virtualAgentKnowledgeBaseTouchpoint",
        packageName: "servicedeskVirtualAgentKnowledgeBaseTouchpoint",
        fallback: "unmount",
        teamName: "jsd-flux-capacitors"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "virtual-agent-knowledge-base-touchpoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5IHp.VirtualServiceAgentCtaCard), {
        queryReference: queryReference
    }))));
};

});
parcelRegister("i5IHp", function(module, exports) {

$parcel$export(module.exports, "VirtualServiceAgentCtaCard", () => $05e34a0117a08fc6$export$34c5c186bf6183a9);

var $9vLVd = parcelRequire("9vLVd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWfiu = parcelRequire("bWfiu");

var $8zIDr = parcelRequire("8zIDr");

var $eOat1 = parcelRequire("eOat1");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $37XBA = parcelRequire("37XBA");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $bmKPg = parcelRequire("bmKPg");

var $9NQQx = parcelRequire("9NQQx");
const $05e34a0117a08fc6$export$34c5c186bf6183a9 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const data = (0, $8Uumt.usePreloadedQuery)((0, $9vLVd.default), queryReference);
    const numberOfArticles = data.jira?.jiraProjectByKey?.knowledgeBaseArticlesCount.count ?? 0;
    const vaFeaturesAreNotCorrectlyConfigured = data.virtualAgent?.virtualAgentEntitlements?.isVirtualAgentAvailable === false || data.virtualAgent?.virtualAgentEntitlements?.isAiEnabledInAdminHub === false && (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent');
    const isVACreated = data.jira?.jiraProjectByKey?.virtualAgentConfiguration?.__typename === 'VirtualAgentConfiguration';
    const isVirtualAgentEnabled = data.jira?.jiraProjectByKey?.isVirtualAgentEnabled;
    const renderCta = (0, $5uXOq.useMemo)(()=>{
        if (isVirtualAgentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            onClick: (_, analyticsEvent)=>{
                // https://data-portal.internal.atlassian.com/analytics/registry/74456
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'kbVirtualAgentTouchpointCta', {
                    actionType: 'manage'
                });
            },
            target: "_blank",
            href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent`
        }, formatMessage((0, $9NQQx.default).manageCta));
        if (isVACreated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            onClick: (_, analyticsEvent)=>{
                // https://data-portal.internal.atlassian.com/analytics/registry/74456
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'kbVirtualAgentTouchpointCta', {
                    actionType: 'turnOnAiAnswers'
                });
            },
            target: "_blank",
            href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent/ai-answers`
        }, formatMessage((0, $9NQQx.default).turnOnAiAnswersCta));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            onClick: (_, analyticsEvent)=>{
                // https://data-portal.internal.atlassian.com/analytics/registry/74456
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'kbVirtualAgentTouchpointCta', {
                    actionType: 'setupVSA'
                });
            },
            target: "_blank",
            href: `/jira/servicedesk/projects/${projectKey}/settings/virtual-agent`
        }, formatMessage((0, $9NQQx.default).turnOnVsaCta));
    }, [
        formatMessage,
        isVACreated,
        isVirtualAgentEnabled,
        projectKey
    ]);
    if (numberOfArticles < 10 || vaFeaturesAreNotCorrectlyConfigured) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        padding: "space.200",
        xcss: $05e34a0117a08fc6$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37XBA.AiIcon), {
        size: "medium",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall"
    }, formatMessage((0, $9NQQx.default).cardTitle)), isVirtualAgentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "success"
    }, formatMessage((0, $9NQQx.default).activeLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), null, formatMessage((0, $9NQQx.default).inactiveLabel))), !isVirtualAgentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $9NQQx.default).cardDescription)), renderCta), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $05e34a0117a08fc6$var$cardContainerStyles = (0, $2s57o.xcss)({
    minWidth: '300px',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width'
});

});
parcelRegister("9vLVd", function(module, exports) {

$parcel$export(module.exports, "default", () => $891afdf26b9a74fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2f347b6f86114c24b369b99a5ac19f5>>
 * @relayHash 6846c2b353d52935ffcd97c0c83888da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813

var $eiowN = parcelRequire("eiowN");
const $891afdf26b9a74fa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "checkForAiEnabledFF"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
        }
    ], v5 = [
        v3 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "count"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isVirtualAgentEnabled"
    }, v9 = {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
            {
                "args": v5 /*: any*/ ,
                "concreteType": "VirtualAgentFeatures",
                "kind": "LinkedField",
                "name": "virtualAgentEntitlements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isVirtualAgentAvailable"
                    },
                    {
                        "condition": "checkForAiEnabledFF",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isAiEnabledInAdminHub"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainVirtualServiceAgentCtaCardQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "knowledgeBaseArticlesCount",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.knowledgeBaseArticlesCount.count"
                                                    }
                                                ],
                                                "type": "KnowledgeBaseArticleCountSource"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey.knowledgeBaseArticlesCount"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                v9 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainVirtualServiceAgentCtaCardQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v11 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                },
                v9 /*: any*/ 
            ]
        },
        "params": {
            "id": "dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813",
            "metadata": {},
            "name": "mainVirtualServiceAgentCtaCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$891afdf26b9a74fa$var$node.hash = "9989db7de5f26bbca549027d2509feb6";
(0, $eiowN.PreloadableQueryRegistry).set($891afdf26b9a74fa$var$node.params.id, $891afdf26b9a74fa$var$node);
var $891afdf26b9a74fa$export$2e2bcd8739ae039 = $891afdf26b9a74fa$var$node;

});

parcelRegister("37XBA", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $1a27254ae9bfd82b$export$762da6f7f5ace732);

var $5uXOq = parcelRequire("5uXOq");

var $2SY35 = parcelRequire("2SY35");
const $1a27254ae9bfd82b$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled) {
        iconAccentBlueB200 = "var(--ds-text-subtlest, #626F86)";
        textAccentBlueB400 = "var(--ds-text-subtlest, #626F86)";
    } else if (props.isDisabled) {
        iconAccentBlueB200 = "var(--ds-icon-accent-gray, #758195)";
        textAccentBlueB400 = "var(--ds-text-accent-gray, #44546F)";
    } else {
        iconAccentBlueB200 = "var(--ds-icon-accent-blue, #1D7AFC)";
        textAccentBlueB400 = "var(--ds-text-accent-blue, #0055CC)";
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2SY35.default), {
        ...props,
        testId: "atlassian-intelligence.common.ui.ai-icon.svg-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});

parcelRegister("9NQQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5949b8c6e9264df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e5949b8c6e9264df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cardTitle: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.title.nonFinal",
        "defaultMessage": "Virtual service agent"
    },
    inactiveLabel: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.inactive.nonFinal",
        "defaultMessage": "Inactive"
    },
    activeLabel: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.active.nonFinal",
        "defaultMessage": "Active"
    },
    cardDescription: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.description.nonFinal",
        "defaultMessage": "Use your knowledge base and AI to respond to customer questions."
    },
    turnOnAiAnswersCta: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.cta.inactive.nonFinal",
        "defaultMessage": "Turn on AI Answers"
    },
    turnOnVsaCta: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.cta.turnOnVsa.nonFinal",
        "defaultMessage": "Turn on Virtual Service Agent"
    },
    manageCta: {
        "id": "servicedesk.knowledge-hub.virtual-service-agent-cta-card.cta.active.nonFinal",
        "defaultMessage": "Manage"
    }
});

});



parcelRegister("7Mned", function(module, exports) {
module.exports = new URL("no-search-results.6374065e.svg", import.meta.url).toString();

});

parcelRegister("c9JME", function(module, exports) {

$parcel$export(module.exports, "DraftArticleSuccessFlags", () => $e2abc86780787baa$export$a396c03fd23667ef);

var $5uXOq = parcelRequire("5uXOq");

var $9UIxp = parcelRequire("9UIxp");

var $rzE3E = parcelRequire("rzE3E");

var $6hrB4 = parcelRequire("6hrB4");
const $e2abc86780787baa$export$a396c03fd23667ef = ()=>{
    const [kbCommonflags, resetDraftArticleData] = (0, $9UIxp.useKnowledgeCommonFlagHook)((0, $6hrB4.default));
    const onDismissed = ()=>{
        resetDraftArticleData(true);
    };
    // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(id: string | number) => Promise<undefined> | undefined'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $rzE3E.KbFlags), {
        flags: kbCommonflags,
        onDismissed: onDismissed
    });
};

});
parcelRegister("9UIxp", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeCommonFlagHook", () => $68535e79aa4458dd$export$71a682bd55aae872);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lw2HC = parcelRequire("lw2HC");
const $68535e79aa4458dd$export$71a682bd55aae872 = (messages)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ id: id, type: type, title: title, description: description }, { resetDraftArticleData: resetDraftArticleData }] = (0, $lw2HC.useFlagData)(messages);
    const knowledgeCommonflags = id ? [
        {
            description: typeof description === 'string' ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), description),
            flagType: type,
            id: id,
            title: formatMessage(title)
        }
    ] : [];
    return [
        knowledgeCommonflags,
        resetDraftArticleData
    ];
};

});

parcelRegister("rzE3E", function(module, exports) {

$parcel$export(module.exports, "KbFlags", () => $a0b6ad285d45eb5a$export$3934d8be12f752d2);

var $5uXOq = parcelRequire("5uXOq");

var $gM4B1 = parcelRequire("gM4B1");

var $5E93O = parcelRequire("5E93O");

var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

const $a0b6ad285d45eb5a$export$3934d8be12f752d2 = ({ flags: flags, onDismissed: onDismissed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
        onDismissed: (id)=>{
            onDismissed(id);
        }
    }, flags.map(({ flagType: flagType, title: title, description: description, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
            id: id,
            icon: flagType && flagType === (0, $3026c2757a468eb7$export$516433e8a6db7503) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gM4B1))), {
                label: "Success",
                color: "var(--ds-icon-success, #22A06B)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                label: "Error",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            key: id,
            title: title,
            description: description,
            messageId: "servicedesk-knowledge-common.ui.kb-flags.auto-dismiss-flag",
            messageType: "transactional"
        })));
var $a0b6ad285d45eb5a$export$2e2bcd8739ae039 = $a0b6ad285d45eb5a$export$3934d8be12f752d2;

});
parcelRegister("f2BYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3780c7e328dbb70e$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, $3KRpp.FlagGroup);

});


parcelRegister("6hrB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $218f2273ae394fb2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$218f2273ae394fb2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    draftSuccessFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-title",
        "defaultMessage": "Article published"
    },
    draftSuccessFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-description",
        "defaultMessage": "This article has been added to your knowledge base. Your articles list will update soon."
    },
    draftSuccessSavedFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-title",
        "defaultMessage": "Draft saved"
    },
    draftSuccessSavedFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-description",
        "defaultMessage": "Find it in Drafts in your knowledge base."
    },
    articleSuccessSavedFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-title",
        "defaultMessage": "We\u2019ve saved your unpublished changes"
    },
    articleSuccessSavedFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-description",
        "defaultMessage": "You can edit the article and publish these changes later."
    },
    confluenceCreatePageFailureTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-title",
        "defaultMessage": "We're having trouble creating the article"
    },
    confluenceCreatePageFailureDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-description",
        "defaultMessage": "Wait for a few minutes and try creating the article again."
    },
    articleDeletedFlagTitle: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-title",
        "defaultMessage": "Article deleted"
    },
    articleDeletedFlagDescription: {
        "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-description",
        "defaultMessage": "This article has been deleted from your knowledge base. Your articles list will update soon."
    }
});

});


parcelRegister("1ydSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d11ba66aa3b5efd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9d11ba66aa3b5efd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createArticleCta: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.create-article-cta",
        "defaultMessage": "Create article"
    },
    noArticlesTitleMultipleSpaces: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-title-multiple-spaces",
        "defaultMessage": "We couldn't find an article matching your search"
    },
    noArticlesTitle: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-title",
        "defaultMessage": "There are no articles in your knowledge base"
    },
    noArticlesDescription: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-description",
        "defaultMessage": "Articles can help your help seekers find the solutions they're looking for."
    },
    noArticlesDescriptionMultipleSpaces: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-description-multiple-spaces",
        "defaultMessage": "Consider {creating} a new one"
    },
    creatingArticleDescription: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.creating-article-description",
        "defaultMessage": "creating"
    },
    noArticlesCta: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-cta",
        "defaultMessage": "Create article"
    },
    welcomeDescription: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description",
        "defaultMessage": "Create articles in knowledge base spaces to share information with your team and to let customers self-serve."
    },
    welcomeDescriptionNew: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-new",
        "defaultMessage": "Create articles in knowledge base spaces to share information with your team and to let customers self-serve."
    },
    welcomeDescriptionCrossSiteArticlesTable: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-cross-site-articles-table",
        "defaultMessage": "View articles from Confluence spaces that your admin has linked to this project. "
    },
    welcomeDescriptionCrossSiteArticlesTableLink: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-cross-site-articles-table-link",
        "defaultMessage": "Manage knowledge sources"
    },
    welcomeDescriptionAdmins: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-admins",
        "defaultMessage": "Manage your spaces and permissions in {linkText}"
    },
    viewAll: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.view-all",
        "defaultMessage": "View all"
    },
    welcomeDescriptionAdminsLink: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-admins-link",
        "defaultMessage": "knowledge base settings"
    },
    welcomeDescriptionNoCategories: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-no-categories",
        "defaultMessage": "Share solutions to problems with your customers and team by adding articles to your knowledge base."
    },
    inlineSearchPlaceholder: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.inline-search-placeholder",
        "defaultMessage": "Search all articles"
    },
    searchPlaceholder: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-placeholder",
        "defaultMessage": "Search"
    },
    topicSubtitle: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.topic-subtitle",
        "defaultMessage": "Based on {workItemCount} related {workItemCount, plural, one {work item} other {work items}}"
    },
    suggestedTopicsTitle: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.suggested-topics-title",
        "defaultMessage": "Suggested topics"
    },
    spacesDropdownText: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.spaces-dropdown-text",
        "defaultMessage": "{count, plural, =0 {Spaces} one {{spaceName}} other {Multiple (# spaces)}}"
    },
    searchLabelText: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-label-text",
        "defaultMessage": "Search for articles"
    },
    searchArticlesHintText: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-articles-hint-text",
        "defaultMessage": "The table below will get updated as you type characters in the field."
    },
    noArticlesFound: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-found",
        "defaultMessage": "No articles found"
    }
});

});

parcelRegister("hAcT9", function(module, exports) {
module.exports = new URL("create-articles.766910dd.svg", import.meta.url).toString();

});

parcelRegister("4gYN1", function(module, exports) {

$parcel$export(module.exports, "KnowledgeBaseHubArticlesTable", () => $95b66f17674ede06$export$97df7bae3388bbf5);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $b71gk = parcelRequire("b71gk");

var $kb4zh = parcelRequire("kb4zh");

var $acxy1 = parcelRequire("acxy1");

var $jcw0u = parcelRequire("jcw0u");



var $1Dmr7 = parcelRequire("1Dmr7");
const $95b66f17674ede06$export$97df7bae3388bbf5 = (props)=>{
    const renderer = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acxy1.default), {
            projectKey: props.projectId,
            enableHeader: false
        });
    }, [
        props.projectId
    ]);
    const onError = ()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'kbHubCrossSiteArticlesTableQuery',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b),
                teamName: (0, $b078eb7289614d21$export$d57b6b390e78d90f)
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "knowledge-hub-cross-site-articles-table",
        packageName: "@atlassian/jira-servicedesk-knowledge-hub",
        render: renderer,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "knowledge-hub-cross-site-articles-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Dmr7.ArticleTable), props)));
};

});
parcelRegister("1Dmr7", function(module, exports) {

$parcel$export(module.exports, "ArticleTable", () => $a8a4708863090dca$export$88e3aff22d73c352);

var $6XEKV = parcelRequire("6XEKV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $acxy1 = parcelRequire("acxy1");

var $l8ruj = parcelRequire("l8ruj");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $jcw0u = parcelRequire("jcw0u");

var $a9Z5f = parcelRequire("a9Z5f");

var $9ZGGr = parcelRequire("9ZGGr");


const $a8a4708863090dca$export$88e3aff22d73c352 = ({ canViewSpaceUrl: canViewSpaceUrl, searchQuery: searchQuery, emptyStateComponent: emptyStateComponent, noSearchResultsComponent: noSearchResultsComponent, spaceAriList: articleContainers, projectId: projectId, showSpaceColumn: showSpaceColumn, limit: limit = 25 })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [sortKey, setSortKey] = (0, $5uXOq.useState)('LAST_MODIFIED');
    const [sortOrder, setSortOrder] = (0, $5uXOq.useState)('DESC');
    const [pageNumber, setPageNumber] = (0, $5uXOq.useState)(1);
    const [cursor, setCursor] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // we must reset cursor whenever search query or space changes.
    (0, $5uXOq.useMemo)(()=>{
        setCursor(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery,
        articleContainers
    ]);
    const searchArticles = (0, $8Uumt.useLazyLoadQuery)((0, $6XEKV.default), {
        searchInput: {
            searchQuery: searchQuery,
            projectId: projectId,
            cloudId: cloudId,
            cursor: cursor,
            articleContainers: articleContainers,
            sortByKey: sortKey,
            sortOrder: sortOrder,
            limit: limit
        }
    }, {
        fetchPolicy: 'network-only' // TODO: Add PageNumber to server schema to cache the data in relay store
    });
    const { pageInfo: pageInfo, nodes: nodes } = (0, $5uXOq.useMemo)(()=>{
        if (searchArticles.knowledgeBase_searchArticles?.__typename === 'KnowledgeBaseCrossSiteSearchConnection') {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchCrossSiteArticles succeeded');
            return {
                pageInfo: searchArticles.knowledgeBase_searchArticles.pageInfo,
                nodes: searchArticles.knowledgeBase_searchArticles.nodes
            };
        }
        return {
            pageInfo: null,
            nodes: []
        };
    }, [
        createAnalyticsEvent,
        searchArticles.knowledgeBase_searchArticles
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (!pageInfo?.hasPreviousPage) setPageNumber(1);
    }, [
        pageInfo
    ]);
    const knowledgePieceData = (0, $5uXOq.useMemo)(()=>{
        return nodes?.map((articleData)=>{
            if (!articleData?.id || !articleData.title || !articleData.lastModified) return null;
            return {
                id: articleData?.id,
                title: articleData?.title,
                url: articleData?.url,
                spaceName: articleData?.spaceName,
                spaceUrl: articleData?.spaceUrl,
                lastModified: articleData?.lastModified
            };
        }).filter(Boolean) ?? [];
    }, [
        nodes
    ]);
    const columns = (0, $5uXOq.useMemo)(()=>{
        return [
            (0, $a9Z5f.createTitleColumnGeneric)((knowledge)=>knowledge?.url ? knowledge.url : '#', 60),
            ...showSpaceColumn ? [
                canViewSpaceUrl ? (0, $a9Z5f.createLinkedSpaceColumnGeneric)(30) : (0, $a9Z5f.createLinkedSpaceColumnWithoutLinkGeneric)(30)
            ] : [],
            (0, $a9Z5f.lastModifiedColumnGeneric)(10)
        ];
    }, [
        canViewSpaceUrl,
        showSpaceColumn
    ]);
    const onSort = (0, $5uXOq.useCallback)((newSortKey, newSortOrder)=>{
        setSortKey(newSortKey);
        setSortOrder(newSortOrder);
    }, []);
    const loadPrevious = (0, $5uXOq.useCallback)(()=>{
        if (pageInfo?.hasPreviousPage && pageInfo?.startCursor) {
            setCursor(pageInfo.startCursor);
            setPageNumber((_page)=>Math.max(0, _page - 1));
        }
    }, [
        pageInfo?.hasPreviousPage,
        pageInfo?.startCursor
    ]);
    const loadNext = (0, $5uXOq.useCallback)(()=>{
        if (pageInfo?.hasNextPage && pageInfo.endCursor) {
            setCursor(pageInfo.endCursor);
            setPageNumber((_page)=>_page + 1);
        }
    }, [
        pageInfo?.endCursor,
        pageInfo?.hasNextPage
    ]);
    if (searchArticles.knowledgeBase_searchArticles?.__typename === 'QueryError') {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchCrossSiteArticles',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b),
                teamName: (0, $b078eb7289614d21$export$d57b6b390e78d90f)
            },
            attributes: {
                message: searchArticles.knowledgeBase_searchArticles.message
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acxy1.default), {
            projectKey: projectId,
            enableHeader: false
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "knowledge-base-hub-table-cross-site"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ZGGr.KnowledgeTableGraphql), {
        columns: columns,
        totalSize: knowledgePieceData.length,
        knowledgePieces: knowledgePieceData,
        limit: limit,
        page: pageNumber,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        onSort: onSort,
        searchQuery: searchQuery,
        sortBy: sortKey,
        sortOrder: sortOrder,
        categoryId: "allArticles",
        emptyStateComponent: emptyStateComponent,
        noSearchResultsComponent: noSearchResultsComponent,
        nextCursor: pageInfo?.endCursor ?? null,
        prevCursor: pageInfo?.startCursor ?? null
    }));
};

});
parcelRegister("6XEKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8274a4dabe77bfa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3dbc1c9c64a9fedc2aa4be05f4838a00>>
 * @relayHash 410af1af4a2f50daba88ef0f632db253
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7fd1dfa367235bcf8a154ab7e8659f2c5171402632af4ba7fc1f3e51acd8e4a2
const $c8274a4dabe77bfa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "searchInput",
                    "variableName": "searchInput"
                }
            ],
            "kind": "LinkedField",
            "name": "knowledgeBase_searchArticles",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "KnowledgeBaseCrossSiteArticle",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "spaceName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "spaceUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "startCursor"
                                }
                            ]
                        }
                    ],
                    "type": "KnowledgeBaseCrossSiteSearchConnection"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ],
                    "type": "QueryError"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewArticlesTableQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewArticlesTableQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "7fd1dfa367235bcf8a154ab7e8659f2c5171402632af4ba7fc1f3e51acd8e4a2",
            "metadata": {},
            "name": "viewArticlesTableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c8274a4dabe77bfa$var$node.hash = "9893167b842c0f154647ea61aba8a01f";
var $c8274a4dabe77bfa$export$2e2bcd8739ae039 = $c8274a4dabe77bfa$var$node;

});

parcelRegister("a9Z5f", function(module, exports) {

$parcel$export(module.exports, "getSortKey", () => $905440847d148168$export$5df81d5bd5f33f5b);
$parcel$export(module.exports, "getSortOrder", () => $905440847d148168$export$c11dbba94a24125);
$parcel$export(module.exports, "getSortBy", () => $905440847d148168$export$c7052c2989e7b681);
$parcel$export(module.exports, "createTitleColumn", () => $905440847d148168$export$9cb3346da99da773);
$parcel$export(module.exports, "viewCountColumn", () => $905440847d148168$export$7e5a90571c828007);
$parcel$export(module.exports, "LeftAlignedText", () => $905440847d148168$export$ec83636695a9ceda);
$parcel$export(module.exports, "lastModifiedColumn", () => $905440847d148168$export$120b13130c77685f);
$parcel$export(module.exports, "createTitleColumnGeneric", () => $905440847d148168$export$3c8cf5ff9e1ad799);
$parcel$export(module.exports, "lastModifiedColumnGeneric", () => $905440847d148168$export$8aa98f162148dee0);
$parcel$export(module.exports, "createLinkedSpaceColumnGeneric", () => $905440847d148168$export$bee95fde9ddb3446);
$parcel$export(module.exports, "createLinkedSpaceColumnWithoutLinkGeneric", () => $905440847d148168$export$4c14461d7dd9c3a8);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5KCCi = parcelRequire("5KCCi");

var $gwIPs = parcelRequire("gwIPs");

var $15rEL = parcelRequire("15rEL");

var $iDMMZ = parcelRequire("iDMMZ");

var $hjSul = parcelRequire("hjSul");

var $9S8wn = parcelRequire("9S8wn");
const $905440847d148168$export$5df81d5bd5f33f5b = (columns, orderBy)=>columns.find((column)=>column.sortKey === orderBy.slice(1))?.key;
const $905440847d148168$export$c11dbba94a24125 = (orderBy)=>orderBy[0] === '-' ? 'DESC' : 'ASC';
const $905440847d148168$export$c7052c2989e7b681 = (columns, key, sortOrder)=>{
    const sortKey = columns.find((column)=>column.key === key)?.sortKey;
    switch(sortKey){
        case 'featured':
            return sortOrder === 'DESC' ? '-featured' : '+featured';
        case 'lastModified':
            return sortOrder === 'DESC' ? '-lastModified' : '+lastModified';
        case 'title':
            return sortOrder === 'DESC' ? '-title' : '+title';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sortKey;
            return '-lastModified';
    }
};
const $905440847d148168$export$9cb3346da99da773 = (getLink)=>({
        key: 'knowledge-title',
        sortKey: 'title',
        header: (intl)=>({
                content: intl.formatMessage((0, $9S8wn.default).titleHeader),
                isSortable: true,
                shouldTruncate: true,
                width: `${$905440847d148168$export$a34a62dd85803a75}px`
            }),
        row: (intl, index, knowledge, context)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$82fa245df990fa4, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDMMZ.default), {
                to: getLink(knowledge, context)
            }, knowledge.title))
    });
const $905440847d148168$export$7e5a90571c828007 = {
    key: 'knowledge-view-count',
    header: (intl)=>({
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, intl.formatMessage((0, $9S8wn.default).viewCountHeader)),
            isSortable: false,
            width: `${$905440847d148168$export$5b3cf88de666fd48}px`
        }),
    row: (intl, index, knowledge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, knowledge.viewCount || 0)
};
const $905440847d148168$export$120b13130c77685f = {
    key: 'knowledge-last-modified',
    sortKey: 'lastModified',
    header: (intl)=>({
            content: intl.formatMessage((0, $9S8wn.default).lastModifiedHeader),
            isSortable: true,
            width: `${$905440847d148168$export$ed5a9a7a6e830e46}px`
        }),
    row: (intl, index, knowledge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            tag: "span",
            content: knowledge.lastModified
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15rEL.FormattedRelativeV2), {
            value: knowledge.lastModified
        })))
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $905440847d148168$export$ec83636695a9ceda = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $905440847d148168$export$82fa245df990fa4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $905440847d148168$export$a34a62dd85803a75 = (0, $gwIPs.gridSize) * 44;
const $905440847d148168$export$5b3cf88de666fd48 = (0, $gwIPs.gridSize) * 8;
const $905440847d148168$export$ed5a9a7a6e830e46 = (0, $gwIPs.gridSize) * 16; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $905440847d148168$export$e8e23fb6af23977 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gnusic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $905440847d148168$export$f7cbd6b7c165c8fb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $905440847d148168$export$3c8cf5ff9e1ad799 = (getLink, width)=>({
        key: 'TITLE',
        sortKey: 'TITLE',
        header: ({ formatMessage: formatMessage })=>({
                width: width,
                content: formatMessage((0, $9S8wn.default).titleHeader),
                isSortable: true,
                shouldTruncate: true
            }),
        row: (_, index, knowledge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$82fa245df990fa4, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                to: getLink(knowledge)
            }, knowledge.title))
    });
const $905440847d148168$export$8aa98f162148dee0 = (width)=>({
        key: 'LAST_MODIFIED',
        sortKey: 'LAST_MODIFIED',
        header: ({ formatMessage: formatMessage })=>({
                width: width,
                content: formatMessage((0, $9S8wn.default).lastModifiedHeader),
                isSortable: true
            }),
        row: (_, index, knowledge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                tag: "span",
                content: knowledge.lastModified,
                testId: "servicedesk.knowledge-hub.common.knowledge-table.knowledge-table-column.tooltip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15rEL.FormattedRelativeV2), {
                value: knowledge.lastModified
            })))
    });
const $905440847d148168$export$bee95fde9ddb3446 = (width)=>{
    return {
        key: 'article-linked-spaces',
        header: ({ formatMessage: formatMessage })=>({
                width: width,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, formatMessage((0, $9S8wn.default).linkedSpacesHeader)),
                isSortable: false
            }),
        row: ({ formatMessage: formatMessage }, index, knowledge)=>{
            const spaceName = knowledge.spaceName || '';
            const spaceUrl = knowledge.spaceUrl || '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: formatMessage((0, $9S8wn.default).tooltipText)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                to: spaceUrl,
                target: "_blank",
                rel: "noopener noreferrer nofollow",
                "data-testid": "servicedesk.knowledge-hub.common.knowledge-table.knowledge-table-column.knowledge-hub-table-space-item"
            }, spaceName)));
        }
    };
};
const $905440847d148168$export$4c14461d7dd9c3a8 = (width)=>{
    return {
        key: 'article-linked-spaces',
        header: ({ formatMessage: formatMessage })=>({
                width: width,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, formatMessage((0, $9S8wn.default).linkedSpacesHeader)),
                isSortable: false
            }),
        row: (_, index, knowledge)=>{
            const spaceName = knowledge.spaceName || '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, spaceName);
        }
    };
};

});
parcelRegister("15rEL", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $dff2faa5ae8b6f27$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $dff2faa5ae8b6f27$export$7317ee2f88fd1276);

var $5uXOq = parcelRequire("5uXOq");

var $j7anB = parcelRequire("j7anB");

var $2tElP = parcelRequire("2tElP");
const $dff2faa5ae8b6f27$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $dff2faa5ae8b6f27$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $j7anB.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $dff2faa5ae8b6f27$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $dff2faa5ae8b6f27$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $dff2faa5ae8b6f27$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tElP.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$dff2faa5ae8b6f27$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});

parcelRegister("9S8wn", function(module, exports) {

$parcel$export(module.exports, "default", () => $de45fdf4efe7e0b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de45fdf4efe7e0b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleHeader: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.title-header",
        "defaultMessage": "Article"
    },
    viewCountHeader: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.view-count-header",
        "defaultMessage": "Views"
    },
    lastModifiedHeader: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.last-modified-header",
        "defaultMessage": "Last updated"
    },
    actionsHeader: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.actions-header",
        "defaultMessage": "Actions"
    },
    paginationPrev: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.pagination-prev",
        "defaultMessage": "Prev"
    },
    paginationNext: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.pagination-next",
        "defaultMessage": "Next"
    },
    linkedSpacesHeader: {
        "id": "servicedesk.knowledge-hub.commin.knowledge-table.linked-spaces-header",
        "defaultMessage": "Space"
    },
    tooltipText: {
        "id": "servicedesk.knowledge-hub.commin.knowledge-table.tooltip-text",
        "defaultMessage": "Opens in new tab"
    },
    paginationLabel: {
        "id": "servicedesk.knowledge-hub.common.knowledge-table.pagination-label",
        "defaultMessage": "Page"
    }
});

});


parcelRegister("9ZGGr", function(module, exports) {

$parcel$export(module.exports, "KnowledgeTableGraphql", () => $4109f37f11051cac$export$4c665211f969c4aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1sXeC = parcelRequire("1sXeC");

var $cTmPi = parcelRequire("cTmPi");

var $PtOw7 = parcelRequire("PtOw7");

var $2Eqc8 = parcelRequire("2Eqc8");

var $koVbs = parcelRequire("koVbs");

var $6yXtV = parcelRequire("6yXtV");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9S8wn = parcelRequire("9S8wn");

var $jZgzD = parcelRequire("jZgzD");
const $4109f37f11051cac$export$4c665211f969c4aa = ({ columns: columns, totalSize: totalSize, knowledgePieces: knowledgePieces, sortBy: sortBy, sortOrder: sortOrder, emptyStateComponent: emptyStateComponent, noSearchResultsComponent: noSearchResultsComponent, searchQuery: searchQuery, prevCursor: prevCursor, nextCursor: nextCursor, page: page, categoryId: categoryId, loadNext: loadNext, loadPrevious: loadPrevious, onSort: onSort })=>{
    const intl = (0, $koVbs.default)();
    const pageNumber = (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(page);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const header = (0, $5uXOq.useMemo)(()=>{
        const headerCells = columns.map((column)=>({
                key: column.key,
                ...column.header(intl)
            }));
        return {
            cells: headerCells
        };
    }, [
        columns,
        intl
    ]);
    const rows = (0, $5uXOq.useMemo)(()=>{
        if (totalSize > 0 && Array.isArray(knowledgePieces)) return knowledgePieces.map((knowledge, index)=>{
            // Use the zero padded index as part of the key, manually correcting when sorted in descending order
            const indexKey = (sortOrder === 'DESC' ? knowledgePieces.length - 1 - index : index).toString().padStart((knowledgePieces.length - 1).toString().length, '0');
            const cells = columns.map((column)=>({
                    // we use a row cell key unique to the piece of knowledge
                    key: `${indexKey}-${column.key}-${knowledge.id}`,
                    content: column.row(intl, index, knowledge)
                }));
            return {
                // we use a row key unique to the piece of knowledge
                key: `knowledge-${knowledge.id}`,
                cells: cells
            };
        });
        return [];
    }, [
        columns,
        intl,
        knowledgePieces,
        sortOrder,
        totalSize
    ]);
    const paginationi18n = (0, $5uXOq.useMemo)(()=>({
            prev: intl.formatMessage((0, $9S8wn.default).paginationPrev),
            next: intl.formatMessage((0, $9S8wn.default).paginationNext),
            label: intl.formatMessage((0, $9S8wn.default).paginationLabel)
        }), [
        intl
    ]);
    const selectedIndex = (0, $jZgzD.getPageSelectedIndex)(nextCursor, prevCursor);
    const pagesArray = [
        prevCursor ? pageNumber - 1 : 0,
        pageNumber,
        nextCursor ? pageNumber + 1 : 0
    ].filter((number)=>number > 0);
    const currentPageNumber = pagesArray[selectedIndex];
    const onPageChange = (event, newPageNumber)=>{
        if (newPageNumber !== currentPageNumber) {
            if (currentPageNumber + 1 === newPageNumber && nextCursor) loadNext?.();
            else if (currentPageNumber - 1 === newPageNumber && prevCursor) loadPrevious?.();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent
    ]);
    const onPageSort = (sort)=>{
        if (typeof sort === 'object' && sort !== null && typeof sort.key === 'string' && typeof sort.sortOrder === 'string') {
            const sortKey = columns.find((column)=>column.key === sort.key)?.sortKey;
            onSort(sortKey, sort.sortOrder);
        }
    };
    const articlePagination = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PtOw7.default), {
            pages: pagesArray,
            onChange: onPageChange,
            selectedIndex: selectedIndex
        }));
    if (totalSize === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkv47k _p4liidpf _owipidpf _6autidpf _1pqwidpf _1ik0udwz _c9d7udwz _1bfwudwz _i7sf1hna _1lkk1hna _1fr8u2gc _1160idpf _lxpru2gc _il49idpf _1he61ejb _hlwa1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTmPi.default), {
        head: header,
        sortKey: sortBy,
        sortOrder: sortOrder,
        paginationi18n: paginationi18n
    }), searchQuery === '' ? emptyStateComponent : noSearchResultsComponent);
    const isPaginated = (nextCursor || prevCursor) && totalSize > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkv47k _p4liidpf _owipidpf _6autidpf _1pqwidpf _1ik0udwz _c9d7udwz _1bfwudwz _i7sf1hna _1lkk1hna _1fr8u2gc _1160idpf _lxpru2gc _il49idpf _1he61ejb _hlwa1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTmPi.default), {
        head: header,
        rows: rows,
        sortKey: sortBy,
        sortOrder: sortOrder,
        onSort: onPageSort,
        isLoading: totalSize < 0,
        paginationi18n: paginationi18n
    }), totalSize >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yXtV.SpaStatePageReadyOnUpdate), {
        comparer: [
            categoryId
        ]
    })), isPaginated && articlePagination());
};
const $4109f37f11051cac$var$TableContainer = null;

});
parcelRegister("cTmPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $42488a711cb2a1a2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $fHpHg = parcelRequire("fHpHg");


var $ij3f3 = parcelRequire("ij3f3");

var $gSzpH = parcelRequire("gSzpH");

var $5Du8N = parcelRequire("5Du8N");

var $aeHUt = parcelRequire("aeHUt");

var $iNWZG = parcelRequire("iNWZG");

var $hp7Nj = parcelRequire("hp7Nj");

var $b2Las = parcelRequire("b2Las");

var $kwDS1 = parcelRequire("kwDS1");

var $2CS2C = parcelRequire("2CS2C");
function $42488a711cb2a1a2$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65:
            return 0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b;
        case 0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b:
            return 0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $42488a711cb2a1a2$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $bKnKN.default), onSort: providedOnSort = (0, $bKnKN.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $bKnKN.default), onRankEnd: providedOnRankEnd = (0, $bKnKN.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: (0, $fHpHg.fg)('eax-1131_fix_a11y_issues_global_issues_settings') ? 'Previous Page' : 'Previous',
    next: (0, $fHpHg.fg)('eax-1131_fix_a11y_issues_global_issues_settings') ? 'Next Page' : 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $ij3f3.validateSortKey)(sortKey, head);
        (0, $ij3f3.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) : $42488a711cb2a1a2$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $ij3f3.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3) : (0, $dd4c19bf39ff9e0d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Du8N.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Du8N.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b2Las.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gSzpH.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSzpH.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2CS2C.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($42488a711cb2a1a2$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSzpH.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwDS1.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hp7Nj.default), {
                isLoading: isLoading,
                spinnerSize: (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $42488a711cb2a1a2$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("d6J9p")));
const $42488a711cb2a1a2$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aeHUt.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iNWZG.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($42488a711cb2a1a2$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$42488a711cb2a1a2$export$2e2bcd8739ae039 = $42488a711cb2a1a2$var$DynamicTable;

});
const $dd4c19bf39ff9e0d$export$1dee026a19752d6b = 'ASC';
const $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65 = 'DESC';
const $dd4c19bf39ff9e0d$export$71dd4c8ecd45e95f = 'small';
const $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3 = 'large';
const $dd4c19bf39ff9e0d$export$3843c586a90b9cbf = 0.22;

parcelRegister("ij3f3", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $998feb1dd684a5f5$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $998feb1dd684a5f5$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $998feb1dd684a5f5$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $998feb1dd684a5f5$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $998feb1dd684a5f5$export$c476bbe5da59992d);
const $998feb1dd684a5f5$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $998feb1dd684a5f5$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $998feb1dd684a5f5$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $998feb1dd684a5f5$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $998feb1dd684a5f5$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $998feb1dd684a5f5$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $998feb1dd684a5f5$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $998feb1dd684a5f5$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("gSzpH", function(module, exports) {

$parcel$export(module.exports, "Table", () => $24d7481443a55849$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $24d7481443a55849$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $24d7481443a55849$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $24d7481443a55849$var$fixedSizeTableStyles = null;
const $24d7481443a55849$var$tableStyles = null;
const $24d7481443a55849$var$bodyBorder = null;
const $24d7481443a55849$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $a7f8c6b391092279$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $24d7481443a55849$var$captionStyles = null;
const $24d7481443a55849$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $24d7481443a55849$var$paginationWrapperStyles = null;
const $24d7481443a55849$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("5Du8N", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $20087acc75665f07$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $20087acc75665f07$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $20087acc75665f07$var$fixedHeightStyles = null;
const $20087acc75665f07$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $20087acc75665f07$var$emptyViewContainerStyles = null;
const $20087acc75665f07$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("aeHUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e36766e70be217$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7BCCl = parcelRequire("7BCCl");

var $cbo5N = parcelRequire("cbo5N");
class $50e36766e70be217$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cbo5N.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $50e36766e70be217$var$Body = (0, $7BCCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($50e36766e70be217$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$50e36766e70be217$export$2e2bcd8739ae039 = $50e36766e70be217$var$Body;

});
parcelRegister("7BCCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b182fe0cf2229d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $ij3f3 = parcelRequire("ij3f3");
const $b3b182fe0cf2229d$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $b3b182fe0cf2229d$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $b3b182fe0cf2229d$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $b3b182fe0cf2229d$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $b3b182fe0cf2229d$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $ij3f3.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $b3b182fe0cf2229d$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $ij3f3.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("cbo5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $216850390cb73ba7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gbw3g = parcelRequire("gbw3g");

var $2U6hb = parcelRequire("2U6hb");
const $216850390cb73ba7$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2U6hb.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $gbw3g.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$216850390cb73ba7$export$2e2bcd8739ae039 = $216850390cb73ba7$var$Row;

});
parcelRegister("gbw3g", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $52ed7867b18d7d2f$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aWmPD = parcelRequire("aWmPD");
const $52ed7867b18d7d2f$var$fixedSizeTruncateStyles = null;
const $52ed7867b18d7d2f$var$overflowTruncateStyles = null;
const $52ed7867b18d7d2f$var$truncationWidthStyles = null;
const $52ed7867b18d7d2f$var$cellStyles = null;
const $52ed7867b18d7d2f$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $aWmPD.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("aWmPD", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $9539443fa733857a$export$5e6497a652ae30b5);
const $9539443fa733857a$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $9539443fa733857a$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$9539443fa733857a$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("2U6hb", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $e1fb566ccb11044c$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e1fb566ccb11044c$var$rowStyles = null;
const $e1fb566ccb11044c$var$rowBackgroundStyles = null;
const $e1fb566ccb11044c$var$rowHighlightedBackgroundStyles = null;
const $e1fb566ccb11044c$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("iNWZG", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $b51c6f453b8bb8d8$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $b51c6f453b8bb8d8$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("hp7Nj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecf9d3bdd3bcf46f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");


var $9jhBP = parcelRequire("9jhBP");
class $ecf9d3bdd3bcf46f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $dd4c19bf39ff9e0d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9jhBP.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jhBP.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jhBP.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("9jhBP", function(module, exports) {

$parcel$export(module.exports, "Container", () => $1e66cab656bc739a$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $1e66cab656bc739a$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $1e66cab656bc739a$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1e66cab656bc739a$export$c335a80381ec61f5 = '--contents-opacity';
const $1e66cab656bc739a$var$containerStyles = null;
const $1e66cab656bc739a$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $1e66cab656bc739a$var$contentsContainerStyles = null;
const $1e66cab656bc739a$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$1e66cab656bc739a$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $1e66cab656bc739a$var$spinnerContainerStyles = null;
const $1e66cab656bc739a$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("b2Las", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5bdf68b643c0b74$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");


var $iEr2L = parcelRequire("iEr2L");
class $d5bdf68b643c0b74$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $dd4c19bf39ff9e0d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $dd4c19bf39ff9e0d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iEr2L.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iEr2L.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iEr2L.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("iEr2L", function(module, exports) {

$parcel$export(module.exports, "Container", () => $c5257b659c462a01$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $c5257b659c462a01$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $c5257b659c462a01$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $c5257b659c462a01$var$containerStyles = null;
const $c5257b659c462a01$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $c5257b659c462a01$var$spinnerBackdropStyles = null;
const $c5257b659c462a01$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $c5257b659c462a01$var$spinnerContainerStyles = null;
const $c5257b659c462a01$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("kwDS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $19a3bebc831e1e20$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $PtOw7 = parcelRequire("PtOw7");
class $19a3bebc831e1e20$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PtOw7.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("PtOw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e10201005ed209$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $8yr9w = parcelRequire("8yr9w");

var $kXQqt = parcelRequire("kXQqt");

var $aCQsl = parcelRequire("aCQsl");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $iJ7Hz = parcelRequire("iJ7Hz");

var $f1QVj = parcelRequire("f1QVj");

var $g8LB7 = parcelRequire("g8LB7");

var $aeBLd = parcelRequire("aeBLd");

var $jyOn7 = parcelRequire("jyOn7");
const $91e10201005ed209$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $91e10201005ed209$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $91e10201005ed209$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($kXQqt))) : (0, (/*@__PURE__*/$parcel$interopDefault($aCQsl)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "span",
        xcss: $91e10201005ed209$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $91e10201005ed209$var$InnerPagination({ components: components = (0, $aeBLd.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $aeBLd.emptyObject), max: max = 7, onChange: onChange = (0, $bKnKN.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $g8LB7.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $8yr9w.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$91e10201005ed209$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
            as: "li",
            xcss: $91e10201005ed209$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f1QVj.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJ7Hz.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($91e10201005ed209$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $91e10201005ed209$var$styles.paginationMenu,
                    children: (0, $jyOn7.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJ7Hz.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($91e10201005ed209$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $91e10201005ed209$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($91e10201005ed209$var$InnerPagination));
var $91e10201005ed209$export$2e2bcd8739ae039 = $91e10201005ed209$var$Pagination;

});
parcelRegister("kXQqt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f431fc1028e06487$var$_react = $f431fc1028e06487$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f431fc1028e06487$var$_chevronLeft = $f431fc1028e06487$var$_interopRequireDefault((parcelRequire("eBgkU")));

var $f431fc1028e06487$var$_chevronLeftLarge = $f431fc1028e06487$var$_interopRequireDefault((parcelRequire("doPom")));
function $f431fc1028e06487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f431fc1028e06487$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $f431fc1028e06487$var$_react.default.createElement($f431fc1028e06487$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $f431fc1028e06487$var$_chevronLeftLarge.default
    }, props));
$f431fc1028e06487$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $f431fc1028e06487$var$_default = module.exports.default = $f431fc1028e06487$var$ChevronLeftIcon;

});
parcelRegister("eBgkU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa11316e1b9a50e5$var$_react = $aa11316e1b9a50e5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aa11316e1b9a50e5$var$_baseNew = $aa11316e1b9a50e5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $aa11316e1b9a50e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa11316e1b9a50e5$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $aa11316e1b9a50e5$var$_react.default.createElement($aa11316e1b9a50e5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$aa11316e1b9a50e5$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $aa11316e1b9a50e5$var$_default = module.exports.default = $aa11316e1b9a50e5$var$ChevronLeftIcon;

});

parcelRegister("doPom", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c156198aff068d9$var$_react = $9c156198aff068d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9c156198aff068d9$var$_chevronLeft = $9c156198aff068d9$var$_interopRequireDefault((parcelRequire("eBgkU")));
function $9c156198aff068d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9c156198aff068d9$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9c156198aff068d9$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $9c156198aff068d9$var$_chevronLeft.default,
        iconType: "utility"
    }));
$9c156198aff068d9$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $9c156198aff068d9$var$_default = module.exports.default = $9c156198aff068d9$var$ChevronLeftLargeIcon;

});


parcelRegister("aCQsl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bc624ae76a75667$var$_react = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7bc624ae76a75667$var$_chevronRight = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("LD2gx")));

var $7bc624ae76a75667$var$_chevronRightLarge = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("asO21")));
function $7bc624ae76a75667$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bc624ae76a75667$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7bc624ae76a75667$var$_react.default.createElement($7bc624ae76a75667$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $7bc624ae76a75667$var$_chevronRightLarge.default
    }, props));
$7bc624ae76a75667$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $7bc624ae76a75667$var$_default = module.exports.default = $7bc624ae76a75667$var$ChevronRightIcon;

});
parcelRegister("asO21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79e3541f2bdfe48d$var$_react = $79e3541f2bdfe48d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $79e3541f2bdfe48d$var$_chevronRight = $79e3541f2bdfe48d$var$_interopRequireDefault((parcelRequire("LD2gx")));
function $79e3541f2bdfe48d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79e3541f2bdfe48d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $79e3541f2bdfe48d$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $79e3541f2bdfe48d$var$_chevronRight.default,
        iconType: "utility"
    }));
$79e3541f2bdfe48d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $79e3541f2bdfe48d$var$_default = module.exports.default = $79e3541f2bdfe48d$var$ChevronRightLargeIcon;

});


parcelRegister("iJ7Hz", function(module, exports) {

$parcel$export(module.exports, "default", () => $68429c818e1bccf1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");
function $68429c818e1bccf1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("f1QVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $57683c779a270b1e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");
function $57683c779a270b1e$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("g8LB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $37065f33cd465684$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");

var $cBCgC = parcelRequire("cBCgC");
const $37065f33cd465684$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $37065f33cd465684$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "li",
        testId: testId,
        xcss: $37065f33cd465684$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k9nuy.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cBCgC.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("aeBLd", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $e96752320d8ebdcb$export$3f860eba1218f8d3);
const $e96752320d8ebdcb$export$3f860eba1218f8d3 = {};

});

parcelRegister("jyOn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed4cd84ee61a68bf$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $ed4cd84ee61a68bf$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $ed4cd84ee61a68bf$export$2e2bcd8739ae039 = $ed4cd84ee61a68bf$var$collapseRange;

});



parcelRegister("2CS2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7743ec6945b03629$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $ij3f3 = parcelRequire("ij3f3");

var $Y6nvS = parcelRequire("Y6nvS");

var $6zHVQ = parcelRequire("6zHVQ");

var $kJnN1 = parcelRequire("kJnN1");

var $jMIMt = parcelRequire("jMIMt");

var $7VUM5 = parcelRequire("7VUM5");
class $7743ec6945b03629$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $ij3f3.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $ij3f3.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $kJnN1.default) : (0, $7VUM5.default);
        const HeadCellComponent = isRankable ? (0, $6zHVQ.default) : (0, $jMIMt.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Y6nvS.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7743ec6945b03629$export$2e2bcd8739ae039 = $7743ec6945b03629$var$TableHead;

});
parcelRegister("Y6nvS", function(module, exports) {

$parcel$export(module.exports, "Head", () => $2025e7fb6aa79e5a$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $2025e7fb6aa79e5a$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");



var $aWmPD = parcelRequire("aWmPD");
const $2025e7fb6aa79e5a$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $2025e7fb6aa79e5a$var$rankingStyles = null;
const $2025e7fb6aa79e5a$var$headStyles = null;
const $2025e7fb6aa79e5a$var$overflowTruncateStyles = null;
const $2025e7fb6aa79e5a$var$truncationWidthStyles = null;
const $2025e7fb6aa79e5a$var$fixedSizeTruncateStyles = null;
const $2025e7fb6aa79e5a$var$cellStyles = null;
const $2025e7fb6aa79e5a$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $2025e7fb6aa79e5a$var$headCellBaseStyles = null;
const $2025e7fb6aa79e5a$var$headCellBaseStylesOld = null;
const $2025e7fb6aa79e5a$var$onClickStyles = null;
const $2025e7fb6aa79e5a$var$baseStyles = null;
const $2025e7fb6aa79e5a$var$ascendingStyles = null;
const $2025e7fb6aa79e5a$var$descendingStyles = null;
const $2025e7fb6aa79e5a$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $aWmPD.getTruncationStyleVars)({
            width: width
        }),
        [$2025e7fb6aa79e5a$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $dd4c19bf39ff9e0d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $fHpHg.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("6zHVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5450d9bbffcc8125$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eYd2T = parcelRequire("eYd2T");

var $ij3f3 = parcelRequire("ij3f3");

var $jMIMt = parcelRequire("jMIMt");
class $5450d9bbffcc8125$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $ij3f3.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jMIMt.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5450d9bbffcc8125$var$RankableTableHeadCell = (0, $eYd2T.default)($5450d9bbffcc8125$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5450d9bbffcc8125$export$2e2bcd8739ae039 = $5450d9bbffcc8125$var$RankableTableHeadCell;

});
parcelRegister("eYd2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $12e90393582023be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $12e90393582023be$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jMIMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03bb1c9491f1dae$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $egUrW = parcelRequire("egUrW");

var $2VhaU = parcelRequire("2VhaU");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $7rJgC = parcelRequire("7rJgC");
var $k9nuy = parcelRequire("k9nuy");

var $5KCCi = parcelRequire("5KCCi");


var $Y6nvS = parcelRequire("Y6nvS");
const $b03bb1c9491f1dae$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $b03bb1c9491f1dae$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $b03bb1c9491f1dae$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $b03bb1c9491f1dae$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
            content: sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7rJgC.default), {
                onClick: onClick,
                xcss: $b03bb1c9491f1dae$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
                        xcss: isVisibleIconOnlyHeader ? $b03bb1c9491f1dae$var$styles.hideIconHeaderWrapper : $b03bb1c9491f1dae$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "small",
                            color: "color.text.subtle",
                            weight: "bold",
                            maxLines: 1,
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
                        xcss: isSortIconVisible ? $b03bb1c9491f1dae$var$styles.sortIconVisibleWrapper : $b03bb1c9491f1dae$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $dd4c19bf39ff9e0d$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2VhaU))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egUrW))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Y6nvS.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b03bb1c9491f1dae$export$2e2bcd8739ae039 = $b03bb1c9491f1dae$var$TableHeadCell;

});
parcelRegister("egUrW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a63e59051f36f4fc$var$_react = $a63e59051f36f4fc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a63e59051f36f4fc$var$_baseNew = $a63e59051f36f4fc$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a63e59051f36f4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a63e59051f36f4fc$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $a63e59051f36f4fc$var$_react.default.createElement($a63e59051f36f4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$a63e59051f36f4fc$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $a63e59051f36f4fc$var$_default = module.exports.default = $a63e59051f36f4fc$var$ArrowDownIcon;

});

parcelRegister("2VhaU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $220e3a34bc1119f8$var$_react = $220e3a34bc1119f8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $220e3a34bc1119f8$var$_baseNew = $220e3a34bc1119f8$var$_interopRequireDefault((parcelRequire("enEmH")));
function $220e3a34bc1119f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $220e3a34bc1119f8$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $220e3a34bc1119f8$var$_react.default.createElement($220e3a34bc1119f8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$220e3a34bc1119f8$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $220e3a34bc1119f8$var$_default = module.exports.default = $220e3a34bc1119f8$var$ArrowUpIcon;

});



parcelRegister("kJnN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ca8f1593bf284a$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eYd2T = parcelRequire("eYd2T");

var $ij3f3 = parcelRequire("ij3f3");

var $7VUM5 = parcelRequire("7VUM5");
class $66ca8f1593bf284a$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $ij3f3.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VUM5.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $66ca8f1593bf284a$var$RankableTableHeadCellOld = (0, $eYd2T.default)($66ca8f1593bf284a$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$66ca8f1593bf284a$export$2e2bcd8739ae039 = $66ca8f1593bf284a$var$RankableTableHeadCellOld;

});
parcelRegister("7VUM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d987b690ad45b553$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $Y6nvS = parcelRequire("Y6nvS");
const $d987b690ad45b553$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Y6nvS.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d987b690ad45b553$export$2e2bcd8739ae039 = $d987b690ad45b553$var$TableHeadCellOld;

});



parcelRegister("d6J9p", function(module, exports) {

let $98aedbe81d989584$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $98aedbe81d989584$var$load("cM9em"),
    $98aedbe81d989584$var$load("fr9NE"),
    $98aedbe81d989584$var$load("avfDe")
]).then(()=>parcelRequire('l80GF'));

});


parcelRegister("jZgzD", function(module, exports) {

$parcel$export(module.exports, "getCursor", () => $b4a72f934a466112$export$da3f040fb23d21f);
$parcel$export(module.exports, "getPageSelectedIndex", () => $b4a72f934a466112$export$21dd36eb814eaa19);
$parcel$export(module.exports, "getPagesArray", () => $b4a72f934a466112$export$bde02ecd78b458e3);
const $b4a72f934a466112$export$da3f040fb23d21f = (currentpageNumber, newPageNumber, prevCursor, nextCursor)=>{
    let cursor;
    if (newPageNumber === currentpageNumber + 1 && nextCursor) cursor = nextCursor;
    else if (newPageNumber === currentpageNumber - 1 && prevCursor) cursor = prevCursor;
    else cursor = '';
    return cursor;
};
const $b4a72f934a466112$export$21dd36eb814eaa19 = (nextCursor, prevCursor)=>nextCursor && !prevCursor ? 0 : 1;
const $b4a72f934a466112$export$bde02ecd78b458e3 = (pageNumber, maxPages, prevCursor, nextCursor)=>{
    let pagesArray = [
        pageNumber
    ];
    if (prevCursor && pageNumber !== 1) pagesArray = [
        pageNumber - 1,
        ...pagesArray
    ];
    if (nextCursor && pageNumber < maxPages) pagesArray = [
        ...pagesArray,
        pageNumber + 1
    ];
    return pagesArray;
};

});






parcelRegister("82xR8", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyNoAccessScreeen", () => $f3ffe473ced37dd0$export$120f3ae85d228f3d);

var $5uXOq = parcelRequire("5uXOq");

var $3s0xG = parcelRequire("3s0xG");

var $koVbs = parcelRequire("koVbs");

var $l8ruj = parcelRequire("l8ruj");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $8twJl = parcelRequire("8twJl");

var $bgoFY = parcelRequire("bgoFY");
const $f3ffe473ced37dd0$export$120f3ae85d228f3d = ({ sourceType: sourceType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const connector = sourceType === 'SHAREPOINT' ? 'SharePoint' : 'Google Drive';
    const title = sourceType === 'SHAREPOINT' ? 'Microsoft SharePoint' : 'Google Drive';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "knowledge-hub-thirdparty-no-access-screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "Knowledge-hub-thirdparty-no-access-screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        maxImageHeight: 400,
        maxImageWidth: 400,
        header: formatMessage((0, $bgoFY.default).thirdPartyLinked, {
            value: title
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8twJl))),
        description: formatMessage((0, $bgoFY.default).thirdPartyConnectorDescription, {
            value: connector
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};

});
parcelRegister("8twJl", function(module, exports) {
module.exports = new URL("kb-hub-third-party-connector.13204c29.svg", import.meta.url).toString();

});

parcelRegister("bgoFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b3a52fa7efa5365$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b3a52fa7efa5365$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    thirdPartyLinked: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.third-party-linked",
        "defaultMessage": "Your admin has added {value}"
    },
    thirdPartyConnectorDescription: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.third-party-connector-description",
        "defaultMessage": "Your admin has linked {value} folders to this project\u2019s knowledge base. Documents in the linked folders are used to answer your customers' questions when they search on portal or help centers."
    }
});

});


parcelRegister("l7HvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5657e58bfe8f146f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");

var $fhG9v = parcelRequire("fhG9v");

var $hJo0o = parcelRequire("hJo0o");

var $2ypeR = parcelRequire("2ypeR");
const $5657e58bfe8f146f$var$AllArticlesTableWithRouteDetails = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ypeR.default), props);
var $5657e58bfe8f146f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isInitiallyLoading: (0, $fhG9v.isBrowseLoading)(state, 'all-articles'),
        KnowledgeHubBulkUpdateCategories: (0, $hJo0o.AsyncBulkUpdateCategories),
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isSearchLoading: (0, $fhG9v.getArticlesLoading)(state)
    }), {})($5657e58bfe8f146f$var$AllArticlesTableWithRouteDetails);

});
parcelRegister("hJo0o", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkUpdateCategories", () => $4fb0a570d2ccdf36$export$a43ca58093f3e92a);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $4fb0a570d2ccdf36$var$LazyBulkUpdateCategories = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("aZx0q")), {
    moduleId: "./src/packages/servicedesk/knowledge-hub/src/view/knowledge-hub-bulk-update-categories/index.tsx"
});
const $4fb0a570d2ccdf36$export$a43ca58093f3e92a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bulk-update-categories",
        packageName: "@atlassian/jira-servicedesk-knowledge-hub"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "knowledge-hub-bulk-update-categories",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fb0a570d2ccdf36$var$LazyBulkUpdateCategories, props)));

});
parcelRegister("aZx0q", function(module, exports) {

let $8009342cc8b12aef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8009342cc8b12aef$var$load("43lw7").then(()=>parcelRequire('e1yg0'));

});


parcelRegister("2ypeR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0255550789c12d68$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $ebyGx = parcelRequire("ebyGx");

var $c6Cwb = parcelRequire("c6Cwb");

var $6eFvr = parcelRequire("6eFvr");

var $clxo5 = parcelRequire("clxo5");

var $5KCCi = parcelRequire("5KCCi");

var $gwIPs = parcelRequire("gwIPs");

var $5I3bw = parcelRequire("5I3bw");

var $a9Z5f = parcelRequire("a9Z5f");

var $6OZOz = parcelRequire("6OZOz");
const $0255550789c12d68$var$SPACES_COLUMN_WIDTH = (0, $gwIPs.gridSize) * 33;
const $0255550789c12d68$var$CATEGORIES_COLUMN_WIDTH = (0, $gwIPs.gridSize) * 20; // AllArticlesTable controls the columns, so you shouldn't pass any in to it
class $0255550789c12d68$export$97a31ecee7db1e5e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            categoriesSupported: true,
            onSetPage: undefined
        };
    }
    getTableColumns() {
        const { showSpaceColumn: showSpaceColumn } = this.props;
        return [
            (0, $a9Z5f.createTitleColumn)((knowledge)=>{
                const { spaceKey: spaceKey, id: id } = knowledge;
                return spaceKey !== undefined ? `/knowledge/articles/${id}?spaceKey=${spaceKey}` : `/knowledge/articles/${id}`;
            }),
            ...showSpaceColumn ? [
                this.getLinkedSpacesColumn()
            ] : [],
            this.getCategoriesColumn(),
            (0, $a9Z5f.viewCountColumn),
            (0, $a9Z5f.lastModifiedColumn)
        ];
    }
    getCategoriesColumn() {
        // go/jfe-eslint
        const { KnowledgeHubBulkUpdateCategories: KnowledgeHubBulkUpdateCategories, categoriesSupported: categoriesSupported } = this.props;
        return {
            key: 'article-categories',
            header: (intl)=>({
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0255550789c12d68$var$FlexLeftAlignedText, null, intl.formatMessage((0, $6OZOz.default).categoriesHeader), !categoriesSupported && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0255550789c12d68$var$NoCategoriesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                        content: intl.formatMessage((0, $6OZOz.default).noCategoriesTooltip)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))), {
                        label: "",
                        LEGACY_size: "medium",
                        spacing: "spacious"
                    })))),
                    isSortable: false,
                    width: `${$0255550789c12d68$var$CATEGORIES_COLUMN_WIDTH}px`
                }),
            row: (intl, index, knowledge)=>!categoriesSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                    as: "em"
                }, intl.formatMessage((0, $6OZOz.default).noCategoriesRow)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeHubBulkUpdateCategories, {
                    key: `article-bulk-categories-${knowledge.id}`,
                    articleId: knowledge.id,
                    categoryEditorWidth: $0255550789c12d68$var$CATEGORIES_COLUMN_WIDTH
                })
        };
    }
    getLinkedSpacesColumn() {
        return {
            key: 'article-linked-spaces',
            header: (intl)=>({
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Z5f.LeftAlignedText), null, intl.formatMessage((0, $6OZOz.default).linkedSpacesHeader)),
                    isSortable: false,
                    width: `${$0255550789c12d68$var$SPACES_COLUMN_WIDTH}px`
                }),
            row: (intl, index, knowledge)=>{
                const spaceName = knowledge.spaceName || '';
                const spaceUrl = knowledge.spaceUrl || '';
                const { canViewSpaceUrl: canViewSpaceUrl } = this.props;
                return canViewSpaceUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Z5f.LeftAlignedText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                    content: intl.formatMessage((0, $6OZOz.default).tooltipText)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: spaceUrl,
                    target: "_blank",
                    rel: "noopener noreferrer nofollow"
                }, spaceName))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Z5f.LeftAlignedText), null, spaceName);
            }
        };
    }
    render() {
        const { knowledgePieces: knowledgePieces } = this.props;
        return knowledgePieces ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5I3bw.default), {
            ...this.props,
            categoryId: "all-articles",
            actions: [],
            columns: this.getTableColumns(),
            onSetPage: this.onSetPage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0255550789c12d68$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
            size: 70
        }));
    }
    constructor(...args){
        super(...args), this.onSetPage = (pageNum, sortBy, push, history, analyticsEvent, cursor, searchQuery, spaceKeys)=>{
            // go/jfe-eslint
            const { onSetPage: onSetPage } = this.props;
            onSetPage && onSetPage(pageNum, sortBy, push, history, analyticsEvent, cursor);
            const spacekeyNames = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(spaceKeys) ? null : JSON.stringify(spaceKeys);
            push ? push(`/knowledge/browse/page/${pageNum}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                cursor: cursor,
                sortBy: sortBy,
                searchQuery: searchQuery,
                spaceKey: spacekeyNames
            }, // @ts-expect-error - TS2345 - Argument of type '{ skipNull: boolean; skipEmptyString: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
            {
                skipNull: true,
                skipEmptyString: true
            })}`) : history.push(`/knowledge/browse/page/${pageNum}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                cursor: cursor,
                sortBy: sortBy,
                searchQuery: searchQuery,
                spaceKey: spacekeyNames
            }, // @ts-expect-error - TS2345 - Argument of type '{ skipNull: boolean; skipEmptyString: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
            {
                skipNull: true,
                skipEmptyString: true
            })}`);
        };
    }
}
var $0255550789c12d68$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0255550789c12d68$export$97a31ecee7db1e5e;
const $0255550789c12d68$var$NoCategoriesWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkr5cr _2hwxidpf _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0255550789c12d68$var$FlexLeftAlignedText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0255550789c12d68$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _4t3i1osq _19pk1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5I3bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d45f11aa875c2d$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");

var $akqdW = parcelRequire("akqdW");

var $l1emQ = parcelRequire("l1emQ");

var $kHzxc = parcelRequire("kHzxc");

var $gXg4u = parcelRequire("gXg4u");

var $fhG9v = parcelRequire("fhG9v");

var $4VdM6 = parcelRequire("4VdM6");
const $33d45f11aa875c2d$var$KnowledgeTableWithPush = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akqdW.default), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VdM6.default), {
            ...props,
            push: push
        }));
const $33d45f11aa875c2d$export$2c0e26252fc4f28d = (0, $bC2fB.connect)((state, props)=>{
    // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'. | TS2339 - Property 'categoryId' does not exist on type '{}'. | TS2339 - Property 'page' does not exist on type '{}'.
    const articleIds = (0, $fhG9v.getArticleIdsForCategory)(state, props.categoryId, props.page);
    let totalSize;
    let knowledgePieces;
    let error;
    if (articleIds) {
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'string[] | GenericError'.
        if (articleIds.error && !Array.isArray(articleIds)) error = articleIds;
        else {
            // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'. | TS2339 - Property 'categoryId' does not exist on type '{}'.
            totalSize = (0, $fhG9v.getCategoryTotalSize)(state, props.categoryId);
            // @ts-expect-error - TS2322 - Type 'Article | GenericError' is not assignable to type 'Article[] | undefined'. | TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
            knowledgePieces = (0, $gXg4u.getArticlesByIds)(state, articleIds).reduce(// @ts-expect-error - TS2322 - Type '(Article | GenericError)[]' is not assignable to type 'Article[]'. | TS2339 - Property 'error' does not exist on type 'Article | GenericError'.
            (acc, curr)=>curr.error ? acc : [
                    ...acc,
                    curr
                ], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            []);
        }
    }
    return {
        totalSize: totalSize,
        knowledgePieces: knowledgePieces,
        error: error,
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'. | TS2339 - Property 'categoryId' does not exist on type '{}'.
        isInitiallyLoading: (0, $fhG9v.isBrowseLoading)(state, props.categoryId),
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        limit: (0, $fhG9v.getBrowseLimit)(state),
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isSearchLoading: (0, $fhG9v.getArticlesLoading)(state)
    };
}, {
    onBrowseKnowledge: (0, $kHzxc.browseKnowledge)
})($33d45f11aa875c2d$var$KnowledgeTableWithPush);
var $33d45f11aa875c2d$export$2e2bcd8739ae039 = (0, $l1emQ.withRouter)($33d45f11aa875c2d$var$KnowledgeTableWithPush);

});
parcelRegister("4VdM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4acb9099462d9019$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1sXeC = parcelRequire("1sXeC");

var $cTmPi = parcelRequire("cTmPi");

var $PtOw7 = parcelRequire("PtOw7");

var $clxo5 = parcelRequire("clxo5");

var $koVbs = parcelRequire("koVbs");

var $75gFv = parcelRequire("75gFv");

var $iDMMZ = parcelRequire("iDMMZ");

var $6yXtV = parcelRequire("6yXtV");

var $13x0I = parcelRequire("13x0I");

var $a9Z5f = parcelRequire("a9Z5f");

var $9S8wn = parcelRequire("9S8wn");

var $jZgzD = parcelRequire("jZgzD");
const $4acb9099462d9019$export$ac0a9805cce1a48c = ({ isInitiallyLoading: isInitiallyLoading, isSearchLoading: isSearchLoading, error: error, sortBy: sortBy, expansions: expansions, page: page, emptyStateComponent: emptyStateComponent, noSearchResultsComponent: noSearchResultsComponent, columns: columns, onSetPage: onSetPage, history: history, push: push, totalSize: totalSize = -1, knowledgePieces: knowledgePieces, limit: rowsPerPage, onBrowseKnowledge: onBrowseKnowledge, categoryId: categoryId, prevCursor: prevCursor, nextCursor: nextCursor, searchQuery: searchQuery, spaceKeys: spaceKeys })=>{
    // Ensure page is actually a number.
    // Generally it's sourced from route params which may be a string when implicitly passed down.
    const pageNumber = (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(page);
    const intl = (0, $koVbs.default)();
    const expansionDeps = (expansions || []).join(';');
    (0, $5uXOq.useEffect)(()=>{
        // be careful adding new hook dependencies here!
        // the exhaustive-deps rule is disabled for this useEffect so it won't scream at you
        onBrowseKnowledge && onBrowseKnowledge({
            page: pageNumber,
            limit: rowsPerPage,
            id: categoryId,
            orderBy: sortBy,
            expand: expansions
        });
    }, // this eslint rule is disabled as expansionDeps is just a string-concatenation of the expansions array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        categoryId,
        sortBy,
        expansionDeps,
        onBrowseKnowledge,
        pageNumber,
        rowsPerPage
    ]);
    const columnKeys = columns.map((c)=>c.key).join(';');
    const header = (0, $5uXOq.useMemo)(()=>{
        // be careful adding new hook dependencies here!
        // the exhaustive-deps rule is disabled for this useMemo so it won't scream at you
        const headerCells = columns.map((column)=>({
                key: column.key,
                ...column.header(intl)
            }));
        return {
            cells: headerCells
        };
    }, // we only need to update the header when the column keys change (which means the columns have changed!)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        columnKeys,
        intl
    ]); // @ts-expect-error - TS2304 - Cannot find name 'RowType'.
    let rows = [];
    if (totalSize > 0 && Array.isArray(knowledgePieces)) // each piece of knowledge has its own row
    rows = knowledgePieces.map((knowledge, index)=>{
        // Use the zero padded index as part of the key, manually correcting when sorted in descending order
        const indexKey = ((0, $a9Z5f.getSortOrder)(sortBy) === 'DESC' ? knowledgePieces.length - 1 - index : index).toString().padStart((knowledgePieces.length - 1).toString().length, '0');
        const cells = columns.map((column)=>({
                // we use a row cell key unique to the piece of knowledge
                key: `${indexKey}-${column.key}-${knowledge.id}`,
                content: column.row(intl, index, knowledge, {
                    page: page
                })
            }));
        return {
            // we use a row key unique to the piece of knowledge
            key: `knowledge-${knowledge.id}`,
            cells: cells
        };
    });
    const paginationi18n = (0, $5uXOq.useMemo)(()=>({
            prev: intl.formatMessage((0, $9S8wn.default).paginationPrev),
            next: intl.formatMessage((0, $9S8wn.default).paginationNext)
        }), [
        intl
    ]);
    if (error) {
        const errorContent = error.error;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75gFv))),
            header: intl.formatMessage(errorContent.header),
            description: intl.formatMessage(errorContent.message),
            primaryAction: errorContent.ctaLink && errorContent.ctaText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDMMZ.default), {
                to: errorContent.ctaLink || ''
            }, intl.formatMessage(errorContent.ctaText)) : undefined
        });
    }
    if (isInitiallyLoading || isSearchLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4acb9099462d9019$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large",
        delay: 300
    }));
    if (totalSize === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4acb9099462d9019$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTmPi.default), {
        head: header,
        sortKey: (0, $a9Z5f.getSortKey)(columns, sortBy),
        sortOrder: (0, $a9Z5f.getSortOrder)(sortBy),
        paginationi18n: paginationi18n
    }), searchQuery === '' ? emptyStateComponent : noSearchResultsComponent);
    const selectedIndex = (0, $jZgzD.getPageSelectedIndex)(nextCursor, prevCursor);
    const maxPages = Math.ceil(totalSize / rowsPerPage);
    const pagesArray = (0, $jZgzD.getPagesArray)(pageNumber, maxPages, prevCursor, nextCursor);
    const currentPageNumber = pagesArray[selectedIndex];
    const onPageChange = (event, newPageNumber, analyticsEvent)=>{
        if (newPageNumber !== currentPageNumber && onSetPage) {
            const cursor = (0, $jZgzD.getCursor)(currentPageNumber, newPageNumber, prevCursor, nextCursor);
            if (cursor) onSetPage(newPageNumber, sortBy, push, history, analyticsEvent, cursor, searchQuery, spaceKeys);
        }
    };
    const onPageSort = (sort)=>{
        if (typeof sort === 'object' && sort !== null && // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'.
        typeof sort.key === 'string' && // @ts-expect-error - TS2339 - Property 'sortOrder' does not exist on type 'object'.
        typeof sort.sortOrder === 'string' && onSetPage) onSetPage(1, // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'. | TS2339 - Property 'sortOrder' does not exist on type 'object'.
        (0, $a9Z5f.getSortBy)(columns, sort.key, sort.sortOrder), push, history, undefined, '', searchQuery, spaceKeys);
    }; /* eslint-disable jira/react/no-style-attribute */ 
    const articlePagination = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PtOw7.default), {
            pages: pagesArray,
            onChange: onPageChange,
            style: {
                display: 'flex',
                justifyContent: 'center'
            },
            selectedIndex: selectedIndex
        }); /* eslint-enable jira/react/no-style-attribute */ 
    const isPaginated = (nextCursor || prevCursor) && totalSize > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4acb9099462d9019$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTmPi.default), {
        head: header,
        rows: rows,
        sortKey: (0, $a9Z5f.getSortKey)(columns, sortBy),
        sortOrder: (0, $a9Z5f.getSortOrder)(sortBy),
        onSort: onPageSort,
        isLoading: totalSize < 0 || isSearchLoading,
        paginationi18n: paginationi18n
    }), totalSize >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yXtV.SpaStatePageReadyOnUpdate), {
        comparer: [
            categoryId
        ]
    })), isPaginated && articlePagination());
};
$4acb9099462d9019$export$ac0a9805cce1a48c.defaultProps = {
    totalSize: -1,
    knowledgePieces: [],
    expansions: undefined,
    onActionsOpenChange: undefined,
    error: undefined,
    prevCursor: '',
    nextCursor: '',
    searchQuery: '',
    spaceKeys: {}
};
var $4acb9099462d9019$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $4acb9099462d9019$export$ac0a9805cce1a48c;
const $4acb9099462d9019$var$TableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv47k _p4liidpf _owipidpf _6autidpf _1pqwidpf _1ik0udwz _c9d7udwz _1bfwudwz _i7sf1hna _1lkk1hna _1fr8u2gc _1160idpf _lxpru2gc _il49idpf _1he61ejb _hlwa1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4acb9099462d9019$var$LoadingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _19pkxy5q",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6OZOz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f1c5eb6647072e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1f1c5eb6647072e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    categoriesHeader: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.categories-header",
        "defaultMessage": "Categories"
    },
    noCategoriesTooltip: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.no-categories-tooltip",
        "defaultMessage": "Categories are not available for spaces linked from Confluence Data Center sites."
    },
    noCategoriesRow: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.no-categories-row",
        "defaultMessage": "Not available."
    },
    updateCategoriesHeader: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.update-categories-header",
        "defaultMessage": "Categories"
    },
    linkedSpacesHeader: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.linked-spaces-header",
        "defaultMessage": "Space"
    },
    tooltipText: {
        "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.tooltip-text",
        "defaultMessage": "Opens in new tab"
    }
});

});



parcelRegister("6oq8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $6011c25cb54478d1$export$2e2bcd8739ae039);
// @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $6011c25cb54478d1$export$2e2bcd8739ae039 = (s, defaultValue)=>{
    if (s === undefined || s === null) return undefined;
    const num = parseInt(s, 10);
    if (Number.isNaN(num)) return defaultValue;
    return num;
};

});

parcelRegister("eyGOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31afb52b11d9ee2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lFKmC = parcelRequire("lFKmC");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $ebyGx = parcelRequire("ebyGx");

var $liZ21 = parcelRequire("liZ21");

var $htBRZ = parcelRequire("htBRZ");

var $cNW3X = parcelRequire("cNW3X");

var $j7m8K = parcelRequire("j7m8K");
var $7OX7J = parcelRequire("7OX7J");
var $5d9qL = parcelRequire("5d9qL");

var $bWfiu = parcelRequire("bWfiu");

var $dGKFs = parcelRequire("dGKFs");

var $ieYuw = parcelRequire("ieYuw");

var $7kQOw = parcelRequire("7kQOw");

var $b6xHZ = parcelRequire("b6xHZ");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $9r7BT = parcelRequire("9r7BT");

var $8zOmE = parcelRequire("8zOmE");

var $hZHze = parcelRequire("hZHze");

var $01Rn4 = parcelRequire("01Rn4");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $3HwlS = parcelRequire("3HwlS");

var $8n9Eh = parcelRequire("8n9Eh");

var $7Mned = parcelRequire("7Mned");

var $2bFEE = parcelRequire("2bFEE");

var $5RVjC = parcelRequire("5RVjC");

var $lw2HC = parcelRequire("lw2HC");

var $lnrq2 = parcelRequire("lnrq2");

var $bPEAu = parcelRequire("bPEAu");

var $h5R5L = parcelRequire("h5R5L");

var $9mT3w = parcelRequire("9mT3w");

var $fORah = parcelRequire("fORah");

var $2YBWI = parcelRequire("2YBWI");

var $01ehM = parcelRequire("01ehM");

var $hAcT9 = parcelRequire("hAcT9");

var $c9JME = parcelRequire("c9JME");

var $8WALy = parcelRequire("8WALy");

var $jbwMx = parcelRequire("jbwMx");

var $6geWD = parcelRequire("6geWD");

var $1ydSB = parcelRequire("1ydSB");

var $500iy = parcelRequire("500iy");
const $a31afb52b11d9ee2$var$renderLinkedButton = ({ articleUrl: articleUrl, onCreateArticleHeaderClicked: onCreateArticleHeaderClicked, intl: intl, appLinkOrError: appLinkOrError })=>{
    const isConfluenceServerAppLink = Boolean(!appLinkOrError?.error && appLinkOrError?.isServer);
    if (!isConfluenceServerAppLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lw2HC.UserCapabilitiesSubscriber), null, ({ data: data })=>{
        const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { editableSpaces: editableSpaces } } = data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPEAu.CreateArticleButton), {
            spaces: editableSpaces,
            hasConfluenceLicense: hasConfluenceLicense
        });
    });
    if (articleUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8n9Eh.default), {
        href: articleUrl,
        onClick: onCreateArticleHeaderClicked,
        appearance: "primary",
        spacing: "default"
    }, intl.formatMessage((0, $1ydSB.default).createArticleCta));
    return null;
};
class $a31afb52b11d9ee2$export$cdc9d8ce4adcf011 extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        this.defaultProps = {
            page: 1,
            error: undefined,
            categoriesSupported: true,
            onCreateArticleHeaderClicked: undefined,
            onCreateArticleEmptyStateClicked: undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.isLoading && !state.hasLoaded) return {
            hasLoaded: true
        };
        return null;
    }
    componentDidMount() {
        const { onFetchAppLink: onFetchAppLink, getLinkedSpaces: getLinkedSpaces, projectKey: projectKey, getSuggestedTopics: getSuggestedTopics, onTriggerArticleGenerationForTopics: onTriggerArticleGenerationForTopics, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId } = this.props;
        onFetchAppLink();
        getLinkedSpaces({
            projectKey: projectKey
        });
        if ((0, $4R6GH.fg)('suggested_topics_onboarding_on_articles_tab')) {
            getSuggestedTopics({
                activationId: activationId,
                projectId: projectId
            });
            onTriggerArticleGenerationForTopics({
                projectId: projectId,
                activationId: activationId,
                analyticsEvent: createAnalyticsEvent({})
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { searchQuery: searchQuery, spaceKeys: spaceKeys, page: page, sortBy: sortBy, appLinkOrError: appLinkOrError } = this.props;
        if (page !== prevProps.page || sortBy !== prevProps.sortBy || searchQuery !== prevProps.searchQuery || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(Object.keys(spaceKeys), Object.keys(prevProps.spaceKeys)) || // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'AppLink | AppLinkError'.
        !prevProps.appLinkOrError?.error && // @ts-expect-error - TS2339 - Property 'requireCredentials' does not exist on type 'AppLink | AppLinkError'.
        appLinkOrError?.requireCredentials === false && // @ts-expect-error - TS2339 - Property 'requireCredentials' does not exist on type 'AppLink | AppLinkError'. | TS2339 - Property 'requireCredentials' does not exist on type 'AppLink | AppLinkError'.
        appLinkOrError?.requireCredentials !== prevProps.appLinkOrError?.requireCredentials) this.refreshArticles();
    }
    refreshArticles() {
        const { cursor: cursor, searchQuery: searchQuery, spaceKeys: spaceKeys, page: page, sortBy: sortBy, onBrowseArticles: onBrowseArticles, limit: limit, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        let browseObj = {
            id: 'all-articles',
            page: page,
            limit: limit,
            expand: [
                'viewCount',
                'category'
            ],
            orderBy: sortBy,
            createAnalyticsEvent: createAnalyticsEvent
        };
        if (cursor) // @ts-expect-error - TS2322 - Type '{ cursor: string; id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }' is not assignable to type '{ id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }'.
        browseObj = {
            ...browseObj,
            cursor: cursor
        };
        if (searchQuery) // @ts-expect-error - TS2322 - Type '{ query: string; id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }' is not assignable to type '{ id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }'.
        browseObj = {
            ...browseObj,
            query: searchQuery
        };
        const spaces = Object.keys(spaceKeys);
        if (spaces.length) // @ts-expect-error - TS2322 - Type '{ spaceKey: string[]; id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }' is not assignable to type '{ id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }'.
        browseObj = {
            ...browseObj,
            spaceKey: spaces
        };
         // @ts-expect-error - TS2345 - Argument of type '{ id: string; page: number; limit: number; expand: string[]; orderBy: OrderBy; }' is not assignable to parameter of type 'BrowseKnowledgePayload'.
        onBrowseArticles(browseObj);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    triggerText(spaces) {
        const { intl: intl } = this.props;
        const { length: length } = Object.keys(spaces);
        let spaceName = '';
        if (length === 1) {
            const key = Object.keys(spaces)[0];
            spaceName = spaces[key].length > 15 ? `${spaces[key].substr(0, 15)}...` : spaces[key];
        }
        return intl.formatMessage((0, $1ydSB.default).spacesDropdownText, {
            count: length,
            spaceName: spaceName
        });
    }
    getDropdownItemsV2(linkedSpaces) {
        const { spacesSelected: spacesSelected } = this.state;
        const dropdownItems = linkedSpaces.map((space, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OX7J.default), {
                key: index,
                id: space.spaceKey,
                onClick: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                this.onSpacesToggled,
                isSelected: space.spaceKey in spacesSelected
            }, space.spaceName));
        return dropdownItems;
    }
    content(articleUrl, showSpaceColumn, canViewSpaceUrl) {
        const { articlesPage: articlesPage, page: page, sortBy: sortBy, intl: intl, limit: limit, ArticlesTable: ArticlesTable, nextCursor: nextCursor, prevCursor: prevCursor, searchQuery: searchQuery, spaceKeys: spaceKeys, categoriesSupported: categoriesSupported, appLinkOrError: appLinkOrError } = this.props;
        let creatingLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: articleUrl,
            target: "_blank",
            rel: "noreferrer noopener"
        }, intl.formatMessage((0, $1ydSB.default).creatingArticleDescription));
        const isConfluenceServerAppLink = Boolean(// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'AppLink | AppLinkError'. | TS2339 - Property 'isServer' does not exist on type 'AppLink | AppLinkError'.
        !appLinkOrError?.error && appLinkOrError?.isServer);
        if (!isConfluenceServerAppLink) creatingLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lw2HC.UserCapabilitiesSubscriber), null, ({ data: data })=>{
            const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { editableSpaces: editableSpaces } } = data;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPEAu.CreateArticleButton), {
                spaces: editableSpaces,
                appearance: "link",
                hasConfluenceLicense: hasConfluenceLicense
            }, intl.formatMessage((0, $1ydSB.default).creatingArticleDescription));
        });
        const emptyStateComponentMultipleSpaces = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$ImgContainer, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($hAcT9))),
            alt: intl.formatMessage((0, $1ydSB.default).noArticlesFound)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateMiddleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
            size: "medium"
        }, intl.formatMessage((0, $1ydSB.default).noArticlesTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$CreateArticleLinkButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1ydSB.default).noArticlesDescriptionMultipleSpaces,
            values: {
                creating: creatingLink
            }
        })));
        const noSearchResultsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$ImgContainer, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7Mned))),
            alt: intl.formatMessage((0, $1ydSB.default).noArticlesFound)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateMiddleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
            size: "medium"
        }, intl.formatMessage((0, $1ydSB.default).noArticlesTitleMultipleSpaces))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$CreateArticleLinkButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1ydSB.default).noArticlesDescriptionMultipleSpaces,
            values: {
                creating: creatingLink
            }
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ArticlesTable, {
            limit: limit,
            page: page,
            sortBy: sortBy,
            categoriesSupported: categoriesSupported,
            totalSize: articlesPage?.totalSize,
            knowledgePieces: articlesPage?.articles,
            emptyStateComponent: emptyStateComponentMultipleSpaces,
            noSearchResultsComponent: noSearchResultsComponent,
            nextCursor: nextCursor,
            prevCursor: prevCursor,
            searchQuery: searchQuery,
            spaceKeys: spaceKeys,
            showSpaceColumn: showSpaceColumn,
            canViewSpaceUrl: canViewSpaceUrl,
            appLinkOrError: appLinkOrError
        });
    }
    renderBottomBar() {
        const { intl: intl, categoriesSupported: categoriesSupported, isAdmin: isAdmin, projectKey: projectKey } = this.props;
        const settingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`;
        if (!categoriesSupported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, intl.formatMessage((0, $1ydSB.default).welcomeDescriptionNoCategories));
        const CustomDescription = (0, $3HwlS.getWillShowNav4)() ? $a31afb52b11d9ee2$var$DescriptionV2 : $a31afb52b11d9ee2$var$Description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            alignBlock: "start",
            spread: "space-between",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, intl.formatMessage((0, $1ydSB.default).welcomeDescriptionNew), " ") : // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage((0, $1ydSB.default).welcomeDescriptionNew)), isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $1ydSB.default).welcomeDescriptionAdmins,
            values: {
                linkText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: settingsUrl,
                    className: (0, $bwpsq.default)([
                        "_4bfu18uv _1hms8stv _ajmmnqa1"
                    ])
                }, intl.formatMessage((0, $1ydSB.default).welcomeDescriptionAdminsLink))
            }
        }) : null), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9mT3w.VirtualServiceAgentTouchpoint), null)));
    }
    getCompletedSuggestedTopics() {
        const { topics: topics } = this.props;
        if (!(0, $4R6GH.fg)('suggested_topics_onboarding_on_articles_tab') || !topics) return [];
        const completedSuggestedTopics = topics.filter((topic)=>topic.aiDraftArticleGenerationState === 'COMPLETED');
        if (completedSuggestedTopics.length < 2) return [];
        return completedSuggestedTopics.slice(0, 2);
    }
    getCreateArticle(topic, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lw2HC.UserCapabilitiesSubscriber), null, ({ data: data })=>{
            const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { editableSpaces: editableSpaces } } = data;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fORah.CreateArticleAction), {
                topicId: topic.topicId,
                topicName: topic.topicName,
                numberOfRelatedTickets: topic.numberOfRelatedTickets,
                spaces: editableSpaces,
                aiDraftArticleGenerationState: topic.aiDraftArticleGenerationState,
                hasConfluenceLicense: hasConfluenceLicense,
                isRightDrawerOpen: this.state.isRightDrawerOpen,
                onToggleRightDrawer: this.onToggleRightDrawer,
                aiDraftContent: topic.aiDraftPreview,
                getAIDraftContent: this.onGetAiDraftContent,
                rowIndex: index
            });
        });
    }
    renderAllArticlesView() {
        const { intl: intl, projectKey: projectKey, confluenceUrl: confluenceUrl, spaceKey: spaceKey, onCreateArticleHeaderClicked: onCreateArticleHeaderClicked, ReadyForUser: ReadyForUser, appLinkOrError: appLinkOrError, articlesPage: articlesPage } = this.props;
        const { hasLoaded: hasLoaded } = this.state;
        const articleUrl = confluenceUrl && spaceKey && `${confluenceUrl}/display/${spaceKey}?createDialog=true`;
        const completedSuggestedTopics = this.getCompletedSuggestedTopics();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2bFEE.KbContentContainer), null, hasLoaded && articlesPage && articlesPage.totalSize >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReadyForUser, {
            metricKey: "servicedesk.knowledge.articles",
            metric: (0, $500iy.articlesPageLoad)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), hasLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $a31afb52b11d9ee2$var$confluenceUpsellContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnrq2.ConfluenceUpsellMessage), null)), completedSuggestedTopics.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
            size: "small"
        }, intl.formatMessage((0, $1ydSB.default).suggestedTopicsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liZ21.default), {
            appearance: "subtle",
            href: `/jira/servicedesk/projects/${projectKey}/knowledge/suggested-topics`,
            onClick: this.onViewAllLinkClick
        }, intl.formatMessage((0, $1ydSB.default).viewAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            xcss: $a31afb52b11d9ee2$var$topicSuggestedInlineStyles,
            spread: "space-between",
            space: "space.200"
        }, completedSuggestedTopics.map((topic, index)=>{
            const subtitle = intl.formatMessage((0, $1ydSB.default).topicSubtitle, {
                workItemCount: topic.numberOfRelatedTickets
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
                xcss: $a31afb52b11d9ee2$var$topicSuggestedItemStyles,
                key: topic.topicId,
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $a31afb52b11d9ee2$var$imgStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b6xHZ))), {
                label: "",
                testId: "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.article-icon",
                LEGACY_size: "medium",
                spacing: "spacious"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                size: "medium",
                as: "p",
                maxLines: 2,
                weight: "semibold"
            }, topic.topicName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $a31afb52b11d9ee2$var$topicSubtitleStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                size: "small",
                color: "color.text.subtlest",
                as: "p",
                maxLines: 1
            }, subtitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $a31afb52b11d9ee2$var$actionBoxStyles
            }, this.getCreateArticle(topic, index))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $a31afb52b11d9ee2$var$aiFooterStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2YBWI.AiFooter), {
                isBeta: false,
                showAttributionLink: true
            })));
        }))) : null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.renderBottomBar()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default // @ts-expect-error - TS2769 - No overload matches this call.
        ), {
            truncateTitle: true,
            bottomBar: this.renderBottomBar(),
            actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$ActionsGroup, {
                spacing: "wide"
            }, $a31afb52b11d9ee2$var$renderLinkedButton({
                articleUrl: articleUrl,
                onCreateArticleHeaderClicked: onCreateArticleHeaderClicked,
                intl: intl,
                appLinkOrError: appLinkOrError
            }))
        }, intl.formatMessage((0, $jbwMx.default).articlesPageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01ehM.default), {
            onAuthComplete: this.onAuthComplete
        }, this.renderAllArticleSearchAndTable(articleUrl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9JME.DraftArticleSuccessFlags), null));
    }
    renderSearchContainer(readableSpaces, hasMultipleLinkedSpaces) {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$SearchContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$TextFieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
            elemAfterInput: this.state.query.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$IconWrapper, {
                onClick: this.onRemoveText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieYuw))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: "close"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: "",
                "aria-hidden": "true"
            })),
            onChange: this.onTextEntered,
            placeholder: intl.formatMessage((0, $1ydSB.default).searchPlaceholder),
            value: this.state.query,
            isCompact: true,
            "aria-label": intl.formatMessage((0, $1ydSB.default).searchLabelText),
            "aria-describedby": "hintText"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            id: "hintText",
            hidden: true
        }, intl.formatMessage((0, $1ydSB.default).searchArticlesHintText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasMultipleLinkedSpaces && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$DropdownContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default // eslint-disable-next-line jira/react-no-inline-function-prop
        ), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                    ...props,
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
                        label: ""
                    })
                }, this.state.dropdownText)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5d9qL.default), {
            id: "spaces-dropdown"
        }, this.getDropdownItemsV2(readableSpaces))))));
    }
    renderAllArticleSearchAndTable(articleUrl) {
        const { intl: intl, onCreateArticleHeaderClicked: onCreateArticleHeaderClicked, appLinkOrError: appLinkOrError } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lw2HC.UserCapabilitiesSubscriber), null, ({ data: data })=>{
            const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { readableSpaces: readableSpaces } } = data;
            const totalSize = readableSpaces.length;
            const hasMultipleLinkedSpaces = totalSize > 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5RVjC.KnowledgeBaseActionsGroup), null, this.renderSearchContainer(readableSpaces, hasMultipleLinkedSpaces), $a31afb52b11d9ee2$var$renderLinkedButton({
                articleUrl: articleUrl,
                onCreateArticleHeaderClicked: onCreateArticleHeaderClicked,
                intl: intl,
                appLinkOrError: appLinkOrError
            })) : this.renderSearchContainer(readableSpaces, hasMultipleLinkedSpaces), this.content(articleUrl, hasMultipleLinkedSpaces, hasConfluenceLicense));
        });
    }
    renderAllArticlesViewWithAnalytics() {
        const { articlesPage: articlesPage, appLinkOrError: appLinkOrError } = this.props;
        if (articlesPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
            data: {
                source: `knowledgeBrowseAllArticleSuccess${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
                attributes: {
                    isConfluenceServer: Boolean(// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'AppLink | AppLinkError'. | TS2339 - Property 'isServer' does not exist on type 'AppLink | AppLinkError'.
                    !appLinkOrError?.error && appLinkOrError?.isServer)
                }
            }
        }, this.renderAllArticlesView());
        return this.renderAllArticlesView();
    }
    render() {
        const { error: error, linkedState: linkedState, appLinkOrError: appLinkOrError, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId } = this.props;
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WALy.default), {
            error: error.error,
            screenName: "knowledgeBrowseAllArticleError",
            attributes: {
                isConfluenceServer: Boolean(// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'AppLink | AppLinkError'. | TS2339 - Property 'isServer' does not exist on type 'AppLink | AppLinkError'.
                !appLinkOrError?.error && appLinkOrError?.isServer)
            }
        });
        if (linkedState === 'unlinked') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5R5L.default), {
            to: "/knowledge/setup"
        });
        return(// eslint-disable-next-line jira/react/no-style-attribute
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            style: {
                marginRight: this.state.isRightDrawerOpen ? '420px' : '0px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lw2HC.UserCapabilitiesSubscriber), null, (_, { fetchUserCapabilities: fetchUserCapabilities })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
                op: fetchUserCapabilities,
                args: [
                    projectId,
                    activationId,
                    createAnalyticsEvent({})
                ]
            }), this.renderAllArticlesViewWithAnalytics()))));
    }
    constructor(...args){
        super(...args), this.state = {
            hasLoaded: false,
            spacesSelected: this.props.spaceKeys || {},
            query: this.props.searchQuery || '',
            dropdownText: this.triggerText(this.props.spaceKeys),
            isRightDrawerOpen: false
        }, this.onSetPage = (removeText)=>{
            const { push: push, history: history, sortBy: sortBy } = this.props;
            const { spacesSelected: spacesSelected, query: query } = this.state;
            const spacesLength = Object.keys(spacesSelected).length;
            const spacekeyNames = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(spacesSelected) ? null : JSON.stringify(spacesSelected);
            let queryParams = {
                sortBy: sortBy
            };
            if (removeText && spacesLength > 0) queryParams = {
                ...queryParams,
                spaceKey: spacekeyNames
            };
            else if (!removeText) queryParams = {
                ...queryParams,
                searchQuery: query,
                spaceKey: spacekeyNames
            };
            push ? push(`/knowledge/browse/page/1?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams, {
                // @ts-expect-error - TS2345 - Argument of type '{ skipNull: boolean; skipEmptyString: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
                skipNull: true,
                skipEmptyString: true
            })}`) : history.push(`/knowledge/browse/page/1?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams, {
                // @ts-expect-error - TS2345 - Argument of type '{ skipNull: boolean; skipEmptyString: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
                skipNull: true,
                skipEmptyString: true
            })}`);
        }, this.debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.onSetPage, 300), this.onTextEntered = (e)=>{
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'EventTarget & HTMLElement'.
            const newText = e.currentTarget.value;
            this.setState({
                query: newText != null ? newText : ''
            });
            this.debouncedSearch(false);
        }, this.onRemoveText = ()=>{
            this.setState({
                query: ''
            });
            this.debouncedSearch(true);
        }, this.onSpacesToggled = (e)=>{
            const spaceKey = e.currentTarget.id;
            const spaceName = e.currentTarget.textContent;
            this.setState((state)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let spacesSelected = {};
                if (spaceKey in state.spacesSelected) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    spacesSelected = Object.keys(state.spacesSelected).reduce((acc, key)=>{
                        if (key !== spaceKey) acc[key] = state.spacesSelected[key];
                        return acc;
                    }, {});
                    return {
                        spacesSelected: spacesSelected,
                        dropdownText: this.triggerText(spacesSelected)
                    };
                }
                spacesSelected = {
                    ...state.spacesSelected,
                    [spaceKey]: spaceName
                };
                return {
                    spacesSelected: spacesSelected,
                    dropdownText: this.triggerText(spacesSelected)
                };
            }, ()=>{
                const removeText = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(this.state.spacesSelected);
                this.onSetPage(removeText);
            });
        }, this.onToggleRightDrawer = ()=>{
            this.setState({
                isRightDrawerOpen: !this.state.isRightDrawerOpen
            });
        }, this.onGetAiDraftContent = (topicId)=>{
            const { getAiDraftPreviewContent: getAiDraftPreviewContent, activationId: activationId, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            getAiDraftPreviewContent({
                projectId: projectId,
                activationId: activationId,
                topicId: topicId,
                analyticsEvent: createAnalyticsEvent({})
            });
        } /**
      *
      * we only want to show 2 topics that are in COMPLETED state, no more, no less. If there are less than 2 topics, we return an empty array
      * @returns {Array<Topic>}
      */ , this.onViewAllLinkClick = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewAllSuggestedTopics');
        }, this.onAuthComplete = (error)=>{
            if (!error) {
                this.refreshArticles();
                this.props.onFetchAppLink();
            }
        };
    }
}
var $a31afb52b11d9ee2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($a31afb52b11d9ee2$export$cdc9d8ce4adcf011);
const $a31afb52b11d9ee2$var$DropdownContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$TextFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3izwfg _v69y1b66 _ogxmu2gc _1qtq1b66 _n9z4u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _80omtlke _syaz1gjq _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fbxu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$DescriptionV2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$EmptyStateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _4t3i1952",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$EmptyStateMiddleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _19pkv47k _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
});
const $a31afb52b11d9ee2$var$imgStyles = (0, $2s57o.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$ImgContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1lit _otyru2gc",
            __cmplp.className
        ])
    });
});
const $a31afb52b11d9ee2$var$confluenceUpsellContainerStyles = (0, $2s57o.xcss)({
    marginTop: 'space.300'
});
const $a31afb52b11d9ee2$var$topicSuggestedItemStyles = (0, $2s57o.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    padding: 'space.100',
    borderRadius: 'border.radius.200'
});
const $a31afb52b11d9ee2$var$topicSubtitleStyles = (0, $2s57o.xcss)({
    marginTop: 'space.100'
});
const $a31afb52b11d9ee2$var$actionBoxStyles = (0, $2s57o.xcss)({
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'space.100'
});
const $a31afb52b11d9ee2$var$aiFooterStyles = (0, $2s57o.xcss)({
    height: '24px',
    marginTop: 'space.100'
});
const $a31afb52b11d9ee2$var$topicSuggestedInlineStyles = (0, $2s57o.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$CreateArticleLinkButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _1xdi1txw _18vq1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$SearchContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pk1ejb _2hwxidpf _otyrv47k _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a31afb52b11d9ee2$var$SearchContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $a31afb52b11d9ee2$var$SearchContainer = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $a31afb52b11d9ee2$var$SearchContainerNew, $a31afb52b11d9ee2$var$SearchContainerOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a31afb52b11d9ee2$var$ActionsGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_9eb86w": (0, $lD23V.default)(__cmplp.spacing === 'wide' ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1ko9chmj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ieYuw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4787521ed6b60ff$var$_react = $d4787521ed6b60ff$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d4787521ed6b60ff$var$_close = $d4787521ed6b60ff$var$_interopRequireDefault((parcelRequire("eh9vz")));

var $d4787521ed6b60ff$var$_close2 = $d4787521ed6b60ff$var$_interopRequireDefault((parcelRequire("gKTT6")));
function $d4787521ed6b60ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4787521ed6b60ff$var$CloseIcon = (props)=>/*#__PURE__*/ $d4787521ed6b60ff$var$_react.default.createElement($d4787521ed6b60ff$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $d4787521ed6b60ff$var$_close2.default
    }, props));
$d4787521ed6b60ff$var$CloseIcon.Name = 'CloseIconMigration';
var $d4787521ed6b60ff$var$_default = module.exports.default = $d4787521ed6b60ff$var$CloseIcon;

});

parcelRegister("b6xHZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b31c44090aaef867aaef7692fca9a50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $815a670b55a04fc7$var$_react = $815a670b55a04fc7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $815a670b55a04fc7$var$_page = $815a670b55a04fc7$var$_interopRequireDefault((parcelRequire("4HiZI")));

var $815a670b55a04fc7$var$_document = $815a670b55a04fc7$var$_interopRequireDefault((parcelRequire("gafHb")));
function $815a670b55a04fc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesDocumentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $815a670b55a04fc7$var$PageIcon = (props)=>/*#__PURE__*/ $815a670b55a04fc7$var$_react.default.createElement($815a670b55a04fc7$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $815a670b55a04fc7$var$_document.default
    }, props));
$815a670b55a04fc7$var$PageIcon.Name = 'PageIconMigration';
var $815a670b55a04fc7$var$_default = module.exports.default = $815a670b55a04fc7$var$PageIcon;

});
parcelRegister("gafHb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc49c14e7a2e7096$var$_react = $bc49c14e7a2e7096$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $bc49c14e7a2e7096$var$_page = $bc49c14e7a2e7096$var$_interopRequireDefault((parcelRequire("4HiZI")));
function $bc49c14e7a2e7096$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc49c14e7a2e7096$var$MediaServicesDocumentIcon = (props)=>/*#__PURE__*/ $bc49c14e7a2e7096$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="10" height="2" x="7" y="8" fill="inherit" rx="1"/><rect width="10" height="2" x="7" y="11" fill="inherit" rx="1"/><rect width="5" height="2" x="7" y="14" fill="inherit" rx="1"/></g></svg>`
    }, props, {
        newIcon: $bc49c14e7a2e7096$var$_page.default
    }));
$bc49c14e7a2e7096$var$MediaServicesDocumentIcon.displayName = 'MediaServicesDocumentIcon';
var $bc49c14e7a2e7096$var$_default = module.exports.default = $bc49c14e7a2e7096$var$MediaServicesDocumentIcon;

});


parcelRegister("8n9Eh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef60ceb7a2a29db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $6P0Kj = parcelRequire("6P0Kj");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $az4zD = parcelRequire("az4zD");

var $jsotm = parcelRequire("jsotm");
const $0ef60ceb7a2a29db$export$2c7b2957f409c48f = ({ href: href, children: children, intl: intl, onClick: onClick, appearance: appearance, spacing: spacing, showShortcutIcon: showShortcutIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        tag: "span",
        content: intl.formatMessage((0, $jsotm.default).opensInNewWindow),
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        href: href,
        appearance: appearance,
        target: "_blank",
        spacing: spacing,
        onClick: onClick,
        iconAfter: showShortcutIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $0ef60ceb7a2a29db$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            label: intl.formatMessage((0, $jsotm.default).opensInNewWindow)
        })) : undefined
    }, children));
$0ef60ceb7a2a29db$export$2c7b2957f409c48f.defaultProps = {
    onClick: undefined,
    showShortcutIcon: true,
    appearance: 'link',
    spacing: 'none'
};
var $0ef60ceb7a2a29db$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($0ef60ceb7a2a29db$export$2c7b2957f409c48f);
const $0ef60ceb7a2a29db$var$iconContainerStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("jsotm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15876084b060a35f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15876084b060a35f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    opensInNewWindow: {
        "id": "packages-components-external-link-button.opens-in-new-window",
        "defaultMessage": "Opens in a new window"
    }
});

});


parcelRegister("bPEAu", function(module, exports) {

$parcel$export(module.exports, "CreateArticleButton", () => $4f6e7c1b7c412477$export$f5c14624fc49c9fb);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");
var $i95f5 = parcelRequire("i95f5");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $5eEzC = parcelRequire("5eEzC");

var $lw2HC = parcelRequire("lw2HC");

var $k1uJZ = parcelRequire("k1uJZ");

var $byhrn = parcelRequire("byhrn");
const $4f6e7c1b7c412477$export$f5c14624fc49c9fb = ({ spaces: spaces, appearance: appearance = 'primary', children: children, hasConfluenceLicense: hasConfluenceLicense, isJcs: isJcs, helpCenterId: helpCenterId })=>{
    const intl = (0, $koVbs.default)();
    const [showModal, toggleModal] = (0, $5uXOq.useState)(false);
    const [isFetchingDraftDetails] = (0, $lw2HC.useIsFetchingDraftDetails)();
    const { navigateToEditor: navigateToEditor } = (0, $5eEzC.useNavigateToEditor)({
        spaces: spaces,
        isJcs: isJcs,
        helpCenterId: helpCenterId
    });
    const showCreateArticleModal = (e, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'createArticleBtn clicked', {
            hasConfluenceLicense: Boolean(hasConfluenceLicense)
        });
        if (spaces.length === 1) navigateToEditor();
        else toggleModal(true);
    };
    const hideCreateArticleModal = ()=>{
        toggleModal(false);
    };
    const isSSR = false;
    const text = children !== undefined ? children : intl.formatMessage((0, $k1uJZ.default).text);
    return !isSSR && spaces.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spaces.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: appearance,
        onClick: showCreateArticleModal,
        isLoading: isFetchingDraftDetails
    }, text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: appearance,
        onClick: showCreateArticleModal
    }, text), showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byhrn.CreateArticleModal), {
        onCancel: hideCreateArticleModal,
        isJcs: isJcs,
        helpCenterId: helpCenterId
    })) : null;
};

});
parcelRegister("5eEzC", function(module, exports) {

$parcel$export(module.exports, "useNavigateToEditor", () => $d35a8ee373bc035a$export$bd39fc26850ad4a0);

var $bngFq = parcelRequire("bngFq");

var $gq0sA = parcelRequire("gq0sA");

var $doZTA = parcelRequire("doZTA");

var $lw2HC = parcelRequire("lw2HC");
const $d35a8ee373bc035a$export$bd39fc26850ad4a0 = ({ spaces: spaces, topicId: topicId, topicName: topicName, isJcs: isJcs, helpCenterId: helpCenterId })=>{
    const [, { fetchDraftAndNavigateToEditor: fetchDraftAndNavigateToEditor }] = (0, $lw2HC.useIsPermittedSpaces)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const [routerState, routerActions] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const navigateToEditor = ()=>{
        const { projectContext: projectContext } = pageContextData || {};
        const { projectKey: projectKey, projectId: projectId } = projectContext || {};
        const [{ spaceKey: spaceKey }] = spaces;
        projectKey && projectId && fetchDraftAndNavigateToEditor({
            spaceKey: spaceKey,
            routerActions: routerActions,
            projectKey: projectKey,
            projectId: projectId,
            onCloseRedirectUrl: routerState.location.pathname,
            analyticsEvent: createAnalyticsEvent({}),
            topicId: topicId,
            topicName: topicName,
            isJcs: isJcs,
            helpCenterId: helpCenterId
        });
    };
    return {
        navigateToEditor: navigateToEditor
    };
};

});

parcelRegister("k1uJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b2097b861ad43d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b2097b861ad43d4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    text: {
        "id": "servicedesk-knowledge-common.create-article-button.text",
        "defaultMessage": "Create article"
    }
});

});

parcelRegister("byhrn", function(module, exports) {

$parcel$export(module.exports, "CreateArticleModal", () => $2684c4d3c9ab97e5$export$d133e5d0f26fab46);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $i95f5 = parcelRequire("i95f5");

var $bWfiu = parcelRequire("bWfiu");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $lau8t = parcelRequire("lau8t");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $bngFq = parcelRequire("bngFq");

var $gq0sA = parcelRequire("gq0sA");

var $doZTA = parcelRequire("doZTA");

var $lw2HC = parcelRequire("lw2HC");

var $bl4L1 = parcelRequire("bl4L1");
const $2684c4d3c9ab97e5$export$3d931b64f46140b3 = `${(0, $gwIPs.gridSize) * 51}px`;
const $2684c4d3c9ab97e5$export$d133e5d0f26fab46 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onCancel: onCancel, topicId: topicId, topicName: topicName, isJcs: isJcs, helpCenterId: helpCenterId } = props;
    const [routerState, routerActions] = (0, $doZTA.useRouter)();
    const [selectedSpaceKey, updateSelectedSpaceKey] = (0, $5uXOq.useState)('');
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectId: projectId } = projectContext || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isFetchingDraftDetails, { fetchDraftAndNavigateToEditor: fetchDraftAndNavigateToEditor }] = (0, $lw2HC.useIsFetchingDraftDetails)();
    const [{ data: userPermissionData }] = (0, $lw2HC.useUserCapabilities)();
    const { spaceUserCapabilities: { editableSpaces: editableSpaces } } = userPermissionData;
    const fetchDraftAndNavigateToRoute = async ()=>{
        fetchDraftAndNavigateToEditor({
            spaceKey: selectedSpaceKey,
            routerActions: routerActions,
            projectKey: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectKey,
            projectId: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
            projectId,
            onCloseRedirectUrl: routerState.location.pathname,
            analyticsEvent: createAnalyticsEvent({}),
            topicId: topicId,
            topicName: topicName,
            isJcs: isJcs,
            helpCenterId: helpCenterId
        });
    };
    const onSpaceChanged = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option' && newValue) {
            const selectedValue = newValue.value;
            updateSelectedSpaceKey(selectedValue);
        }
    };
    const options = editableSpaces.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
            label: spaceName,
            value: spaceKey
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "createArticle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "servicedesk-knowledge-common.ui.create-article-button.modal.ak-modal-dialog",
        messageType: "transactional",
        autoFocus: true,
        onClose: onCancel,
        shouldCloseOnOverlayClick: !isFetchingDraftDetails,
        shouldCloseOnEscapePress: !isFetchingDraftDetails,
        width: $2684c4d3c9ab97e5$export$3d931b64f46140b3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, formatMessage((0, $bl4L1.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2684c4d3c9ab97e5$var$DropdownText, {
        htmlFor: "space-name-dropdown-field"
    }, formatMessage((0, $bl4L1.default).selectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        placeholder: formatMessage((0, $bl4L1.default).selectPlaceholder),
        options: options,
        onChange: onSpaceChanged,
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        },
        autoFocus: true,
        isDisabled: isFetchingDraftDetails,
        inputId: "space-name-dropdown-field"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle",
        onClick: onCancel,
        isDisabled: isFetchingDraftDetails
    }, formatMessage((0, $bl4L1.default).cancelBtnText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "primary",
        onClick: fetchDraftAndNavigateToRoute,
        isLoading: isFetchingDraftDetails,
        isDisabled: !selectedSpaceKey.length
    }, formatMessage((0, $bl4L1.default).nextBtnText))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $2684c4d3c9ab97e5$var$dropdownTextStyles = null;
const $2684c4d3c9ab97e5$var$DropdownText = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: props.htmlFor,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _19pkidpf _syaz1gjq _1p1dglyw _otyru2gc"
        ])
    }, props.children));

});
parcelRegister("bl4L1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd29a61777741ba6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd29a61777741ba6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "servicedesk-knowledge-common.create-article-button.modal.heading",
        "defaultMessage": "Create article"
    },
    selectLabel: {
        "id": "servicedesk-knowledge-common.create-article-button.modal.select-label",
        "defaultMessage": "Select a knowledge base space"
    },
    selectPlaceholder: {
        "id": "servicedesk-knowledge-common.create-article-button.modal.select-placeholder",
        "defaultMessage": "Enter a space name"
    },
    cancelBtnText: {
        "id": "servicedesk-knowledge-common.create-article-button.modal.cancel-btn-text",
        "defaultMessage": "Cancel"
    },
    nextBtnText: {
        "id": "servicedesk-knowledge-common.create-article-button.modal.next-btn-text",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("fORah", function(module, exports) {

$parcel$export(module.exports, "CreateArticleAction", () => $cccb06b5d1bca483$export$3faaabd45e54eee);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $inni2 = parcelRequire("inni2");
var $Pxnvj = parcelRequire("Pxnvj");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $5eEzC = parcelRequire("5eEzC");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7mPT9 = parcelRequire("7mPT9");

var $1Rnsx = parcelRequire("1Rnsx");


var $3OKBN = parcelRequire("3OKBN");

var $WMe2e = parcelRequire("WMe2e");

var $gJ4wc = parcelRequire("gJ4wc");
const $cccb06b5d1bca483$export$3faaabd45e54eee = ({ topicId: topicId, hasConfluenceLicense: hasConfluenceLicense, spaces: spaces, topicName: topicName, numberOfRelatedTickets: numberOfRelatedTickets, aiDraftArticleGenerationState: aiDraftArticleGenerationState, onToggleRightDrawer: onToggleRightDrawer, isRightDrawerOpen: isRightDrawerOpen, getAIDraftContent: getAIDraftContent, aiDraftContent: aiDraftContent, rowIndex: rowIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isDrawerOpen, toggleDrawer] = (0, $5uXOq.useState)(false);
    const createArticleButtonRef = (0, $5uXOq.useRef)(null);
    const initialRender = (0, $5uXOq.useRef)(true);
    const { navigateToEditor: navigateToEditor } = (0, $5eEzC.useNavigateToEditor)({
        spaces: spaces,
        topicId: topicId,
        topicName: topicName
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!initialRender.current && !isDrawerOpen && createArticleButtonRef.current) createArticleButtonRef.current.focus();
        initialRender.current = false;
    }, [
        isDrawerOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        toggleDrawer(false);
        onToggleRightDrawer(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createArticleDrawer closed');
    }, [
        toggleDrawer,
        onToggleRightDrawer
    ]);
    const showDrawer = ()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createArticleBtnForTopic clicked', {
            triggeredBy: 'actions-create-article-button',
            hasConfluenceLicense: hasConfluenceLicense,
            topicId: topicId,
            aiDraftArticleGenerationState: aiDraftArticleGenerationState
        });
        if (spaces.length === 1 && aiDraftArticleGenerationState !== 'COMPLETED') navigateToEditor();
        else {
            toggleDrawer(true);
            onToggleRightDrawer(true);
        }
    };
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            topicId: topicId,
            topicName: topicName,
            numberOfRelatedTickets: numberOfRelatedTickets,
            spaces: spaces,
            aiDraftArticleGenerationState: aiDraftArticleGenerationState,
            onClose: onClose,
            getAIDraftContent: getAIDraftContent,
            aiDraftContent: aiDraftContent
        }), [
        topicId,
        topicName,
        numberOfRelatedTickets,
        spaces,
        aiDraftArticleGenerationState,
        onClose,
        getAIDraftContent,
        aiDraftContent
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3OKBN.CreateArticleDrawerEntryPoint), entryPointProps);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, rowIndex === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "aiDraftGenChangeBoarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        onClick: showDrawer,
        ref: (0, $7mPT9.mergeRefs)(createArticleButtonRef, triggerRef),
        isDisabled: isRightDrawerOpen,
        interactionName: "jsm-kb-view-ai-draft-drawer"
    }, formatMessage((0, $WMe2e.default).viewDraft))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Rnsx.default), {
        delay: 2000
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJ4wc.AiDraftGenChangeBoarding), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        onClick: showDrawer,
        ref: (0, $7mPT9.mergeRefs)(createArticleButtonRef, triggerRef),
        isDisabled: isRightDrawerOpen,
        interactionName: "jsm-kb-view-ai-draft-drawer"
    }, formatMessage((0, $WMe2e.default).viewDraft)), isDrawerOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "createArticleDrawerEntryPoint",
        packageName: (0, $abd8c4ced6efb751$export$b8b9d90f9e5bd72b),
        teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f),
        runtimeProps: {
            onClose: onClose,
            topicId: topicId,
            topicName: topicName,
            numberOfRelatedTickets: numberOfRelatedTickets,
            spaces: spaces,
            aiDraftArticleGenerationState: aiDraftArticleGenerationState,
            getAIDraftContent: getAIDraftContent,
            aiDraftContent: aiDraftContent
        }
    }));
};

});
parcelRegister("1Rnsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4456bc9cf107df$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $3c4456bc9cf107df$var$RenderNextAnimationFrame = ({ delay: delay, children: children })=>{
    const [render, setRender] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const renderNextAnimationFrame = ()=>{
            globalThis.window.requestAnimationFrame(()=>{
                globalThis.window.requestAnimationFrame(()=>{
                    setRender(true);
                });
            });
        };
        if (delay) {
            const timer = globalThis.window.setTimeout(renderNextAnimationFrame, delay);
            return ()=>clearTimeout(timer);
        }
        renderNextAnimationFrame();
    }, [
        delay
    ]);
    return render ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children()) : null;
};
var $3c4456bc9cf107df$export$2e2bcd8739ae039 = $3c4456bc9cf107df$var$RenderNextAnimationFrame;

});

const $abd8c4ced6efb751$export$d57b6b390e78d90f = 'jsm-nebula';
const $abd8c4ced6efb751$export$5631491ed07b4a08 = 10;
const $abd8c4ced6efb751$export$b8b9d90f9e5bd72b = '@atlassian/jira-servicedesk-knowledge-performance';

parcelRegister("3OKBN", function(module, exports) {

$parcel$export(module.exports, "CreateArticleDrawerEntryPoint", () => $83c699c95e6411d7$export$6eeb12dc76919be9);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $83c699c95e6411d7$export$6eeb12dc76919be9 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("luHBu")), {
        moduleId: "66763dc1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("luHBu", function(module, exports) {

let $fa5e391767476830$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa5e391767476830$var$load("djMfZ").then(()=>parcelRequire('9wJtB'));

});


parcelRegister("WMe2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c97f03202691674b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c97f03202691674b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewDraft: {
        "id": "servicedesk-knowledge-performance.suggested-topics-table.create-article.view-draft",
        "defaultMessage": "View draft"
    }
});

});

parcelRegister("gJ4wc", function(module, exports) {

$parcel$export(module.exports, "AiDraftGenChangeBoarding", () => $36ce0c916d748455$export$b31c34ca29f43b4f);

var $5uXOq = parcelRequire("5uXOq");

var $98UVV = parcelRequire("98UVV");

var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ehdJY = parcelRequire("ehdJY");

var $5QsHM = parcelRequire("5QsHM");

var $kFeWJ = parcelRequire("kFeWJ");


var $lUaLL = parcelRequire("lUaLL");
const $36ce0c916d748455$var$Target = 'aiDraftGenChangeBoarding';
const $36ce0c916d748455$var$MESSAGE_ID = 'jsm-kb-article-gen-changeboarding';
const $36ce0c916d748455$export$b31c34ca29f43b4f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: $36ce0c916d748455$var$MESSAGE_ID,
        isSeenValue: true,
        packageName: (0, $abd8c4ced6efb751$export$b8b9d90f9e5bd72b),
        teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
    });
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSeenSpotlight) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'aiDraftGenChangeBoarding'
        }));
    }, [
        createAnalyticsEvent,
        hasSeenSpotlight
    ]);
    const onEndTour = ()=>{
        markSpotlightAsSeen();
        setIsSpotlightActive(false);
    };
    return !hasSeenSpotlight && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        testId: $36ce0c916d748455$var$Target,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($kFeWJ))),
        heading: formatMessage((0, $lUaLL.default).spotlightTitle),
        actions: [
            {
                onClick: onEndTour,
                text: formatMessage((0, $lUaLL.default).spotlightCta)
            }
        ],
        dialogPlacement: "bottom right",
        target: $36ce0c916d748455$var$Target,
        targetRadius: 3,
        dialogWidth: 270,
        messageId: "servicedesk-knowledge-performance.ui.suggested-topics-table.create-article.ai-draft-gen-change-boarding.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, formatMessage((0, $lUaLL.default).spotlightDescription))));
};

});
parcelRegister("5QsHM", function(module, exports) {

$parcel$export(module.exports, "useSeenStatus", () => $36807a4a4f35954c$export$12667e37571b0a02);

var $5uXOq = parcelRequire("5uXOq");


var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");
const $36807a4a4f35954c$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $36807a4a4f35954c$export$f7ab30339d40bcd = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $36807a4a4f35954c$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName, skipOnboarding: skipOnboarding })=>{
    const [state, setState] = (0, $5uXOq.useState)($36807a4a4f35954c$var$initialState);
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const reportErrorDeps = (0, $5uXOq.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $5uXOq.useCallback)((errorId, error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $89SaW.getUserProperty)(accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent,
        skipOnboarding
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $89SaW.setUserProperties)(accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $jJZqs.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError,
        skipOnboarding
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});

parcelRegister("kFeWJ", function(module, exports) {
module.exports = new URL("ai-draft-gen-onboarding.6ab5a78a.svg", import.meta.url).toString();

});

parcelRegister("lUaLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $66629a5c426797bb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $66629a5c426797bb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightTitle: {
        "id": "servicedesk-knowledge-performance.suggested-topics-table.create-article.create-article.ai-draft-gen-change-boarding.spotlight-title",
        "defaultMessage": "AI drafts to save time"
    },
    spotlightDescription: {
        "id": "servicedesk-knowledge-performance.suggested-topics-table.create-article.create-article.ai-draft-gen-change-boarding.spotlight-description",
        "defaultMessage": "We've made it easier to write knowledge article with pre-generated drafts for the most common requests in your project."
    },
    spotlightCta: {
        "id": "servicedesk-knowledge-performance.suggested-topics-table.create-article.create-article.ai-draft-gen-change-boarding.spotlight-cta",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("2YBWI", function(module, exports) {

$parcel$export(module.exports, "AiFooter", () => $3e82455ec7fd6882$export$915814a2dcce5cf0);

var $5uXOq = parcelRequire("5uXOq");

var $c1WlH = parcelRequire("c1WlH");

var $k01Ou = parcelRequire("k01Ou");

var $eOat1 = parcelRequire("eOat1");

var $eWkgo = parcelRequire("eWkgo");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $gHU1R = parcelRequire("gHU1R");

var $cBCgC = parcelRequire("cBCgC");

var $koVbs = parcelRequire("koVbs");

var $2m0b6 = parcelRequire("2m0b6");

var $l9x5I = parcelRequire("l9x5I");
const $3e82455ec7fd6882$var$ATLASSIAN_INTELLIGENCE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/';
const $3e82455ec7fd6882$var$AIFooterThreshold = {
    SMALL: 280,
    MEDIUM: 328,
    LARGE: 624
};
const $3e82455ec7fd6882$export$915814a2dcce5cf0 = ({ testId: testId, isBeta: isBeta = true, showDisclaimer: showDisclaimer = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerContainer = (0, $5uXOq.useRef)(null);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        if (footerContainer.current) {
            const { offsetWidth: offsetWidth } = footerContainer.current;
            if (showDisclaimer) {
                if (offsetWidth > $3e82455ec7fd6882$var$AIFooterThreshold.LARGE) {
                    setDisplayedAttribution((0, $l9x5I.default).longAttributionText);
                    setDisplayedDisclaimer((0, $l9x5I.default).longDisclaimerText);
                } else if (offsetWidth > $3e82455ec7fd6882$var$AIFooterThreshold.MEDIUM) {
                    setDisplayedAttribution((0, $l9x5I.default).shortAttributionText);
                    setDisplayedDisclaimer((0, $l9x5I.default).disclaimerText);
                } else {
                    setDisplayedAttribution(null);
                    setDisplayedDisclaimer((0, $l9x5I.default).disclaimerText);
                }
            } else if (offsetWidth > $3e82455ec7fd6882$var$AIFooterThreshold.SMALL) setDisplayedAttribution((0, $l9x5I.default).longAttributionText);
            else setDisplayedAttribution((0, $l9x5I.default).shortAttributionText);
        }
    }, [
        showDisclaimer
    ]);
    const [displayedAttribution, setDisplayedAttribution] = (0, $5uXOq.useState)(null);
    const [displayedDisclaimer, setDisplayedDisclaimer] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        onResize();
    }, [
        onResize
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: footerContainer,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        testId: testId,
        xcss: $3e82455ec7fd6882$var$footerStyle,
        spread: "space-between",
        alignBlock: "center",
        ref: footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center",
        gap: "space.050"
    }, isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        testId: "atlassian-intelligence.common.ui.ai-footer.beta-lozenge",
        appearance: "default"
    }, formatMessage((0, $l9x5I.default).betaLozenge)), displayedDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        label: formatMessage((0, $l9x5I.default).infoIconLabel),
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)",
        testId: "atlassian-intelligence.common.ui.ai-footer.info-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gHU1R.default), {
        xcss: $3e82455ec7fd6882$var$linkStyle,
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.disclaimer-text"
    }, formatMessage(displayedDisclaimer)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gHU1R.default), {
        xcss: $3e82455ec7fd6882$var$linkStyle,
        href: $3e82455ec7fd6882$var$ATLASSIAN_INTELLIGENCE_LINK,
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.attribution-link"
    }, displayedAttribution ? formatMessage(displayedAttribution) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cBCgC.default), null, formatMessage((0, $l9x5I.default).longAttributionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1WlH))), {
        label: formatMessage((0, $l9x5I.default).aiIconLabel),
        spacing: "spacious"
    })));
};
const $3e82455ec7fd6882$var$footerStyle = (0, $2s57o.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingInline: 'space.150',
    paddingBlock: 'space.050'
});
const $3e82455ec7fd6882$var$linkStyle = (0, $2s57o.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("c1WlH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c22d6edca06843c$var$_react = $8c22d6edca06843c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c22d6edca06843c$var$_baseNew = $8c22d6edca06843c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8c22d6edca06843c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c22d6edca06843c$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $8c22d6edca06843c$var$_react.default.createElement($8c22d6edca06843c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$8c22d6edca06843c$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $8c22d6edca06843c$var$_default = module.exports.default = $8c22d6edca06843c$var$AtlassianIntelligenceIcon;

});

parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("l9x5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8aa0e93e9bc458$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7f8aa0e93e9bc458$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    betaLozenge: {
        "id": "atlassian-intelligence.common.ai-footer.beta-lozenge",
        "defaultMessage": "Beta"
    },
    disclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.disclaimer-text",
        "defaultMessage": "Content quality may vary"
    },
    longDisclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.long-disclaimer-text",
        "defaultMessage": "Content is based on your permissions, and its quality may vary"
    },
    shortAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.short-attribution-text",
        "defaultMessage": "Powered by AI"
    },
    longAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.long-attribution-text",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    infoIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.info-icon-label",
        "defaultMessage": "Info"
    },
    aiIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.ai-icon-label",
        "defaultMessage": "Atlassian Intelligence"
    }
});

});


parcelRegister("01ehM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa13ece35ec61c84$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fCYod = parcelRequire("fCYod");

var $8NcsG = parcelRequire("8NcsG");
const $fa13ece35ec61c84$var$mapStateToProps = (state)=>({
        appLinkOrError: (0, $fCYod.getAppLinkOrError)(state)
    });
const $fa13ece35ec61c84$var$Connected = (0, $bC2fB.connect)($fa13ece35ec61c84$var$mapStateToProps, {})((0, $8NcsG.default));
var $fa13ece35ec61c84$export$2e2bcd8739ae039 = $fa13ece35ec61c84$var$Connected;

});
parcelRegister("8NcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $108df07c81877786$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $clxo5 = parcelRequire("clxo5");

var $h6QPt = parcelRequire("h6QPt");

var $fxVD7 = parcelRequire("fxVD7");

var $OuhAr = parcelRequire("OuhAr");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $108df07c81877786$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $108df07c81877786$export$42e634e63dba5325 = ({ appLinkOrError: appLinkOrError, children: children, onAuthComplete: onAuthComplete })=>{
    if (!appLinkOrError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($108df07c81877786$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large",
        delay: 300
    }));
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'AppLink | AppLinkError'.
    if (appLinkOrError.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxVD7.default), null);
    // @ts-expect-error - TS2339 - Property 'requireCredentials' does not exist on type 'AppLink | AppLinkError'.
    if (appLinkOrError.requireCredentials) {
        const onAuthenticate = async ()=>{
            try {
                // @ts-expect-error - TS2339 - Property 'authUrl' does not exist on type 'AppLink | AppLinkError'.
                await (0, $h6QPt.default)(appLinkOrError.authUrl);
                onAuthComplete();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                onAuthComplete(error);
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $OuhAr.default), {
            onAuthenticate: onAuthenticate
        });
    }
    return children;
};
var $108df07c81877786$export$2e2bcd8739ae039 = $108df07c81877786$export$42e634e63dba5325;

});
parcelRegister("h6QPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c756de6db687f03$export$2e2bcd8739ae039);
/**
    This function is in order to encapsulate the behavior of the AppLinksUtils functionality

    AppLinksUtils is an Atlassian Plugin.

    AppLinks repository: https://bitbucket.org/atlassian/application-links
 */ /**
    The following function implements the same interface as the [OAuthCallback object](https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-plugin/src/main/resources/applinks/internal/feature/oauth/oauth-callback.js?at=master)

    It creates the object, assigns the object to a global variable in window and calls the plugin in a new window

    Once the Authentication dance is perform, the opened window will call success or failure callbacks from the window.opener.oauthCallback (https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-oauth-plugin/src/main/resources/com/atlassian/applinks/oauth/auth/oauth-dance.js?at=master)
 */ const $0c756de6db687f03$var$authenticateUsingAppLinks = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.oauthCallback) // preventing opening more than one authentication at the time.
    return null;
    const result = new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject)=>{
        let oauthWindow;
        let timer;
        let isPending = true;
        const oauthCallback = {
            success: ()=>{
                clearInterval(timer);
                // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                resolve();
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            },
            failure: ()=>{
                clearInterval(timer);
                reject(Error('Failed to authenticate with applinks'));
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.oauthCallback = oauthCallback;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
        timer = setInterval(()=>{
            if (oauthWindow && oauthWindow.closed && isPending) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                reject(Error('Failed to authenticate with applinks'));
                clearInterval(timer);
            }
        }, 500);
    });
    return result;
};
var $0c756de6db687f03$export$2e2bcd8739ae039 = $0c756de6db687f03$var$authenticateUsingAppLinks;

});

parcelRegister("fxVD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $112a70946b83e16d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6z7Gx = parcelRequire("6z7Gx");

var $cIhXH = parcelRequire("cIhXH");
const $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
        data: {
            attributes: {
                context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cIhXH.default), props));
var $112a70946b83e16d$export$2e2bcd8739ae039 = $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics;

});
parcelRegister("cIhXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $889aaaaf1f3263e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $75gFv = parcelRequire("75gFv");

var $13x0I = parcelRequire("13x0I");

var $hW1Vu = parcelRequire("hW1Vu");
const $889aaaaf1f3263e7$export$e0621c26812fcde2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75gFv))),
        header: formatMessage((0, $hW1Vu.default).applinkErrorHeader),
        description: formatMessage((0, $hW1Vu.default).applinkErrorMessage)
    });
};
var $889aaaaf1f3263e7$export$2e2bcd8739ae039 = $889aaaaf1f3263e7$export$e0621c26812fcde2;

});
parcelRegister("hW1Vu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbfeba0604b7d141$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fbfeba0604b7d141$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    applinkErrorHeader: {
        "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-header",
        "defaultMessage": "We couldn\u2019t load this article"
    },
    applinkErrorMessage: {
        "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-message",
        "defaultMessage": "Refresh and try again"
    }
});

});



parcelRegister("OuhAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $19f2d1dc625a92a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $6z7Gx = parcelRequire("6z7Gx");

var $8xabp = parcelRequire("8xabp");
const $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
        data: {
            context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xabp.default), props));
var $19f2d1dc625a92a7$export$2e2bcd8739ae039 = $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics;

});
parcelRegister("8xabp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4394b6b9f879006e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $dU448 = parcelRequire("dU448");

var $koVbs = parcelRequire("koVbs");

var $i9Ubb = parcelRequire("i9Ubb");

var $13x0I = parcelRequire("13x0I");

var $jam2I = parcelRequire("jam2I");
const $4394b6b9f879006e$export$9277c11b36960dfe = ({ onAuthenticate: onAuthenticate })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onActionClick = ()=>{
        onAuthenticate();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i9Ubb))),
        header: "",
        description: formatMessage((0, $jam2I.default).pageDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dU448))), {
                label: "authenticate"
            }),
            appearance: "primary",
            onClick: onActionClick
        }, formatMessage((0, $jam2I.default).primaryAction))
    });
};
var $4394b6b9f879006e$export$2e2bcd8739ae039 = $4394b6b9f879006e$export$9277c11b36960dfe;

});
parcelRegister("dU448", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7d30dad6d1ac9ad16d909c6f786d22d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1f3a8ad650bd465$var$_react = $a1f3a8ad650bd465$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1f3a8ad650bd465$var$_lockLocked = $a1f3a8ad650bd465$var$_interopRequireDefault((parcelRequire("5DSGX")));

var $a1f3a8ad650bd465$var$_lockFilled = $a1f3a8ad650bd465$var$_interopRequireDefault((parcelRequire("88ixi")));
function $a1f3a8ad650bd465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1f3a8ad650bd465$var$LockLockedIcon = (props)=>/*#__PURE__*/ $a1f3a8ad650bd465$var$_react.default.createElement($a1f3a8ad650bd465$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $a1f3a8ad650bd465$var$_lockFilled.default
    }, props));
$a1f3a8ad650bd465$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $a1f3a8ad650bd465$var$_default = module.exports.default = $a1f3a8ad650bd465$var$LockLockedIcon;

});
parcelRegister("5DSGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41bb04ef30194277$var$_react = $41bb04ef30194277$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $41bb04ef30194277$var$_baseNew = $41bb04ef30194277$var$_interopRequireDefault((parcelRequire("enEmH")));
function $41bb04ef30194277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41bb04ef30194277$var$LockLockedIcon = (props)=>/*#__PURE__*/ $41bb04ef30194277$var$_react.default.createElement($41bb04ef30194277$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$41bb04ef30194277$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $41bb04ef30194277$var$_default = module.exports.default = $41bb04ef30194277$var$LockLockedIcon;

});

parcelRegister("88ixi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ebd72f7c13602db$var$_react = $5ebd72f7c13602db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5ebd72f7c13602db$var$_lockLocked = $5ebd72f7c13602db$var$_interopRequireDefault((parcelRequire("5DSGX")));
function $5ebd72f7c13602db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5ebd72f7c13602db$var$LockFilledIcon = (props)=>/*#__PURE__*/ $5ebd72f7c13602db$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $5ebd72f7c13602db$var$_lockLocked.default
    }));
$5ebd72f7c13602db$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $5ebd72f7c13602db$var$_default = module.exports.default = $5ebd72f7c13602db$var$LockFilledIcon;

});


parcelRegister("i9Ubb", function(module, exports) {
module.exports = new URL("authenticate-confluence.4d07da41.svg", import.meta.url).toString();

});

parcelRegister("jam2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $a812dd379bbb5f8f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a812dd379bbb5f8f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageDescription: {
        "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.page-description",
        "defaultMessage": "Authenticate with Confluence to access articles from your linked spaces."
    },
    primaryAction: {
        "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.primary-action",
        "defaultMessage": "Authenticate"
    }
});

});





parcelRegister("8WALy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4715523505b99e61$export$2e2bcd8739ae039);

var $9tOEo = parcelRequire("9tOEo");

var $6z7Gx = parcelRequire("6z7Gx");

var $axsl2 = parcelRequire("axsl2");
const $4715523505b99e61$var$ErrorPageWithAnalytics = (0, $9tOEo.default)({
    attributes: {
        context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
    }
})((0, $axsl2.default));
var $4715523505b99e61$export$2e2bcd8739ae039 = $4715523505b99e61$var$ErrorPageWithAnalytics;

});
parcelRegister("axsl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c66f766909105fb1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $cigQb = parcelRequire("cigQb");
var $4KBRy = parcelRequire("4KBRy");

var $hZHze = parcelRequire("hZHze");

var $jS4lj = parcelRequire("jS4lj");

var $6Ndma = parcelRequire("6Ndma");

var $8RXs9 = parcelRequire("8RXs9");


var $75gFv = parcelRequire("75gFv");

var $iDMMZ = parcelRequire("iDMMZ");

var $13x0I = parcelRequire("13x0I");

var $6geWD = parcelRequire("6geWD");
function $c66f766909105fb1$export$c120a0e80fd44ca6(props) {
    const { intl: intl, error: error, screenName: screenName, attributes: attributes } = props;
    const isKBRouteWithHorizontalNav = (0, $6Ndma.useIsKBRouteWithHorizontalNav)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
        data: {
            source: `${screenName}${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
            attributes: attributes ? {
                ...attributes
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cigQb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4KBRy.default), null, !isKBRouteWithHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6geWD.default), {
        // @ts-expect-error - TS2769 - No overload matches this call.
        truncateTitle: true,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13x0I.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75gFv))),
        header: intl.formatMessage(error.header),
        description: intl.formatMessage(error.message),
        primaryAction: error.ctaLink && error.ctaText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDMMZ.default), {
            to: error.ctaLink || ''
        }, intl.formatMessage(error.ctaText)) : undefined
    }))));
}
var $c66f766909105fb1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($c66f766909105fb1$export$c120a0e80fd44ca6);

});
parcelRegister("6Ndma", function(module, exports) {

$parcel$export(module.exports, "useIsKBRouteWithHorizontalNav", () => $76f1b69b9a6db003$export$49e43abdbfaa6622);

var $jIAHH = parcelRequire("jIAHH");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");
const $76f1b69b9a6db003$export$49e43abdbfaa6622 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    return (0, $3HwlS.getWillShowNav4)() && route.group === 'servicedesk' && HorizontalNavComponent === (0, $jIAHH.AsyncKbNav);
};

});



parcelRegister("500iy", function(module, exports) {

$parcel$export(module.exports, "articlesPageLoad", () => $9f4158c988d9e1fa$export$6f468438b9b40e19);

var $2nKjG = parcelRequire("2nKjG");
const $9f4158c988d9e1fa$export$6f468438b9b40e19 = (0, $2nKjG.metrics).pageLoad({
    key: 'service-management.knowledge.articles'
});

});



parcelRegister("2riGj", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubAppBase", () => $cda69d9cd68a5197$export$f848f52481042e56);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $e0Brz = parcelRequire("e0Brz");

var $gEFwt = parcelRequire("gEFwt");

var $kb4zh = parcelRequire("kb4zh");

var $9sGI6 = parcelRequire("9sGI6");

var $97Kan = parcelRequire("97Kan");

var $3HwlS = parcelRequire("3HwlS");

var $bngFq = parcelRequire("bngFq");

var $5MiFc = parcelRequire("5MiFc");

var $cf7yQ = parcelRequire("cf7yQ");

var $lw2HC = parcelRequire("lw2HC");

var $cbMay = parcelRequire("cbMay");

var $h4S6Q = parcelRequire("h4S6Q");

var $hYd1f = parcelRequire("hYd1f");

var $1eweq = parcelRequire("1eweq");

var $1xzCS = parcelRequire("1xzCS");

var $7FkcY = parcelRequire("7FkcY");

var $6GLlD = parcelRequire("6GLlD");

var $e33py = parcelRequire("e33py");

var $6FTcZ = parcelRequire("6FTcZ");

var $gq0sA = parcelRequire("gq0sA");

var $4S0uJ = parcelRequire("4S0uJ");

var $doZTA = parcelRequire("doZTA");
const $cda69d9cd68a5197$var$KnowledgeHubAppBaseView = (props)=>{
    const { initialActions: initialActions, KnowledgeHubContainer: KnowledgeHubContainer, appName: appName, shouldRemoveMargin: shouldRemoveMargin = false } = props;
    const [{ match: match, query: query }] = (0, $doZTA.useRouter)();
    const [{ data: pageContextData, error: pageContextError }] = (0, $gq0sA.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId } = projectContext || {};
    const [{ data: confluenceLink, error: confluenceLinkError }] = (0, $6FTcZ.useKbConfluenceContext)(projectKey);
    const [{ categories: categories, isCategoriesSupported: isCategoriesSupported }, { fetchCategories: fetchCategories }] = (0, $lw2HC.useCategoriesData)();
    const { activationId: activationId } = tenantContext || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) return;
        projectId && activationId && fetchCategories(projectId, createAnalyticsEvent({}), activationId);
    }, [
        projectId,
        fetchCategories,
        createAnalyticsEvent,
        activationId
    ]);
    if (!confluenceLink && !confluenceLinkError || !pageContextData && !pageContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stateAppProps = {
        app: {
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }
    };
    const CustomizedPageStyle = (0, $3HwlS.getWillShowNav4)() && shouldRemoveMargin ? (0, $0yZbT.default) : (0, $4S0uJ.PageStyle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GLlD.default), {
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KnowledgeHubContainer, {
        scope: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eweq.KnowledgeHubActionsSubscriber), null, (_, scopedKnowledgeActions)=>{
        const initialState = {
            ...scopedKnowledgeActions.getStoreState(),
            ...stateAppProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MiFc.ReduxConnector), {
            storeName: "servicedesk-knowledge-hub",
            initialState: initialState,
            rootReducer: (0, $1xzCS.default)(scopedKnowledgeActions.updateStore),
            rootEpic: (0, $hYd1f.default),
            initialActions: initialActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FkcY.default), {
            ...confluenceLink,
            categories: categories,
            isCategoriesSupported: isCategoriesSupported
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e33py.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2769 - No overload matches this call.
            projectName: projectName,
            section: "knowledge"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbMay.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            baseUrl: "",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectKey: projectKey,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            projectName: projectName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomizedPageStyle, null, props.children({
            match: match,
            query: query,
            pageContext: {
                ...stateAppProps.app
            }
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $h4S6Q.default)
        })));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null));
};
const $cda69d9cd68a5197$export$f848f52481042e56 = (0, $9sGI6.default)($cda69d9cd68a5197$var$KnowledgeHubAppBaseView, {
    initialActions: [],
    KnowledgeHubContainer: (0, $1eweq.KnowledgeHubContainer)
});
var $cda69d9cd68a5197$export$2e2bcd8739ae039 = $cda69d9cd68a5197$export$f848f52481042e56;

});
parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("5MiFc", function(module, exports) {

$parcel$export(module.exports, "ReduxConnector", () => $d6d887f51629efb1$export$c0c26a673bd1981c);

var $5uXOq = parcelRequire("5uXOq");

var $F2Mxm = parcelRequire("F2Mxm");

var $bC2fB = parcelRequire("bC2fB");
const $d6d887f51629efb1$export$c0c26a673bd1981c = ({ storeName: storeName, initialState: initialState, initialActions: initialActions, rootReducer: rootReducer, rootEpic: rootEpic, children: children })=>{
    // Guarantees store is created only once for component's lifespan
    const createStoreRef = (0, $5uXOq.useRef)(()=>(0, $F2Mxm.default)({
            appName: storeName,
            initialState: initialState,
            rootReducer: rootReducer,
            rootEpic: rootEpic
        }));
    // Guarantees same store is used throughout component's lifespan
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const store = (0, $5uXOq.useMemo)(createStoreRef.current, []);
    // Guarantees initial actions only get run once even if prop changes
    const initialActionsRef = (0, $5uXOq.useRef)(initialActions);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        initialActionsRef.current?.forEach((action)=>{
            store.dispatch(action());
        });
    }, [
        store
    ]);
    return(// ReduxProvider provides store only to first child. Using fragment so if multiple
    // children are given, all will get store context. Common case for this is when
    // FlagsDispatcher and app need to share the same store
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC2fB.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)));
};

});

parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("sXYgA")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2OvSt")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("f6mEW")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("1oRHz")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("sXYgA", function(module, exports) {

let $057122a3b41c04fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $057122a3b41c04fd$var$load("eNmuD"),
    $057122a3b41c04fd$var$load("chQyv")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("2OvSt", function(module, exports) {

let $20c8fa806ea6db90$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $20c8fa806ea6db90$var$load("eNmuD"),
    $20c8fa806ea6db90$var$load("cM9em"),
    $20c8fa806ea6db90$var$load("fr9NE"),
    $20c8fa806ea6db90$var$load("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("f6mEW", function(module, exports) {

let $afe8fe3c672ff16f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $afe8fe3c672ff16f$var$load("eNmuD"),
    $afe8fe3c672ff16f$var$load("cM9em"),
    $afe8fe3c672ff16f$var$load("fr9NE"),
    $afe8fe3c672ff16f$var$load("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("1oRHz", function(module, exports) {

let $1051b0675adbeaab$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1051b0675adbeaab$var$load("eNmuD"),
    $1051b0675adbeaab$var$load("cM9em"),
    $1051b0675adbeaab$var$load("fr9NE"),
    $1051b0675adbeaab$var$load("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("cbMay", function(module, exports) {

$parcel$export(module.exports, "default", () => $342ca5599182c99e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $825UM = parcelRequire("825UM");

var $ks7Ah = parcelRequire("ks7Ah");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$342ca5599182c99e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ks7Ah.default), null, ({ isOpen: isOpen, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $825UM.default), {
            isOpen: isOpen,
            onClose: onClose
        }));

});
parcelRegister("825UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d18ceb0644bdde$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $kW74I = parcelRequire("kW74I");


var $6z7Gx = parcelRequire("6z7Gx");

var $gq0sA = parcelRequire("gq0sA");

var $lVJAU = parcelRequire("lVJAU");

var $261Bl = parcelRequire("261Bl");

var $lw2HC = parcelRequire("lw2HC");

var $7U3kA = parcelRequire("7U3kA");
const $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [{ data: pageContextData }] = (0, $gq0sA.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const { projectId: projectId, projectKey: projectKey } = projectContext || {};
    const [{ isSubmitting: isSubmitting, formValues: formValues, error: error, createdCategory: createdCategory }, { createCategory: createCategory, handleFormInputChange: handleFormInputChange, resetCreatedCategory: resetCreatedCategory }] = (0, $lw2HC.useCreateCategoryData)();
    const activationId = tenantContext?.activationId || '';
    const isValid = !!formValues.name && formValues.name.length !== 0;
    const onChange = (field, value)=>{
        handleFormInputChange(field, value);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!createdCategory) return;
        onClose();
        resetCreatedCategory();
        push(`/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, $261Bl.categoryGuidToString)(createdCategory.id)}`);
    }, [
        createdCategory,
        projectKey,
        push,
        onClose,
        resetCreatedCategory
    ]);
    const onSubmit = (e, analyticsEvent)=>{
        e.preventDefault();
        if (isSubmitting || !isValid) return;
        projectId && createCategory(projectId, analyticsEvent, activationId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
        data: {
            source: `knowledgeCreateCategory${(0, $4d5e0871c06cee03$export$1171103ea9083ffa)}`,
            actionSubject: 'category',
            attributes: {
                context: (0, $6z7Gx.ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7U3kA.default), {
        onChange: onChange,
        onClose: onClose,
        onSubmit: onSubmit,
        formValues: formValues,
        formError: error.formError,
        fieldErrors: error.fieldErrors,
        isSubmitting: isSubmitting,
        isDisabled: !isValid
    })));
};
var $a6d18ceb0644bdde$export$2e2bcd8739ae039 = $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory;

});
parcelRegister("7U3kA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ae948e58435135$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");
var $i95f5 = parcelRequire("i95f5");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $7NYq5 = parcelRequire("7NYq5");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $9oIFN = parcelRequire("9oIFN");

var $5TOVG = parcelRequire("5TOVG");
const $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSubmitting: isSubmitting = false, isDisabled: isDisabled = false, onChange: onChange, onClose: onClose, onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "servicedesk-knowledge-common.ui.create-category.create-category-stateless.modal-dialog",
        messageType: "transactional",
        onClose: onClose,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, formatMessage((0, $5TOVG.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9oIFN.default), {
        onChange: onChange,
        onSubmit: onSubmit,
        formError: formError,
        fieldErrors: fieldErrors,
        isDisabled: isSubmitting
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "primary",
        onClick: onSubmit,
        isLoading: isSubmitting,
        isDisabled: isDisabled
    }, formatMessage((0, $5TOVG.default).createAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: onClose
    }, formatMessage((0, $5TOVG.default).cancelAction)))));
};
var $c2ae948e58435135$export$2e2bcd8739ae039 = $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless;

});
parcelRegister("9oIFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $49788ff41cd45114$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $3pn3a = parcelRequire("3pn3a");
var $49788ff41cd45114$export$2e2bcd8739ae039 = (0, $8oe80.default)('form', {
    onSubmit: 'submitted'
})((0, $3pn3a.default));

});
parcelRegister("3pn3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6b524a14a97bee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4EHpO = parcelRequire("4EHpO");

var $9FSw2 = parcelRequire("9FSw2");

var $bjTxt = parcelRequire("bjTxt");

var $9r7BT = parcelRequire("9r7BT");

var $koVbs = parcelRequire("koVbs");

var $7cbM0 = parcelRequire("7cbM0");

var $7VpFm = parcelRequire("7VpFm");
const $da6b524a14a97bee$var$CreateCategoryForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors, isDisabled: isDisabled = false, testId: testId } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createOnChangeHandlerForField = (field)=>(e)=>{
            props.onChange(field, e.currentTarget.value);
        };
    const errorMessage = (field)=>fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;
    return(// @ts-expect-error - TS2322 - Type '{ children: (Element | undefined)[]; onSubmit: (e: SyntheticEvent<any, Event>) => void; disabled: boolean; }' is not assignable to type 'DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        onSubmit: onSubmit,
        disabled: isDisabled
    }, formError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "error",
        testId: testId && `${testId}--section-message`
    }, formatMessage(formError.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $7VpFm.default).helpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
        error: errorMessage('name'),
        label: formatMessage((0, $7VpFm.default).nameFieldLabel),
        isRequired: true,
        name: "name"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cbM0.default), {
            error: errorMessage('name')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
            ...fieldProps,
            isRequired: true,
            autoComplete: "off",
            placeholder: formatMessage((0, $7VpFm.default).nameFieldPlaceholder),
            isInvalid: fieldErrors && !!fieldErrors.name,
            maxLength: 100,
            onChange: createOnChangeHandlerForField('name'),
            isDisabled: isDisabled,
            autoFocus: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
        error: errorMessage('description'),
        label: formatMessage((0, $7VpFm.default).descriptionFieldLabel),
        name: "description"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7cbM0.default), {
            error: errorMessage('description')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjTxt.default), {
            ...fieldProps,
            maxLength: 150,
            minimumRows: 3,
            autoComplete: "off",
            placeholder: formatMessage((0, $7VpFm.default).descriptionFieldPlaceholder),
            isInvalid: fieldErrors && !!fieldErrors.description,
            isDisabled: isDisabled,
            onChange: createOnChangeHandlerForField('description')
        })))));
};
var $da6b524a14a97bee$export$2e2bcd8739ae039 = $da6b524a14a97bee$var$CreateCategoryForm;

});
parcelRegister("9FSw2", function(module, exports) {

$parcel$export(module.exports, "default", () => $992999896a95fc30$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $fPYPu = parcelRequire("fPYPu");
const $992999896a95fc30$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $992999896a95fc30$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $fPYPu.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "section",
        backgroundColor: $992999896a95fc30$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $992999896a95fc30$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $992999896a95fc30$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $992999896a95fc30$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            role: "list",
                            xcss: (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && $992999896a95fc30$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                                    role: "listitem",
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $992999896a95fc30$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$992999896a95fc30$var$SectionMessage.displayName = 'SectionMessage';
var $992999896a95fc30$export$2e2bcd8739ae039 = $992999896a95fc30$var$SectionMessage;

});
parcelRegister("fPYPu", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $3vNgn = parcelRequire("3vNgn");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $c121b5ea31b69b1c$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $a7f8c6b391092279$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $a7f8c6b391092279$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $a7f8c6b391092279$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $a7f8c6b391092279$export$147899de772240ec)})`
    }
};
function $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $c121b5ea31b69b1c$var$appearanceIconSchema[appearance] || $c121b5ea31b69b1c$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("bjTxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb5fb9ca46f29ed$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $fHpHg = parcelRequire("fHpHg");
const $fdb5fb9ca46f29ed$var$packageName = "platform-pkg";
const $fdb5fb9ca46f29ed$var$packageVersion = "0.0.0-use.local";
const $fdb5fb9ca46f29ed$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $fdb5fb9ca46f29ed$var$packageName,
    packageVersion: $fdb5fb9ca46f29ed$var$packageVersion
};
const $fdb5fb9ca46f29ed$var$lineHeightBase = 20;
const $fdb5fb9ca46f29ed$var$lineHeightCompact = 16;
const $fdb5fb9ca46f29ed$var$compactVerticalPadding = 2;
const $fdb5fb9ca46f29ed$var$verticalPadding = 6;
const $fdb5fb9ca46f29ed$var$transitionDuration = '0.2s';
const $fdb5fb9ca46f29ed$var$borderWidth = 2;
const $fdb5fb9ca46f29ed$var$baseStyles = null;
const $fdb5fb9ca46f29ed$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $fdb5fb9ca46f29ed$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $fdb5fb9ca46f29ed$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $fdb5fb9ca46f29ed$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $fdb5fb9ca46f29ed$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $fdb5fb9ca46f29ed$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $fdb5fb9ca46f29ed$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$fdb5fb9ca46f29ed$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$fdb5fb9ca46f29ed$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $fdb5fb9ca46f29ed$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $fdb5fb9ca46f29ed$var$appearanceStyles[appearance],
            (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && $fdb5fb9ca46f29ed$var$fontStyles['large'],
            $fdb5fb9ca46f29ed$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $fdb5fb9ca46f29ed$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($fdb5fb9ca46f29ed$var$lineHeightCompact * minimumRows + $fdb5fb9ca46f29ed$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($fdb5fb9ca46f29ed$var$lineHeightBase * minimumRows + $fdb5fb9ca46f29ed$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $fdb5fb9ca46f29ed$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fdb5fb9ca46f29ed$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$fdb5fb9ca46f29ed$var$TextArea.displayName = 'TextArea';
var $fdb5fb9ca46f29ed$export$2e2bcd8739ae039 = $fdb5fb9ca46f29ed$var$TextArea;

});

parcelRegister("7cbM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c9409ad575aa5f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
function $78c9409ad575aa5f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c9409ad575aa5f$var$ErrorMessage, null, props.error));
}
$78c9409ad575aa5f$export$2e2bcd8739ae039.defaultProps = {
    error: undefined
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $78c9409ad575aa5f$var$ErrorMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1tmw _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7VpFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $185a0480b7dde273$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $185a0480b7dde273$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    helpText: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text",
        "defaultMessage": "Group related articles in categories to help customers find what they need."
    },
    nameFieldLabel: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label",
        "defaultMessage": "Name"
    },
    nameFieldPlaceholder: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder",
        "defaultMessage": "Category name, e.g \"Printers\" or \"Wifi\""
    },
    descriptionFieldLabel: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label",
        "defaultMessage": "Description"
    },
    descriptionFieldPlaceholder: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder",
        "defaultMessage": "Tell customers more about this category"
    }
});

});



parcelRegister("5TOVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f748cc858c62ad0d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f748cc858c62ad0d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.title",
        "defaultMessage": "Create new category"
    },
    createAction: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-action",
        "defaultMessage": "Create"
    },
    cancelAction: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("ks7Ah", function(module, exports) {

$parcel$export(module.exports, "default", () => $30d72adc6eb603b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kvQS7 = parcelRequire("kvQS7");
const $30d72adc6eb603b4$var$NavDriver = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvQS7.KbCreateCategorySubscriber), null, ({ isOpen: isOpen }, { setCreateCategoryDisplay: setCreateCategoryDisplay })=>{
        const onClose = ()=>setCreateCategoryDisplay(false);
        return children({
            isOpen: isOpen,
            onClose: onClose
        });
    });
};
var $30d72adc6eb603b4$export$2e2bcd8739ae039 = $30d72adc6eb603b4$var$NavDriver;

});
parcelRegister("kvQS7", function(module, exports) {

$parcel$export(module.exports, "useKbCreateCategoryActions", () => $fefcd82701364dc4$export$719df9e736f08a9);
$parcel$export(module.exports, "KbCreateCategorySubscriber", () => $fefcd82701364dc4$export$2b9cf8c256011b51);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $fefcd82701364dc4$export$d4c72bab9d6cc13a = {
    isOpen: false
};
const $fefcd82701364dc4$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
        setState({
            isOpen: isOpen
        });
    };
const $fefcd82701364dc4$export$e324594224ef24da = {
    setCreateCategoryDisplay: $fefcd82701364dc4$var$setCreateCategoryDisplay
};
const $fefcd82701364dc4$var$Store = (0, $iXqE5.createStore)({
    name: 'kb-create-category',
    initialState: $fefcd82701364dc4$export$d4c72bab9d6cc13a,
    actions: $fefcd82701364dc4$export$e324594224ef24da
});
const $fefcd82701364dc4$export$719df9e736f08a9 = (0, $3sQ5x.createHook)($fefcd82701364dc4$var$Store, {
    selector: null
});
const $fefcd82701364dc4$export$2b9cf8c256011b51 = (0, $51nlc.createSubscriber)($fefcd82701364dc4$var$Store);

});



parcelRegister("h4S6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e91b5defeecf9279$export$2e2bcd8739ae039);

var $5sKH1 = parcelRequire("5sKH1");

var $iHUHp = parcelRequire("iHUHp");

var $6zk4x = parcelRequire("6zk4x");

var $1hzgw = parcelRequire("1hzgw");

var $6VTSZ = parcelRequire("6VTSZ");
const $e91b5defeecf9279$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $6zk4x.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
        case 0, $5sKH1.ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
            return (0, $6VTSZ.default)();
        case 0, $iHUHp.REMOVE_LABEL_FROM_ARTICLE_FAILURE:
            return (0, $1hzgw.default)();
        default:
            return undefined;
    }
};
var $e91b5defeecf9279$export$2e2bcd8739ae039 = $e91b5defeecf9279$var$flagsMapper;

});
parcelRegister("5sKH1", function(module, exports) {

$parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_FAILURE", () => $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d);
$parcel$export(module.exports, "addCategoriesForArticleFailure", () => $a77e1c0ebfe8e6c5$export$98c16426b39dc19d);
const $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d = 'state.actions.add-categories-for-article-failure.ADD_CATEGORIES_FOR_ARTICLE_FAILURE';
const $a77e1c0ebfe8e6c5$export$98c16426b39dc19d = (payload)=>({
        payload: payload,
        type: $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d
    });

});

parcelRegister("iHUHp", function(module, exports) {

$parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_FAILURE", () => $36bd602e9276dc31$export$78c874904ae250ac);
$parcel$export(module.exports, "removeLabelFromArticleFailure", () => $36bd602e9276dc31$export$b7ca01a9c0fd6afb);
const $36bd602e9276dc31$export$78c874904ae250ac = 'state.actions.remove-label-from-article-failure.REMOVE_LABEL_FROM_ARTICLE_FAILURE';
const $36bd602e9276dc31$export$b7ca01a9c0fd6afb = (payload)=>({
        payload: payload,
        type: $36bd602e9276dc31$export$78c874904ae250ac
    });

});

parcelRegister("6zk4x", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE", () => $ad606a0cff7a573c$export$f5f174c6323905d3);
$parcel$export(module.exports, "updateCategoriesForArticleFailure", () => $ad606a0cff7a573c$export$4578d03141d71619);
const $ad606a0cff7a573c$export$f5f174c6323905d3 = 'state.actions.update-categories-for-article-failure.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE';
const $ad606a0cff7a573c$export$4578d03141d71619 = (payload)=>({
        payload: payload,
        type: $ad606a0cff7a573c$export$f5f174c6323905d3
    });

});

parcelRegister("1hzgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb51d5c83a378fb$export$2e2bcd8739ae039);

var $fmcGe = parcelRequire("fmcGe");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ecb51d5c83a378fb$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        type: 'error',
        title: (0, $fmcGe.default).title,
        description: (0, $fmcGe.default).description,
        messageId: 'servicedesk-knowledge-hub.flags.remove-label-from-article-failure',
        messageType: 'transactional'
    });

});
parcelRegister("fmcGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $372161f8a7552a21$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $372161f8a7552a21$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.title",
        "defaultMessage": "We couldn\u2019t save the changes you made"
    },
    description: {
        "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("6VTSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $53def11827375f52$export$2e2bcd8739ae039);

var $kINlF = parcelRequire("kINlF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53def11827375f52$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        type: 'error',
        title: (0, $kINlF.default).title,
        description: (0, $kINlF.default).description,
        messageId: 'servicedesk-knowledge-hub.flags.update-categories-for-article-failure',
        messageType: 'transactional'
    });

});
parcelRegister("kINlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59c7a9bfc032690$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f59c7a9bfc032690$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.title",
        "defaultMessage": "Article's categories not updated"
    },
    description: {
        "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.description",
        "defaultMessage": "We weren't able to update the article's categories. Try again in a minute."
    }
});

});



parcelRegister("hYd1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c850f2f9e57103ab$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $bdof7 = parcelRequire("bdof7");

var $eGP51 = parcelRequire("eGP51");

var $4DyVT = parcelRequire("4DyVT");

var $feRMu = parcelRequire("feRMu");

var $kTAvA = parcelRequire("kTAvA");

var $bDRTj = parcelRequire("bDRTj");

var $cpM8i = parcelRequire("cpM8i");

var $a20m8 = parcelRequire("a20m8");

var $gTvcp = parcelRequire("gTvcp");

var $4JAV5 = parcelRequire("4JAV5");

var $iYJ1l = parcelRequire("iYJ1l");

var $92ShW = parcelRequire("92ShW");

var $8ybmo = parcelRequire("8ybmo");

var $6OXm8 = parcelRequire("6OXm8");

var $fBtAp = parcelRequire("fBtAp");

var $fFeqO = parcelRequire("fFeqO");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$c850f2f9e57103ab$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $92ShW.epic), (0, $gTvcp.epic), (0, $cpM8i.epic), (0, $bDRTj.epic), (0, $a20m8.epic), (0, $8ybmo.epic), (0, $4DyVT.epic), (0, $bdof7.epic), (0, $6OXm8.epic), (0, $4JAV5.epic), (0, $feRMu.epic), (0, $kTAvA.epic), (0, $eGP51.epic), (0, $iYJ1l.epic), (0, $fBtAp.epic), (0, $fFeqO.epic));

});
parcelRegister("bdof7", function(module, exports) {

$parcel$export(module.exports, "epic", () => $8156adb89212081f$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $5sKH1 = parcelRequire("5sKH1");

var $5XgTr = parcelRequire("5XgTr");

var $6ovlC = parcelRequire("6ovlC");

var $gXg4u = parcelRequire("gXg4u");

var $gLt7z = parcelRequire("gLt7z");

const $8156adb89212081f$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $6ovlC.ADD_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
        const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        const currentCategoryIds = (0, $gXg4u.getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
        return (0, $fmmX1.addCategoriesForArticle)({
            projectId: projectId,
            categoryIds: categoryIds,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map(()=>{
            (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
                action: 'update',
                actionSubjectId: articleId
            });
            return (0, $5XgTr.addCategoriesForArticleSuccess)({
                articleId: articleId,
                categoryIds: categoryIds,
                previousCategoryIds: currentCategoryIds
            });
        }).catch((error)=>{
            const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
            (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: analyticsEvent,
                id: 'articleUpdate Failure',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $5sKH1.addCategoriesForArticleFailure)({
                statusCode: statusCode,
                errorKey: errorKey,
                errorMessage: errorMessage,
                failedCategoryIds: categories,
                articleId: articleId
            }));
        });
    });

});
parcelRegister("fmmX1", function(module, exports) {

$parcel$export(module.exports, "list", () => $0f36cff0fb97de2b$export$8837f4fc672e936d);
$parcel$export(module.exports, "listCategoryArticles", () => $0f36cff0fb97de2b$export$897d9115a17b4c24);
$parcel$export(module.exports, "getArticleWithExpandParams", () => $0f36cff0fb97de2b$export$fb27d96404fd219d);
$parcel$export(module.exports, "addCategoriesForArticle", () => $0f36cff0fb97de2b$export$d93a983139fde0cc);
$parcel$export(module.exports, "updateCategoriesForArticle", () => $0f36cff0fb97de2b$export$2613b83c3141003a);
$parcel$export(module.exports, "getAllLinkedSpaces", () => $0f36cff0fb97de2b$export$6f4beca8ff3702f3);
$parcel$export(module.exports, "addLabelsToArticles", () => $0f36cff0fb97de2b$export$f40640db2a9b7e80);
$parcel$export(module.exports, "removeLabelsFromArticles", () => $0f36cff0fb97de2b$export$cba6b78bbfb96381);
$parcel$export(module.exports, "fetchLabelSuggestions", () => $0f36cff0fb97de2b$export$8502c8a97aecfbad);
$parcel$export(module.exports, "fetchArticleEditPermission", () => $0f36cff0fb97de2b$export$65396ff44dade790);
parcelRequire("3q49N");
parcelRequire("c66Ur");
parcelRequire("d0pqD");

var $ebyGx = parcelRequire("ebyGx");

var $kVLXA = parcelRequire("kVLXA");

var $7f4tk = parcelRequire("7f4tk");

var $5OrSA = parcelRequire("5OrSA");

var $2Lj35 = parcelRequire("2Lj35");

/**
 * This will replace `null` with `undefined`. We want to merge
 * data later in the application - but we don't want null to
 * override data that already exists.
 */ const $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined = (article)=>{
    const parsedArticle = {
        ...article
    };
    if (parsedArticle.viewCount === null) parsedArticle.viewCount = undefined;
    if (parsedArticle.categories === null) parsedArticle.categories = undefined;
    if (parsedArticle.featuredInCategories === null) parsedArticle.featuredInCategories = undefined;
    return parsedArticle;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0f36cff0fb97de2b$var$transformArticleResponse = (articleResponse)=>{
    // Currently API return ADF as string instead of a JSON blob, so we have to
    // an additional transformation step here.
    let bodyAdf;
    if (articleResponse.body) bodyAdf = JSON.parse(articleResponse.body);
    const transformedData = {
        ...articleResponse,
        body: bodyAdf
    };
    return $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined(transformedData);
};
const $0f36cff0fb97de2b$var$getQueryString = (opts)=>{
    const { expand: expand, ...otherOpts } = opts;
    if (expand) return (0, $ebyGx.stringify)({
        ...otherOpts,
        expand: expand.join(',')
    });
    return (0, $ebyGx.stringify)(otherOpts);
};
const $0f36cff0fb97de2b$export$8837f4fc672e936d = (projectId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
    const apiPath = `/api/project/${projectId}/article?${queryString}`;
    const url = `${apolloPath}/${activationId}${apiPath}`;
    return (0, $5OrSA.fetchJson$)(url).map((response)=>({
            ...response,
            results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
        }));
};
const $0f36cff0fb97de2b$export$897d9115a17b4c24 = (projectId, categoryId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
    const apiPath = `/api/project/${projectId}/category/${(0, $2Lj35.categoryGuidToString)(categoryId)}/article?${queryString}`;
    const url = `${apolloPath}/${activationId}${apiPath}`;
    return (0, $5OrSA.fetchJson$)(url).map((response)=>({
            ...response,
            results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
        }));
};
const $0f36cff0fb97de2b$export$f8c0d0a39b0d7d4e = (projectId, articleId, withCategory, apolloPath = (0, $45c806b56a43da0e$export$8ce6d23ffa1a190a))=>{
    const url = `${apolloPath}/api/project/${projectId}/article/${articleId}`;
    const queryString = withCategory ? `?${(0, $ebyGx.stringify)({
        expand: 'category'
    })}` : '';
    return (0, $5OrSA.fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
};
const $0f36cff0fb97de2b$export$fb27d96404fd219d = (projectId, articleId, activationId, expandParams, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}`;
    const queryString = expandParams.length ? `?${$0f36cff0fb97de2b$var$getQueryString({
        expand: expandParams
    })}` : '';
    return (0, $5OrSA.fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
};
const $0f36cff0fb97de2b$export$d93a983139fde0cc = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/category`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'PATCH',
        body: JSON.stringify({
            categories: categoryIds
        })
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$2613b83c3141003a = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}/category`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'PUT',
        body: JSON.stringify({
            spaceKey: spaceKey,
            categories: categoryIds
        })
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$6f4beca8ff3702f3 = (projectKey)=>{
    const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb`;
    const transformedResponse = (0, $5OrSA.fetchJson$)(url).map((response)=>({
            spaces: response.map((space)=>({
                    name: space.spaceName,
                    key: space.spaceKey,
                    appLinkId: space.appLinkId
                }))
        }));
    return transformedResponse;
};
const $0f36cff0fb97de2b$export$f40640db2a9b7e80 = ({ projectId: projectId, labels: labels, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'POST',
        body: JSON.stringify(labels)
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$cba6b78bbfb96381 = ({ projectId: projectId, label: label, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label/${encodeURIComponent(label)}`;
    return (0, $5OrSA.fetchJson$)(url, {
        method: 'DELETE'
    }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
};
const $0f36cff0fb97de2b$export$8502c8a97aecfbad = (projectKey, queryString, articleId)=>{
    const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb/labels?query=${queryString}&contentId=${articleId}`;
    return (0, $7f4tk.default)(url).then(({ contentNameMatches: contentNameMatches })=>{
        if (!contentNameMatches?.length) return [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const suggestions = contentNameMatches.reduce((labelList, contentNameMatch)=>{
            if (contentNameMatch.length) // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...labelList,
                ...contentNameMatch
            ];
            return labelList;
        }, []);
        return suggestions.length ? suggestions.map(({ name: name })=>({
                label: name,
                value: name
            })) : [];
    }).catch(()=>[]);
};
const $0f36cff0fb97de2b$export$65396ff44dade790 = (cloudId, articleId, projectId, accountId, sendCustomHeaders, spaceKey)=>{
    const body = {
        subject: {
            type: 'user',
            identifier: accountId
        },
        operation: 'update'
    };
    const headers = sendCustomHeaders ? {
        'Content-Type': 'application/json',
        'X-ATL-EmbeddablePage-EntityIds': JSON.stringify({
            spaceKey: spaceKey || '',
            parentProduct: 'JSM',
            parentProductContentContainerId: projectId,
            contentId: articleId
        })
    } : {
        'Content-Type': 'application/json'
    };
    return (0, $5OrSA.fetchJson$)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/${articleId}/permission/check`, {
        method: 'POST',
        headers: // @ts-expect-error - TS-2322 Please check what's correct: either add `headers` to fetchJson$ `options` type, or remove this argument, if function does not support it and it does nothing
        headers,
        body: JSON.stringify(body)
    }).catch((error)=>(0, $kVLXA.Observable).throw(error));
};

});

parcelRegister("5XgTr", function(module, exports) {

$parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_SUCCESS", () => $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2);
$parcel$export(module.exports, "addCategoriesForArticleSuccess", () => $b60bbe4f4c92ec4f$export$deab1340d30ad632);
const $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2 = 'state.actions.add-categories-for-article-success.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS';
const $b60bbe4f4c92ec4f$export$deab1340d30ad632 = (payload)=>({
        payload: payload,
        type: $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2
    });

});

parcelRegister("6ovlC", function(module, exports) {

$parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE", () => $5b88d8b66d98e99f$export$c22494f1249599aa);
$parcel$export(module.exports, "addCategoriesForArticle", () => $5b88d8b66d98e99f$export$d93a983139fde0cc);
const $5b88d8b66d98e99f$export$c22494f1249599aa = 'state.actions.add-categories-for-article.ADD_CATEGORIES_FOR_ARTICLE';
const $5b88d8b66d98e99f$export$d93a983139fde0cc = (payload)=>({
        payload: payload,
        type: $5b88d8b66d98e99f$export$c22494f1249599aa
    });

});


parcelRegister("eGP51", function(module, exports) {

$parcel$export(module.exports, "epic", () => $b7199b09d6315b91$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $e8y9X = parcelRequire("e8y9X");

var $8j0bg = parcelRequire("8j0bg");

var $80A0Z = parcelRequire("80A0Z");

var $gLt7z = parcelRequire("gLt7z");

const $b7199b09d6315b91$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $80A0Z.ADD_LABELS_TO_ARTICLE)).mergeMap((action)=>{
        const { labels: labels, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        return (0, $fmmX1.addLabelsToArticles)({
            projectId: projectId,
            labels: labels,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map((response)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onAddLabels success', {
                articleId: articleId
            });
            return (0, $8j0bg.addLabelsToArticleSuccess)(response);
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onAddLabelsFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $e8y9X.addLabelsToArticleFailure)({
                articleId: articleId
            }));
        });
    });

});
parcelRegister("e8y9X", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_FAILURE", () => $68db2bd167d08867$export$836fc3274a0c8c08);
$parcel$export(module.exports, "addLabelsToArticleFailure", () => $68db2bd167d08867$export$46974ef034e5e1ff);
const $68db2bd167d08867$export$836fc3274a0c8c08 = 'state.actions.add-labels-to-article-failure.ADD_LABELS_TO_ARTICLE_FAILURE';
const $68db2bd167d08867$export$46974ef034e5e1ff = (payload)=>({
        payload: payload,
        type: $68db2bd167d08867$export$836fc3274a0c8c08
    });

});

parcelRegister("8j0bg", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_SUCCESS", () => $7cdb79ea2b68767f$export$fb41ea70dd3d20e7);
$parcel$export(module.exports, "addLabelsToArticleSuccess", () => $7cdb79ea2b68767f$export$1d48c14841a2dd90);
const $7cdb79ea2b68767f$export$fb41ea70dd3d20e7 = 'state.actions.add-labels-to-article-success.ADD_LABELS_TO_ARTICLE_SUCCESS';
const $7cdb79ea2b68767f$export$1d48c14841a2dd90 = (payload)=>({
        payload: payload,
        type: $7cdb79ea2b68767f$export$fb41ea70dd3d20e7
    });

});

parcelRegister("80A0Z", function(module, exports) {

$parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE", () => $f87c53beb7b3ea22$export$2b91058f81222c91);
$parcel$export(module.exports, "addLabelsToArticle", () => $f87c53beb7b3ea22$export$335c057b91702017);
const $f87c53beb7b3ea22$export$2b91058f81222c91 = 'state.actions.add-labels-to-article.ADD_LABELS_TO_ARTICLE';
const $f87c53beb7b3ea22$export$335c057b91702017 = (payload)=>({
        payload: payload,
        type: $f87c53beb7b3ea22$export$2b91058f81222c91
    });

});


parcelRegister("4DyVT", function(module, exports) {

$parcel$export(module.exports, "epic", () => $01135ff527d8b512$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $i4zGm = parcelRequire("i4zGm");

var $33YKl = parcelRequire("33YKl");

var $4VDwv = parcelRequire("4VDwv");

var $kHzxc = parcelRequire("kHzxc");

var $gLt7z = parcelRequire("gLt7z");

var $fhG9v = parcelRequire("fhG9v");

const $01135ff527d8b512$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $kHzxc.BROWSE_KNOWLEDGE)).mergeMap((action)=>{
        const page = action.payload.page || 1;
        const state = store.getState();
        const limit = action.payload.limit || (0, $fhG9v.getBrowseLimit)(state);
        const projectId = (0, $gLt7z.getProjectId)(state);
        const spaceKey = action.payload.spaceKey ?? '';
        const cursor = action.payload.cursor ?? '';
        const activationId = (0, $gLt7z.getActivationId)(state);
        let requestParams = {
            categoryId: action.payload.id,
            expand: action.payload.expand,
            orderby: action.payload.orderBy,
            limit: limit
        };
        const query = action.payload.query != null ? action.payload.query : '';
        if (query) // @ts-expect-error - TS2322 - Type '{ query: string; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
        requestParams = {
            ...requestParams,
            query: query
        };
        if (spaceKey) // @ts-expect-error - TS2322 - Type '{ spaceKey: string[]; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
        requestParams = {
            ...requestParams,
            spaceKey: spaceKey
        };
        if (cursor) // @ts-expect-error - TS2322 - Type '{ cursor: string; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
        requestParams = {
            ...requestParams,
            cursor: cursor
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
        const EVENT_NAME = requestParams.categoryId !== 'all-articles' ? 'browseArticleInCategory' : 'browseArticles';
        return (0, $i4zGm.list)(projectId, activationId, requestParams).map((response)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({});
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${EVENT_NAME} success`, {
                    projectId: projectId
                });
            }
            return (0, $4VDwv.browseKnowledgeSuccess)({
                id: action.payload.id,
                ...response,
                page: page
            });
        }).catch((error)=>{
            const { statusCode: statusCode } = error;
            if (createAnalyticsEvent) (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: createAnalyticsEvent({}),
                id: `${EVENT_NAME} failure`,
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $33YKl.browseKnowledgeFailure)({
                id: action.payload.id,
                page: page,
                statusCode: statusCode
            }));
        });
    });

});
parcelRegister("i4zGm", function(module, exports) {

$parcel$export(module.exports, "list", () => $45a2c0bfdac04a79$export$8837f4fc672e936d);
$parcel$export(module.exports, "linkedSpaces", () => $45a2c0bfdac04a79$export$d3636d9abefdd232);

var $fmmX1 = parcelRequire("fmmX1");
const $45a2c0bfdac04a79$export$8837f4fc672e936d = (projectId, activationId, { categoryId: categoryId, ...opts })=>{
    if (categoryId === 'all-articles') return (0, $fmmX1.list)(projectId, opts, activationId);
    return (0, $fmmX1.listCategoryArticles)(projectId, categoryId, opts, activationId);
};
const $45a2c0bfdac04a79$export$d3636d9abefdd232 = (projectKey)=>(0, $fmmX1.getAllLinkedSpaces)(projectKey);

});

parcelRegister("33YKl", function(module, exports) {

$parcel$export(module.exports, "BROWSE_KNOWLEDGE_FAILURE", () => $da91aed3c1c538b9$export$be396dbd2f8b61b5);
$parcel$export(module.exports, "browseKnowledgeFailure", () => $da91aed3c1c538b9$export$a84d455b463b93e5);

var $dMhXw = parcelRequire("dMhXw");
const $da91aed3c1c538b9$export$be396dbd2f8b61b5 = 'state.actions.browse-knowledge-failure.BROWSE_KNOWLEDGE_FAILURE';
const $da91aed3c1c538b9$export$a84d455b463b93e5 = (opts)=>({
        type: $da91aed3c1c538b9$export$be396dbd2f8b61b5,
        payload: {
            id: opts.id,
            page: opts.page,
            error: {
                message: (0, $dMhXw.default).genericMessage,
                header: (0, $dMhXw.default).genericHeader
            }
        }
    });

});
parcelRegister("dMhXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $060d0dd30f30d38c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $060d0dd30f30d38c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-header",
        "defaultMessage": "Something went wrong"
    },
    genericMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-message",
        "defaultMessage": "We couldn't load the articles. Please refresh and try again."
    }
});

});


parcelRegister("4VDwv", function(module, exports) {

$parcel$export(module.exports, "BROWSE_KNOWLEDGE_SUCCESS", () => $fdd461c5c2f5f7b7$export$b9ec4df681504dbb);
$parcel$export(module.exports, "browseKnowledgeSuccess", () => $fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d);
const $fdd461c5c2f5f7b7$export$b9ec4df681504dbb = 'state.actions.browse-knowledge-success.BROWSE_KNOWLEDGE_SUCCESS';
const $fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d = (payload)=>({
        type: $fdd461c5c2f5f7b7$export$b9ec4df681504dbb,
        payload: payload
    });

});


parcelRegister("feRMu", function(module, exports) {

$parcel$export(module.exports, "epic", () => $40f3d7cc48e99b60$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jrkeZ = parcelRequire("jrkeZ");

var $6FRaa = parcelRequire("6FRaa");

var $aZdbu = parcelRequire("aZdbu");

var $gMZw6 = parcelRequire("gMZw6");

var $gLt7z = parcelRequire("gLt7z");
const $40f3d7cc48e99b60$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $gMZw6.FETCH_APPLINK)).mergeMap(()=>{
        const projectKey = (0, $gLt7z.getProjectKey)(store.getState());
        return (0, $jrkeZ.fetchCurrentAppLink)(projectKey).mergeMap((appLink)=>(0, $kVLXA.Observable).of((0, $aZdbu.fetchAppLinkSuccess)(appLink))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, $6FRaa.fetchAppLinkFailure)({
                statusCode: statusCode
            })));
    });

});
parcelRegister("jrkeZ", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceAppLinks", () => $75401d703e62a5e6$export$411bec8e101d37ea);
$parcel$export(module.exports, "fetchCurrentAppLink", () => $75401d703e62a5e6$export$f1e8c76efca169f3);
$parcel$export(module.exports, "fetchCurrentAppLinkV2", () => $75401d703e62a5e6$export$a5d48ab772ff4e41);
$parcel$export(module.exports, "fetchConfluenceLink", () => $75401d703e62a5e6$export$1eeb53c23f99ec16);
$parcel$export(module.exports, "fetchConfluenceLinkRestful", () => $75401d703e62a5e6$export$c71d13c885efd437);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $7f4tk = parcelRequire("7f4tk");

var $kTM7r = parcelRequire("kTM7r");

var $5QK3R = parcelRequire("5QK3R");
const $75401d703e62a5e6$export$411bec8e101d37ea = (projectKey)=>(0, $5QK3R.fetchAppLinkNoEyeball)(projectKey);
const $75401d703e62a5e6$export$916391fe3383489b = (projectKey)=>(0, $5QK3R.fetchAppLinkNoEyeball)(projectKey).map((data)=>data.appLinks.find((link)=>link.isSystem));
const $75401d703e62a5e6$export$f1e8c76efca169f3 = (projectKey)=>(0, $5QK3R.fetchCurrentAppLinkNoEyeball)(projectKey);
const $75401d703e62a5e6$export$a5d48ab772ff4e41 = (projectKey)=>(0, $5QK3R.fetchCurrentAppLinkNoEyeballV2)(projectKey);
const $75401d703e62a5e6$export$1eeb53c23f99ec16 = (projectKey)=>{
    const kbLink = (0, $kTM7r.wrmClaimSafe)('sd-kb-link');
    if (kbLink) {
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
        if (kbLink && !kbLink.error) return (0, $kVLXA.Observable).of({
            projectKey: projectKey,
            // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
            id: kbLink.id,
            // @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
            spaceKey: kbLink.spaceKey,
            // This is the base URL of the KB instance, not Jira
            /* eslint-disable-next-line jira/deprecations/no-base-url */ // @ts-expect-error - TS2339 - Property 'baseUrl' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
            baseUrl: kbLink.baseUrl
        });
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
        if (kbLink && kbLink.error) return (0, $kVLXA.Observable).throw(kbLink);
    }
    return (0, $kVLXA.Observable).throw({
        error: {
            key: 'sd.applinks.error.corrupt'
        }
    });
};
const $75401d703e62a5e6$var$ERROR_KEY_MAP = {
    '404': 'sd.kb.link.error.link.not.found',
    other: 'sd.applinks.error.corrupt'
};
const $75401d703e62a5e6$export$c71d13c885efd437 = (projectKey)=>{
    const url = `/rest/servicedesk/1/pages/agent/knowledge/${projectKey}`;
    return (0, $7f4tk.default)(url).catch((err)=>// eslint-disable-next-line prefer-promise-reject-errors
        Promise.reject({
            error: {
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly '404': "sd.kb.link.error.link.not.found"; readonly other: "sd.applinks.error.corrupt"; }'.
                key: $75401d703e62a5e6$var$ERROR_KEY_MAP[err.statusCode] || $75401d703e62a5e6$var$ERROR_KEY_MAP.other
            }
        }));
};

});
parcelRegister("kTM7r", function(module, exports) {

$parcel$export(module.exports, "wrmClaimSafe", () => $7a3f570973700129$export$6d04651d170462ec);
/**
 * Claim the WRM data provided by the JIRA instance, utilises the wrm data cache where available.
 * <p>
 *
 * @param {string} key - WRM data key defined by JIRA or the JIRA plugin
 * @returns {*} data obtained from the WRM data set
 */ const $7a3f570973700129$export$6d04651d170462ec = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.wrmDataCache = window.wrmDataCache || {};
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.wrmDataCache[key]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.wrmDataCache[key];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const data = window.WRM.data.claim(key);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.wrmDataCache[key] = data;
    return data;
};
const $7a3f570973700129$export$460d685a9ee326a8 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const claimedData = window.WRM.data.claim(key);
    if (claimedData === undefined) throw new Error(`Could not find WRM data for key: ${key}`);
    return claimedData;
};

});

parcelRegister("5QK3R", function(module, exports) {

$parcel$export(module.exports, "fetchAppLinkNoEyeball", () => $00051febdde61fec$export$d888e54a19706e84);
$parcel$export(module.exports, "fetchCurrentAppLinkNoEyeball", () => $00051febdde61fec$export$91f2ef831add2534);
$parcel$export(module.exports, "fetchCurrentAppLinkNoEyeballV2", () => $00051febdde61fec$export$2727b4e442c6787f);

var $7f4tk = parcelRequire("7f4tk");

var $5OrSA = parcelRequire("5OrSA");
const $00051febdde61fec$export$d888e54a19706e84 = (projectKey)=>(0, $5OrSA.fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence`);
const $00051febdde61fec$export$91f2ef831add2534 = (projectKey)=>(0, $5OrSA.fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);
const $00051febdde61fec$export$2727b4e442c6787f = (projectKey)=>(0, $7f4tk.default)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);

});


parcelRegister("6FRaa", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINK_FAILURE", () => $5c0435e88e4a5ddc$export$1763acbd33c374e5);
$parcel$export(module.exports, "fetchAppLinkFailure", () => $5c0435e88e4a5ddc$export$635f69357a47e715);
const $5c0435e88e4a5ddc$export$1763acbd33c374e5 = 'state.actions.fetch-applink-failure.FETCH_APPLINK_FAILURE';
const $5c0435e88e4a5ddc$export$635f69357a47e715 = (error)=>({
        type: $5c0435e88e4a5ddc$export$1763acbd33c374e5,
        payload: error
    });

});

parcelRegister("aZdbu", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINK_SUCCESS", () => $cada50d61c624db3$export$5a66f7b0b7a57504);
$parcel$export(module.exports, "fetchAppLinkSuccess", () => $cada50d61c624db3$export$d64417727a56e7f1);
const $cada50d61c624db3$export$5a66f7b0b7a57504 = 'state.actions.fetch-applink-success.FETCH_APPLINK_SUCCESS';
const $cada50d61c624db3$export$d64417727a56e7f1 = (payload)=>({
        type: $cada50d61c624db3$export$5a66f7b0b7a57504,
        payload: payload
    });

});


parcelRegister("kTAvA", function(module, exports) {

$parcel$export(module.exports, "epic", () => $034fe31e006c1c0e$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jrkeZ = parcelRequire("jrkeZ");

var $3XkGj = parcelRequire("3XkGj");

var $7GY3F = parcelRequire("7GY3F");

var $4dXi2 = parcelRequire("4dXi2");

var $gLt7z = parcelRequire("gLt7z");
const $034fe31e006c1c0e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $4dXi2.FETCH_APPLINKS)).mergeMap(()=>{
        const projectKey = (0, $gLt7z.getProjectKey)(store.getState());
        return (0, $jrkeZ.fetchConfluenceAppLinks)(projectKey).mergeMap((appLinks)=>(0, $kVLXA.Observable).of((0, $7GY3F.fetchAppLinksSuccess)(appLinks.appLinks))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, $3XkGj.fetchAppLinksFailure)({
                statusCode: statusCode
            })));
    });

});
parcelRegister("3XkGj", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINKS_FAILURE", () => $daac65f7a8dc65e2$export$51c9d05978c1783b);
$parcel$export(module.exports, "fetchAppLinksFailure", () => $daac65f7a8dc65e2$export$c460ed087c66a41d);
const $daac65f7a8dc65e2$export$51c9d05978c1783b = 'state.actions.fetch-applinks-failure.FETCH_APPLINKS_FAILURE';
const $daac65f7a8dc65e2$export$c460ed087c66a41d = (error)=>({
        type: $daac65f7a8dc65e2$export$51c9d05978c1783b,
        payload: error
    });

});

parcelRegister("7GY3F", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINKS_SUCCESS", () => $81371e274ff768f8$export$de0056b0bbdd21c8);
$parcel$export(module.exports, "fetchAppLinksSuccess", () => $81371e274ff768f8$export$56072929934471cd);
const $81371e274ff768f8$export$de0056b0bbdd21c8 = 'state.actions.fetch-applinks-success.FETCH_APPLINKS_SUCCESS';
const $81371e274ff768f8$export$56072929934471cd = (payload)=>({
        type: $81371e274ff768f8$export$de0056b0bbdd21c8,
        payload: payload
    });

});

parcelRegister("4dXi2", function(module, exports) {

$parcel$export(module.exports, "FETCH_APPLINKS", () => $01bf9f555ca0b395$export$e7bce13a560ead5e);
$parcel$export(module.exports, "fetchAppLinks", () => $01bf9f555ca0b395$export$ee72e8e00b4fb176);
const $01bf9f555ca0b395$export$e7bce13a560ead5e = 'state.actions.fetch-applinks.FETCH_APPLINKS';
const $01bf9f555ca0b395$export$ee72e8e00b4fb176 = ()=>({
        type: $01bf9f555ca0b395$export$e7bce13a560ead5e
    });

});


parcelRegister("bDRTj", function(module, exports) {

$parcel$export(module.exports, "epic", () => $90f2b96f2a0068c3$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $39oW5 = parcelRequire("39oW5");

var $fTBH5 = parcelRequire("fTBH5");

var $gLt7z = parcelRequire("gLt7z");

const $90f2b96f2a0068c3$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $39oW5.FETCH_ARTICLE_EDIT_PERMISSION)).mergeMap((action)=>{
        const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent, spaceKey: spaceKey } = action.payload;
        const cloudId = (0, $gLt7z.getCloudId)(store.getState());
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        return (0, $fmmX1.fetchArticleEditPermission)(cloudId, id, projectId, accountId, true, spaceKey).mergeMap(({ hasPermission: hasPermission })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchArticleEditPermission success', {
                articleId: id
            });
            return (0, $kVLXA.Observable).of((0, $fTBH5.setArticleEditPermission)(hasPermission, id));
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onFetchArticleEditPermission failure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $fTBH5.setArticleEditPermission)(false, id));
        });
    });

});
parcelRegister("39oW5", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE_EDIT_PERMISSION", () => $21d9f874c3cb8395$export$2f278bb19228e406);
$parcel$export(module.exports, "fetchArticleEditPermission", () => $21d9f874c3cb8395$export$65396ff44dade790);
const $21d9f874c3cb8395$export$2f278bb19228e406 = 'state.actions.fetch-article-edit-permission.FETCH_ARTICLE_EDIT_PERMISSION';
const $21d9f874c3cb8395$export$65396ff44dade790 = (id, accountId, createAnalyticsEvent, spaceKey)=>({
        type: $21d9f874c3cb8395$export$2f278bb19228e406,
        payload: {
            id: id,
            spaceKey: spaceKey,
            accountId: accountId,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});

parcelRegister("fTBH5", function(module, exports) {

$parcel$export(module.exports, "SET_ARTICLE_EDIT_PERMISSION", () => $9fa31b3f751a812f$export$b3431c0d5e84092c);
$parcel$export(module.exports, "setArticleEditPermission", () => $9fa31b3f751a812f$export$bb3e34eb2358e906);
const $9fa31b3f751a812f$export$b3431c0d5e84092c = 'state.actions.set-article-edit-permission.SET_ARTICLE_EDIT_PERMISSION';
const $9fa31b3f751a812f$export$bb3e34eb2358e906 = (isEditable, articleId)=>({
        type: $9fa31b3f751a812f$export$b3431c0d5e84092c,
        payload: {
            isEditable: isEditable,
            articleId: articleId
        }
    });

});


parcelRegister("cpM8i", function(module, exports) {

$parcel$export(module.exports, "epic", () => $f95e339a734ecb5c$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $39oW5 = parcelRequire("39oW5");

var $4C8gV = parcelRequire("4C8gV");

var $agxSw = parcelRequire("agxSw");

var $la4EY = parcelRequire("la4EY");

var $gLt7z = parcelRequire("gLt7z");

const $f95e339a734ecb5c$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $la4EY.FETCH_ARTICLE)).mergeMap((action)=>{
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = action.payload;
        const getArticleObservable = (0, $fmmX1.getArticleWithExpandParams)(projectId, id, activationId, [
            'category',
            'labels'
        ]);
        return getArticleObservable.mergeMap((article)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $agxSw.fetchArticleSuccess)(article)), (0, $kVLXA.Observable).of((0, $39oW5.fetchArticleEditPermission)(id, accountId, createAnalyticsEvent, article.spaceKey || '')))).catch((error)=>{
            (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: createAnalyticsEvent({}),
                id: 'fetchArticle failure',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $4C8gV.fetchArticleFailure)({
                id: id,
                statusCode: error.statusCode
            }));
        });
    });

});
parcelRegister("4C8gV", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => $e3473a94e4383912$export$862d1fc538bf047c);
$parcel$export(module.exports, "fetchArticleFailure", () => $e3473a94e4383912$export$b135c19fc249d3ab);

var $4zIHa = parcelRequire("4zIHa");
const $e3473a94e4383912$export$862d1fc538bf047c = 'state.actions.fetch-article-failure.FETCH_ARTICLE_FAILURE';
const $e3473a94e4383912$export$b135c19fc249d3ab = (opts)=>({
        type: $e3473a94e4383912$export$862d1fc538bf047c,
        payload: {
            id: opts.id,
            error: opts.statusCode === 404 ? {
                message: (0, $4zIHa.default).notFoundMessage,
                header: (0, $4zIHa.default).notFoundHeader,
                ctaText: (0, $4zIHa.default).genericSearchCta,
                ctaLink: '/knowledge'
            } : {
                message: (0, $4zIHa.default).genericMessage,
                header: (0, $4zIHa.default).genericHeader,
                ctaText: (0, $4zIHa.default).genericSearchCta,
                ctaLink: '/knowledge'
            }
        }
    });

});
parcelRegister("4zIHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1714dd9e0ac9ecf4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1714dd9e0ac9ecf4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-header",
        "defaultMessage": "Can't find this article"
    },
    notFoundMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-message",
        "defaultMessage": "You may not have permission to view this article, you may not have permission to access Confluence, or this article may not exist."
    },
    genericHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-header",
        "defaultMessage": "Something went wrong"
    },
    genericMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-message",
        "defaultMessage": "We couldn't load this article. Please refresh after a few minutes."
    },
    genericSearchCta: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-search-cta",
        "defaultMessage": "Browse all articles"
    }
});

});


parcelRegister("agxSw", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => $345896be0e3d6472$export$2d213dcac7fc3339);
$parcel$export(module.exports, "fetchArticleSuccess", () => $345896be0e3d6472$export$6910c63a4b3017af);
const $345896be0e3d6472$export$2d213dcac7fc3339 = 'state.actions.fetch-article-success.FETCH_ARTICLE_SUCCESS';
const $345896be0e3d6472$export$6910c63a4b3017af = (payload)=>({
        type: $345896be0e3d6472$export$2d213dcac7fc3339,
        payload: payload
    });

});

parcelRegister("la4EY", function(module, exports) {

$parcel$export(module.exports, "FETCH_ARTICLE", () => $fdce37e75ad78af2$export$a55f0530be417648);
$parcel$export(module.exports, "fetchArticle", () => $fdce37e75ad78af2$export$b455945318d7989e);
const $fdce37e75ad78af2$export$a55f0530be417648 = 'state.actions.fetch-article.FETCH_ARTICLE';
const $fdce37e75ad78af2$export$b455945318d7989e = (id, articleType, accountId, createAnalyticsEvent)=>({
        type: $fdce37e75ad78af2$export$a55f0530be417648,
        payload: {
            id: id,
            articleType: articleType,
            accountId: accountId,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});


parcelRegister("a20m8", function(module, exports) {

$parcel$export(module.exports, "epic", () => $e17a2d6c79b83d30$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $guSo6 = parcelRequire("guSo6");

var $4COnH = parcelRequire("4COnH");

var $7gdJb = parcelRequire("7gdJb");

var $jpaaK = parcelRequire("jpaaK");

var $gLt7z = parcelRequire("gLt7z");

const $e17a2d6c79b83d30$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $jpaaK.FETCH_CATEGORIES)).mergeMap((action)=>{
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const { analyticsEvent: analyticsEvent } = action.payload;
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        return (0, $guSo6.listCategories)(projectId, activationId).mergeMap((categories)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                projectId: projectId
            });
            return (0, $kVLXA.Observable).of((0, $7gdJb.fetchCategoriesSuccess)(categories));
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onFetchCategoriesFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $4COnH.fetchCategoriesFailure)(error));
        });
    });

});
parcelRegister("4COnH", function(module, exports) {

$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => $ab63acaf2733bdc5$export$4425a101b60fad1);
$parcel$export(module.exports, "fetchCategoriesFailure", () => $ab63acaf2733bdc5$export$10b1ac5b71f5513e);
const $ab63acaf2733bdc5$export$4425a101b60fad1 = 'state.actions.fetch-categories-failure.FETCH_CATEGORIES_FAILURE';
const $ab63acaf2733bdc5$export$10b1ac5b71f5513e = (error)=>({
        type: $ab63acaf2733bdc5$export$4425a101b60fad1,
        payload: error
    });

});

parcelRegister("7gdJb", function(module, exports) {

$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => $abc28ada0f8a3d9a$export$8fe15054f89178e3);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => $abc28ada0f8a3d9a$export$1372a078b0bbb728);
const $abc28ada0f8a3d9a$export$8fe15054f89178e3 = 'state.actions.fetch-categories-success.FETCH_CATEGORIES_SUCCESS';
const $abc28ada0f8a3d9a$export$1372a078b0bbb728 = (payload)=>({
        type: $abc28ada0f8a3d9a$export$8fe15054f89178e3,
        payload: payload
    });

});

parcelRegister("jpaaK", function(module, exports) {

$parcel$export(module.exports, "FETCH_CATEGORIES", () => $b9a08106a74df812$export$cce9a7031b65f96c);
const $b9a08106a74df812$export$cce9a7031b65f96c = 'state.actions.fetch-categories.FETCH_CATEGORIES';
const $b9a08106a74df812$export$416ec9f5729de215 = (payload)=>({
        type: $b9a08106a74df812$export$cce9a7031b65f96c,
        payload: payload
    });

});


parcelRegister("gTvcp", function(module, exports) {

$parcel$export(module.exports, "epic", () => $ab48fc04d604b95e$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $jrkeZ = parcelRequire("jrkeZ");

var $eIzL1 = parcelRequire("eIzL1");

var $dtw6v = parcelRequire("dtw6v");

var $791HF = parcelRequire("791HF");

var $gLt7z = parcelRequire("gLt7z");

var $knU3A = parcelRequire("knU3A");
const $ab48fc04d604b95e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $791HF.FETCH_KB_HUB)).mergeMap((action)=>{
        const state = store.getState();
        const projectKey = (0, $gLt7z.getProjectKey)(state);
        const linkedState = (0, $knU3A.getHubLinkedState)(state);
        if (linkedState === 'linked') return (0, $kVLXA.Observable).empty();
        // Try wrmClaim
        return (0, $jrkeZ.fetchConfluenceLink)(action.payload.projectKey).mergeMap((link)=>(0, $kVLXA.Observable).of((0, $dtw6v.fetchKbHubSuccess)(link))).catch(()=>// wrmClaim REST fallback
            (0, $kVLXA.Observable).fromPromise((0, $jrkeZ.fetchConfluenceLinkRestful)(projectKey)).map((link)=>(0, $dtw6v.fetchKbHubSuccess)(link)).catch((err)=>(0, $kVLXA.Observable).of((0, $eIzL1.fetchKbHubFailure)(err))));
    });

});
parcelRegister("eIzL1", function(module, exports) {

$parcel$export(module.exports, "FETCH_KB_HUB_FAILURE", () => $be2f3f4be23b75f6$export$100d6710da08cb59);
$parcel$export(module.exports, "fetchKbHubFailure", () => $be2f3f4be23b75f6$export$7b9ad8413eaffe44);
// FETCH KB HUB FAILURE
const $be2f3f4be23b75f6$export$100d6710da08cb59 = 'state.actions.fetch-knowledge-hub-failure.FETCH_KB_HUB_FAILURE';
const $be2f3f4be23b75f6$export$7b9ad8413eaffe44 = (payload)=>({
        type: $be2f3f4be23b75f6$export$100d6710da08cb59,
        payload: payload
    });

});

parcelRegister("dtw6v", function(module, exports) {

$parcel$export(module.exports, "FETCH_KB_HUB_SUCCESS", () => $db188543ec32993c$export$52043214fd798dd);
$parcel$export(module.exports, "fetchKbHubSuccess", () => $db188543ec32993c$export$3b2b22c5e24bfc30);
const $db188543ec32993c$export$52043214fd798dd = 'state.actions.fetch-knowledge-hub-success.FETCH_KB_HUB_SUCCESS';
const $db188543ec32993c$export$3b2b22c5e24bfc30 = (payload)=>({
        type: $db188543ec32993c$export$52043214fd798dd,
        payload: payload
    });

});

parcelRegister("791HF", function(module, exports) {

$parcel$export(module.exports, "FETCH_KB_HUB", () => $2cbea12bc7a00f0f$export$6838769d7df96fbb);
// FETCH KB HUB
const $2cbea12bc7a00f0f$export$6838769d7df96fbb = 'state.actions.fetch-knowledge-hub.FETCH_KB_HUB';
const $2cbea12bc7a00f0f$export$647aec6b80785904 = (projectKey)=>({
        type: $2cbea12bc7a00f0f$export$6838769d7df96fbb,
        payload: {
            projectKey: projectKey
        }
    });

});


parcelRegister("4JAV5", function(module, exports) {

$parcel$export(module.exports, "epic", () => $f044973d8abb6a80$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $i4zGm = parcelRequire("i4zGm");

var $azjdP = parcelRequire("azjdP");

var $jzG6G = parcelRequire("jzG6G");

var $goH2j = parcelRequire("goH2j");
const $f044973d8abb6a80$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, $goH2j.FETCH_LINKED_SPACES)).mergeMap((action)=>{
        const { projectKey: projectKey } = action.payload;
        return (0, $i4zGm.linkedSpaces)(projectKey).map((response)=>(0, $jzG6G.fetchLinkedSpacesSuccess)(response)).catch(()=>(0, $kVLXA.Observable).of((0, $azjdP.fetchLinkedSpacesFailure)()));
    });

});
parcelRegister("azjdP", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => $cf0b03dea91f2721$export$9c186423b974805a);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => $cf0b03dea91f2721$export$e63a5f7249c4e5d6);

var $NEu0c = parcelRequire("NEu0c");
const $cf0b03dea91f2721$export$9c186423b974805a = 'state.actions.fetch-linked-spaces-failure.FETCH_LINKED_SPACES_FAILURE';
const $cf0b03dea91f2721$export$e63a5f7249c4e5d6 = ()=>({
        type: $cf0b03dea91f2721$export$9c186423b974805a,
        payload: {
            error: {
                message: (0, $NEu0c.default).genericMessage,
                header: (0, $NEu0c.default).genericHeader
            }
        }
    });

});
parcelRegister("NEu0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc9fdd816f4c370f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc9fdd816f4c370f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericHeader: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-header",
        "defaultMessage": "Something went wrong"
    },
    genericMessage: {
        "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-message",
        "defaultMessage": "We couldn't load the linked spaces. Please refresh and try again."
    }
});

});


parcelRegister("jzG6G", function(module, exports) {

$parcel$export(module.exports, "FETCH_LINKED_SPACE_SUCCESS", () => $366933797ff4c171$export$5142badf262ccc86);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => $366933797ff4c171$export$ad2cc5272eef487);
const $366933797ff4c171$export$5142badf262ccc86 = 'state.actions.fetch-linked-spaces-success.FETCH_LINKED_SPACE_SUCCESS';
const $366933797ff4c171$export$ad2cc5272eef487 = (payload)=>({
        type: $366933797ff4c171$export$5142badf262ccc86,
        payload: payload
    });

});


parcelRegister("iYJ1l", function(module, exports) {

$parcel$export(module.exports, "epic", () => $c4c23b3440ef4ce4$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $iHUHp = parcelRequire("iHUHp");

var $9aNfZ = parcelRequire("9aNfZ");

var $l1APE = parcelRequire("l1APE");

var $gLt7z = parcelRequire("gLt7z");

const $c4c23b3440ef4ce4$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $l1APE.REMOVE_LABEL_FROM_ARTICLE)).mergeMap((action)=>{
        const { label: label, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        return (0, $fmmX1.removeLabelsFromArticles)({
            projectId: projectId,
            label: label,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'onRemoveLabel success', {
                articleId: articleId
            });
            return (0, $9aNfZ.removeLabelFromArticleSuccess)({
                articleId: articleId,
                label: label
            });
        }).catch((error)=>{
            (0, $cVUDi.fireErrorAnalyticsEvents)(error, 'onRemoveLabelFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
            return (0, $kVLXA.Observable).of((0, $iHUHp.removeLabelFromArticleFailure)({
                articleId: articleId
            }));
        });
    });

});
parcelRegister("9aNfZ", function(module, exports) {

$parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_SUCCESS", () => $16ef0dd8936a9692$export$a9305d58f2d32098);
$parcel$export(module.exports, "removeLabelFromArticleSuccess", () => $16ef0dd8936a9692$export$2aaf552c4301b8b9);
const $16ef0dd8936a9692$export$a9305d58f2d32098 = 'state.actions.remove-label-from-article-success.REMOVE_LABEL_FROM_ARTICLE_SUCCESS';
const $16ef0dd8936a9692$export$2aaf552c4301b8b9 = (payload)=>({
        payload: payload,
        type: $16ef0dd8936a9692$export$a9305d58f2d32098
    });

});

parcelRegister("l1APE", function(module, exports) {

$parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE", () => $6c5650e2e1eb67b6$export$ad78add1bc20cf2e);
$parcel$export(module.exports, "removeLabelFromArticle", () => $6c5650e2e1eb67b6$export$c7cf56492591fe0f);
const $6c5650e2e1eb67b6$export$ad78add1bc20cf2e = 'state.actions.remove-label-from-article.REMOVE_LABEL_FROM_ARTICLE';
const $6c5650e2e1eb67b6$export$c7cf56492591fe0f = (payload)=>({
        payload: payload,
        type: $6c5650e2e1eb67b6$export$ad78add1bc20cf2e
    });

});


parcelRegister("92ShW", function(module, exports) {

$parcel$export(module.exports, "epic", () => $699ec73c490fb4c9$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("8n054");
parcelRequire("6cbqE");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("2agIZ");

var $i4zGm = parcelRequire("i4zGm");

var $hkbfC = parcelRequire("hkbfC");

var $gLt7z = parcelRequire("gLt7z");
const $699ec73c490fb4c9$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $hkbfC.SEARCH_ARTICLES)).mergeMap(()=>(0, $gLt7z.getBaseUrl)(store.getState()));
const $699ec73c490fb4c9$export$83f762cb3c8bb65a = (activationId)=>{
    const stream$ = new (0, $cab1K.Subject)();
    // @ts-expect-error - TS2684 - The 'this' context of type 'Observable<unknown>' is not assignable to method's 'this' of type 'Observable<{ term: any; projectId: any; limit: any; searchOnEmptyTerm: any; categoryId: any; expansions: any; orderBy: any; }>'.
    const results$ = stream$// @ts-expect-error - TS2345 - Argument of type '({ term }: { term: any; }) => Observable<number>' is not assignable to parameter of type '(value: unknown) => SubscribableOrPromise<number>'.
    .debounce(({ term: term })=>(0, $kVLXA.Observable).timer(term ? 300 : 0)).switchMap(({ term: term, projectId: projectId, limit: limit, searchOnEmptyTerm: searchOnEmptyTerm, categoryId: categoryId, expansions: expansions, orderBy: orderBy })=>{
        if (!searchOnEmptyTerm && !term) {
            const empty = {
                results: [],
                totalSize: 0,
                start: 0,
                limit: 0,
                size: 0,
                categoriesSupported: true
            };
            return (0, $kVLXA.Observable).of(empty);
        }
        return (0, $i4zGm.list)(projectId, activationId, {
            limit: limit,
            categoryId: categoryId,
            query: term,
            expand: expansions,
            orderby: orderBy
        });
    });
    return {
        search: (args)=>stream$.next(args),
        results$: results$
    };
};

});
parcelRegister("hkbfC", function(module, exports) {

$parcel$export(module.exports, "SEARCH_ARTICLES", () => $b106701f9da61eca$export$9d662e85b068d1ae);
// SEARCH ARTICLES
const $b106701f9da61eca$export$9d662e85b068d1ae = 'state.actions.search-articles.SEARCH_ARTICLES';
const $b106701f9da61eca$export$ce4856e0aa50b880 = (payload)=>({
        type: $b106701f9da61eca$export$9d662e85b068d1ae,
        payload: payload
    });

});


parcelRegister("8ybmo", function(module, exports) {

$parcel$export(module.exports, "epic", () => $972b417496a7883a$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $l5XOm = parcelRequire("l5XOm");

var $9LHpK = parcelRequire("9LHpK");

var $gWFyQ = parcelRequire("gWFyQ");

var $9TXr0 = parcelRequire("9TXr0");
const $972b417496a7883a$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, $9LHpK.FETCH_SUGGESTED_TOPICS)).mergeMap((action)=>{
        const { projectId: projectId, activationId: activationId } = action.payload;
        return (0, $kVLXA.Observable).fromPromise((0, $l5XOm.fetchSuggestedTopics)(projectId, activationId)).map((suggestedTopicsResp)=>(0, $9TXr0.fetchSuggestedTopicsSuccess)(suggestedTopicsResp)).catch((err)=>(0, $kVLXA.Observable).of((0, $gWFyQ.fetchSuggestedTopicsFailure)(err)));
    });

});
parcelRegister("gWFyQ", function(module, exports) {

$parcel$export(module.exports, "FETCH_SUGGESTED_TOPICS_FAILURE", () => $9120b153cef115d5$export$282d79fefb9795d);
$parcel$export(module.exports, "fetchSuggestedTopicsFailure", () => $9120b153cef115d5$export$1e442aea405d2ba2);
const $9120b153cef115d5$export$282d79fefb9795d = 'state.actions.fetch-suggested-topics-failure.FETCH_SUGGESTED_TOPICS_FAILURE';
const $9120b153cef115d5$export$1e442aea405d2ba2 = (payload)=>({
        type: $9120b153cef115d5$export$282d79fefb9795d,
        payload: payload
    });

});

parcelRegister("9TXr0", function(module, exports) {

$parcel$export(module.exports, "FETCH_SUGGESTED_TOPICS_SUCCESS", () => $4d80c689bddb5ee7$export$4db2fb5e194bd760);
$parcel$export(module.exports, "fetchSuggestedTopicsSuccess", () => $4d80c689bddb5ee7$export$30c0fa9a0977e006);
const $4d80c689bddb5ee7$export$4db2fb5e194bd760 = 'state.actions.fetch-suggested-topics-success.FETCH_SUGGESTED_TOPICS_SUCCESS';
const $4d80c689bddb5ee7$export$30c0fa9a0977e006 = (payload)=>({
        type: $4d80c689bddb5ee7$export$4db2fb5e194bd760,
        payload: payload
    });

});


parcelRegister("6OXm8", function(module, exports) {

$parcel$export(module.exports, "epic", () => $611d4a2326bd0c8a$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $cVUDi = parcelRequire("cVUDi");

var $fmmX1 = parcelRequire("fmmX1");

var $6zk4x = parcelRequire("6zk4x");

var $ffNrT = parcelRequire("ffNrT");

var $19Gv3 = parcelRequire("19Gv3");

var $gXg4u = parcelRequire("gXg4u");

var $gLt7z = parcelRequire("gLt7z");

const $611d4a2326bd0c8a$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $19Gv3.UPDATE_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
        const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
        const projectId = (0, $gLt7z.getProjectId)(store.getState());
        const activationId = (0, $gLt7z.getActivationId)(store.getState());
        const currentCategoryIds = (0, $gXg4u.getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
        return (0, $fmmX1.updateCategoriesForArticle)({
            projectId: projectId,
            categoryIds: categoryIds,
            articleId: articleId,
            spaceKey: spaceKey,
            activationId: activationId
        }).map(()=>{
            (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
                action: 'update',
                actionSubjectId: articleId
            });
            return (0, $ffNrT.updateCategoriesForArticleSuccess)({
                articleId: articleId,
                categoryIds: categoryIds,
                previousCategoryIds: currentCategoryIds
            });
        }).catch((error)=>{
            const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
            (0, $cVUDi.fireCustomErrorAnalytics)({
                error: error,
                event: analyticsEvent,
                id: 'articleUpdate Failure',
                packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
            });
            return (0, $kVLXA.Observable).of((0, $6zk4x.updateCategoriesForArticleFailure)({
                statusCode: statusCode,
                errorKey: errorKey,
                errorMessage: errorMessage,
                failedCategoryIds: categories,
                articleId: articleId
            }));
        });
    });

});
parcelRegister("ffNrT", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS", () => $80acc745b1c17a99$export$1c5489fde8a5332f);
$parcel$export(module.exports, "updateCategoriesForArticleSuccess", () => $80acc745b1c17a99$export$c725200756c4c1a2);
const $80acc745b1c17a99$export$1c5489fde8a5332f = 'state.actions.update-categories-for-article-success.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS';
const $80acc745b1c17a99$export$c725200756c4c1a2 = (payload)=>({
        payload: payload,
        type: $80acc745b1c17a99$export$1c5489fde8a5332f
    });

});

parcelRegister("19Gv3", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE", () => $44779a20dce37d77$export$a58f1691e9b5c9e3);
$parcel$export(module.exports, "updateCategoriesForArticle", () => $44779a20dce37d77$export$2613b83c3141003a);
const $44779a20dce37d77$export$a58f1691e9b5c9e3 = 'state.actions.update-categories-for-article.UPDATE_CATEGORIES_FOR_ARTICLE';
const $44779a20dce37d77$export$2613b83c3141003a = (payload)=>({
        payload: payload,
        type: $44779a20dce37d77$export$a58f1691e9b5c9e3
    });

});


parcelRegister("fBtAp", function(module, exports) {

$parcel$export(module.exports, "epic", () => $c7393e3a6ad2560d$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $cywfH = parcelRequire("cywfH");

var $8zOmE = parcelRequire("8zOmE");

var $jcw0u = parcelRequire("jcw0u");


var $d8ryz = parcelRequire("d8ryz");
const $c7393e3a6ad2560d$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, $d8ryz.TRIGGER_ARTICLE_GENERATION_FOR_TOPICS)).mergeMap((action)=>{
        const { analyticsEvent: analyticsEvent, projectId: projectId, activationId: activationId } = action.payload;
        return (0, $kVLXA.Observable).fromPromise((0, $cywfH.fetchArticleGenerationForTopics)(projectId, activationId)).mergeMap(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'fetchArticleGenerationForTopics succeeded', {
                projectId: projectId
            });
            return (0, $kVLXA.Observable).empty();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchArticleGenerationForTopics',
                    packageName: 'jiraServicedeskKnowledgeHub',
                    teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
                },
                error: error
            });
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("cywfH", function(module, exports) {

$parcel$export(module.exports, "fetchArticleGenerationForTopics", () => $ebf54415eb8574c5$export$5d2d7bed782963e7);

var $eusud = parcelRequire("eusud");
const $ebf54415eb8574c5$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $ebf54415eb8574c5$export$fd5c5783cdaa5a5f = (projectId, activationId)=>`${$ebf54415eb8574c5$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics/draft-article/generate`;
const $ebf54415eb8574c5$export$5d2d7bed782963e7 = (projectId, activationId)=>{
    const url = $ebf54415eb8574c5$export$fd5c5783cdaa5a5f(projectId, activationId);
    return (0, $eusud.performPostRequest)(url);
};

});


parcelRegister("fFeqO", function(module, exports) {

$parcel$export(module.exports, "epic", () => $fcbc6334de3c8cc5$export$8ec5145af6f76965);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $a28Hx = parcelRequire("a28Hx");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $15yEh = parcelRequire("15yEh");

var $6IPCs = parcelRequire("6IPCs");

var $f70Hn = parcelRequire("f70Hn");
const $fcbc6334de3c8cc5$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, $15yEh.FETCH_AI_DRAFT_CONTENT)).mergeMap((action)=>{
        const { projectId: projectId, activationId: activationId, topicId: topicId, analyticsEvent: analyticsEvent } = action.payload;
        return (0, $kVLXA.Observable).fromPromise((0, $a28Hx.fetchAiDraftPreviewContent)(projectId, activationId, topicId)).map((aiDraftContentResp)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'fetchAiDraftPreviewContent succeeded', {
                projectId: projectId,
                topicId: topicId
            });
            return (0, $6IPCs.fetchAIDraftContentSuccess)(aiDraftContentResp);
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchAiDraftPreviewContent',
                    packageName: 'jiraServicedeskKnowledgeHub',
                    teamName: (0, $abd8c4ced6efb751$export$d57b6b390e78d90f)
                },
                error: error
            });
            return (0, $kVLXA.Observable).of((0, $f70Hn.fetchAIDraftContentFailure)({
                topicId: topicId,
                error: error
            }));
        });
    });

});
parcelRegister("a28Hx", function(module, exports) {

$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $2d46a2ee5c1862bd$export$518af6df5154b1b1);

var $eusud = parcelRequire("eusud");
const $2d46a2ee5c1862bd$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $2d46a2ee5c1862bd$var$getAiDraftPreviewContentUrl = (projectId, activationId, topicId, contentFormat)=>`${$2d46a2ee5c1862bd$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}/draft-article?contentFormat=${contentFormat}`;
const $2d46a2ee5c1862bd$export$518af6df5154b1b1 = (projectId, activationId, topicId)=>{
    const contentFormat = 'text/adf';
    const url = $2d46a2ee5c1862bd$var$getAiDraftPreviewContentUrl(projectId, activationId, topicId, contentFormat);
    return (0, $eusud.performGetRequest)(url);
};

});

parcelRegister("6IPCs", function(module, exports) {

$parcel$export(module.exports, "FETCH_AI_DRAFT_CONTENT_SUCCESS", () => $0b6615c8f1a449b1$export$13f8c99681597bd3);
$parcel$export(module.exports, "fetchAIDraftContentSuccess", () => $0b6615c8f1a449b1$export$75c6f93f1862dec6);
const $0b6615c8f1a449b1$export$13f8c99681597bd3 = 'state.actions.fetch-ai-draft-content.FETCH_AI_DRAFT_CONTENT_SUCCESS';
const $0b6615c8f1a449b1$export$75c6f93f1862dec6 = (payload)=>({
        type: $0b6615c8f1a449b1$export$13f8c99681597bd3,
        payload: payload
    });

});

parcelRegister("f70Hn", function(module, exports) {

$parcel$export(module.exports, "FETCH_AI_DRAFT_CONTENT_FAILURE", () => $ba58d8394264eba2$export$ff0d48646a3ebb94);
$parcel$export(module.exports, "fetchAIDraftContentFailure", () => $ba58d8394264eba2$export$b689e4e935f1b97d);
const $ba58d8394264eba2$export$ff0d48646a3ebb94 = 'state.actions.fetch-ai-draft-content.FETCH_AI_DRAFT_CONTENT_FAILURE';
const $ba58d8394264eba2$export$b689e4e935f1b97d = (payload)=>({
        type: $ba58d8394264eba2$export$ff0d48646a3ebb94,
        payload: payload
    });

});



parcelRegister("1eweq", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubContainer", () => $248571581b729595$export$bb94633c27dcd0a4);
$parcel$export(module.exports, "KnowledgeHubActionsSubscriber", () => $248571581b729595$export$3982d9a4b6ad6814);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $1xzCS = parcelRequire("1xzCS");
const $248571581b729595$export$168a0875d66dd4b7 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $248571581b729595$export$e155678cbf296809 = ()=>({ getState: getState })=>getState();
const $248571581b729595$export$e324594224ef24da = {
    updateStore: $248571581b729595$export$168a0875d66dd4b7,
    getStoreState: $248571581b729595$export$e155678cbf296809
};
const $248571581b729595$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'knowledge-hub',
    initialState: $1xzCS.defaultState,
    actions: $248571581b729595$export$e324594224ef24da
});
const $248571581b729595$export$bb94633c27dcd0a4 = (0, $gg7kZ.createContainer)($248571581b729595$export$390f32400eaf98c9);
const $248571581b729595$export$44bc38849b4bbf73 = (0, $51nlc.createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
    displayName: 'KnowledgeHubState'
});
const $248571581b729595$export$3982d9a4b6ad6814 = (0, $51nlc.createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
    displayName: 'KnowledgeHubActions',
    selector: null
});
const $248571581b729595$export$81f6ad95dee7b9c = (0, $3sQ5x.createHook)($248571581b729595$export$390f32400eaf98c9, {
    selector: null
});

});
parcelRegister("1xzCS", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $349a74123be4d8a0$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $349a74123be4d8a0$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $kChFH = parcelRequire("kChFH");

var $3nEyX = parcelRequire("3nEyX");

var $lJvk4 = parcelRequire("lJvk4");
const $349a74123be4d8a0$var$reducer = (0, $3f2cs.combineReducers)({
    app: $kChFH.default,
    ui: $lJvk4.default,
    entities: $3nEyX.default
});
const $349a74123be4d8a0$export$49d5fc8cba920a0 = {
    app: (0, $kChFH.defaultState),
    ui: (0, $lJvk4.defaultState),
    entities: (0, $3nEyX.defaultState)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$349a74123be4d8a0$export$2e2bcd8739ae039 = (sweetStateUpdater)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state = $349a74123be4d8a0$export$49d5fc8cba920a0, action)=>{
        const outputState = $349a74123be4d8a0$var$reducer(state, action);
        sweetStateUpdater(outputState);
        return outputState;
    };

});
parcelRegister("kChFH", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $1551bcf88a1371a5$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $1551bcf88a1371a5$export$2e2bcd8739ae039);

var $lzeFL = parcelRequire("lzeFL");

var $g5X3G = parcelRequire("g5X3G");

var $kstMB = parcelRequire("kstMB");
const $1551bcf88a1371a5$export$49d5fc8cba920a0 = {
    baseUrl: (0, $g5X3G.toBaseUrl)(''),
    atlassianAccountId: '',
    cloudId: '',
    fabricPfDirUrl: '',
    locale: (0, $lzeFL.defaultLocale),
    userFullname: '',
    portalId: -1,
    projectKey: (0, $g5X3G.toProjectKey)(''),
    projectId: -1,
    projectName: '',
    projectType: '',
    isAdmin: false,
    isJiraAdmin: false,
    isProjectSimplified: false,
    sidebarCategoryLabel: '',
    activationId: 'ee20ebad-e5a1-42f6-899b-18706f0559e7'
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1551bcf88a1371a5$export$2e2bcd8739ae039 = (state = $1551bcf88a1371a5$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $kstMB.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload
            };
        case 0, $kstMB.UPDATE_CATEGORY_SIDEBAR_LABEL:
            return {
                ...state,
                sidebarCategoryLabel: action.payload
            };
        default:
            return state;
    }
};

});
parcelRegister("kstMB", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $802af204f69179eb$export$84856e4ae7cd7538);
$parcel$export(module.exports, "UPDATE_CATEGORY_SIDEBAR_LABEL", () => $802af204f69179eb$export$52e22c956d5c6839);
const $802af204f69179eb$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $802af204f69179eb$export$52e22c956d5c6839 = 'state.actions.app.UPDATE_CATEGORY_SIDEBAR_LABEL';
const $802af204f69179eb$export$5f0e35553cecddfe = (payload)=>({
        type: $802af204f69179eb$export$84856e4ae7cd7538,
        payload: payload
    });
const $802af204f69179eb$export$c2eea28c04c00544 = (payload)=>({
        type: $802af204f69179eb$export$52e22c956d5c6839,
        payload: payload
    });

});


parcelRegister("3nEyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $599b129cc2fb02a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultState", () => $599b129cc2fb02a8$export$49d5fc8cba920a0);

var $3f2cs = parcelRequire("3f2cs");

var $fmcS9 = parcelRequire("fmcS9");

var $gS1i9 = parcelRequire("gS1i9");

var $kahXZ = parcelRequire("kahXZ");

var $5ev1t = parcelRequire("5ev1t");

var $aCUFo = parcelRequire("aCUFo");

var $jsmdo = parcelRequire("jsmdo");

var $3h2aI = parcelRequire("3h2aI");

var $Z19DZ = parcelRequire("Z19DZ");
var $599b129cc2fb02a8$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    hub: $jsmdo.default,
    articles: $kahXZ.default,
    browse: $5ev1t.default,
    categories: $aCUFo.default,
    topics: (0, $Z19DZ.topicsReducer),
    spaces: $3h2aI.default,
    appLink: $fmcS9.default,
    appLinks: $gS1i9.default
});
const $599b129cc2fb02a8$export$49d5fc8cba920a0 = {
    hub: (0, $jsmdo.defaultState),
    articles: (0, $kahXZ.defaultState),
    browse: (0, $5ev1t.defaultState),
    categories: (0, $aCUFo.defaultState),
    spaces: (0, $3h2aI.defaultState),
    topics: (0, $Z19DZ.defaultState),
    appLink: (0, $fmcS9.defaultState),
    appLinks: (0, $gS1i9.defaultState)
};

});
parcelRegister("fmcS9", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $f5121befb21ec1b4$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $f5121befb21ec1b4$export$2e2bcd8739ae039);

var $6FRaa = parcelRequire("6FRaa");

var $aZdbu = parcelRequire("aZdbu");

var $gMZw6 = parcelRequire("gMZw6");
const $f5121befb21ec1b4$export$49d5fc8cba920a0 = {
    isLoaded: false,
    appLink: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5121befb21ec1b4$export$2e2bcd8739ae039 = (state = $f5121befb21ec1b4$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $gMZw6.FETCH_APPLINK:
            {
                const { error: error, ...stateWithoutError } = state;
                const newState = {
                    ...stateWithoutError,
                    isLoaded: false
                };
                return newState;
            }
        case 0, $aZdbu.FETCH_APPLINK_SUCCESS:
            return {
                ...state,
                isLoaded: true,
                appLink: action.payload
            };
        case 0, $6FRaa.FETCH_APPLINK_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoaded: true
            };
        default:
            return state;
    }
};

});

parcelRegister("gS1i9", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $39212e89b0790fee$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $39212e89b0790fee$export$2e2bcd8739ae039);

var $3XkGj = parcelRequire("3XkGj");

var $7GY3F = parcelRequire("7GY3F");

var $4dXi2 = parcelRequire("4dXi2");
const $39212e89b0790fee$export$49d5fc8cba920a0 = {
    isLoaded: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39212e89b0790fee$export$2e2bcd8739ae039 = (state = $39212e89b0790fee$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $4dXi2.FETCH_APPLINKS:
            return {
                ...state,
                error: undefined,
                isLoaded: false
            };
        case 0, $7GY3F.FETCH_APPLINKS_SUCCESS:
            return {
                appLinks: action.payload,
                error: undefined,
                hasConfluenceServer: action.payload.some((appLink)=>appLink.isServer),
                isLoaded: true
            };
        case 0, $3XkGj.FETCH_APPLINKS_FAILURE:
            return {
                appLinks: [],
                error: action.payload,
                hasConfluenceServer: false,
                isLoaded: true
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("kahXZ", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $16983ab139c0b8e5$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $16983ab139c0b8e5$export$2e2bcd8739ae039);

var $4wVpT = parcelRequire("4wVpT");

var $1UikQ = parcelRequire("1UikQ");

var $hqULQ = parcelRequire("hqULQ");

var $5sKH1 = parcelRequire("5sKH1");

var $5XgTr = parcelRequire("5XgTr");

var $6ovlC = parcelRequire("6ovlC");

var $e8y9X = parcelRequire("e8y9X");

var $8j0bg = parcelRequire("8j0bg");

var $80A0Z = parcelRequire("80A0Z");

var $4VDwv = parcelRequire("4VDwv");

var $4C8gV = parcelRequire("4C8gV");

var $agxSw = parcelRequire("agxSw");

var $la4EY = parcelRequire("la4EY");

var $iMgsY = parcelRequire("iMgsY");

var $e4spq = parcelRequire("e4spq");

var $3pXRi = parcelRequire("3pXRi");

var $iHUHp = parcelRequire("iHUHp");

var $9aNfZ = parcelRequire("9aNfZ");

var $l1APE = parcelRequire("l1APE");

var $hsOR7 = parcelRequire("hsOR7");

var $fTBH5 = parcelRequire("fTBH5");

var $6zk4x = parcelRequire("6zk4x");

var $ffNrT = parcelRequire("ffNrT");

var $19Gv3 = parcelRequire("19Gv3");
const $16983ab139c0b8e5$export$49d5fc8cba920a0 = {};
const $16983ab139c0b8e5$var$articleListToObject = (articles)=>articles.reduce((acc, article)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [article.id]: {
                ...article,
                // This is required to handle the response provided
                // by the legacy JSD endpoint.
                // We can remove this when browseAllArticlesMilestone1
                // is unfeatured.
                title: (0, $hqULQ.removeHighlightText)(article.title),
                categories: article.categories && article.categories.map((category)=>category.id)
            }
        }), {});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16983ab139c0b8e5$export$2e2bcd8739ae039 = (state = $16983ab139c0b8e5$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $3pXRi.REMOVE_ARTICLE_FROM_CATEGORY:
        case 0, $6ovlC.ADD_CATEGORIES_FOR_ARTICLE:
        case 0, $19Gv3.UPDATE_CATEGORIES_FOR_ARTICLE:
            if (state[action.payload.articleId]) return {
                ...state,
                [action.payload.articleId]: {
                    ...state[action.payload.articleId],
                    isBusy: true
                }
            };
            return state;
        case 0, $iMgsY.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE:
        case 0, $5sKH1.ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
        case 0, $6zk4x.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
            if (state[action.payload.articleId]) return {
                ...state,
                [action.payload.articleId]: {
                    ...state[action.payload.articleId],
                    isBusy: false
                }
            };
            return state;
        case 0, $e4spq.REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS:
            if (state[action.payload.articleId]) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[action.payload.articleId];
                const { categoryId: categoryId } = action.payload;
                const newCategoriesList = (existingArticle.categories || []).filter((id)=>id !== categoryId);
                const featuredInCategoryList = (existingArticle.featuredInCategories || []).filter((id)=>id !== categoryId);
                return {
                    ...state,
                    [action.payload.articleId]: {
                        ...existingArticle,
                        categories: newCategoriesList,
                        featuredInCategories: featuredInCategoryList,
                        isBusy: false
                    }
                };
            }
            return state;
        case 0, $5XgTr.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { articleId: articleId, categoryIds: newlyAddedCategoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                const allCategoryIds = [
                    ...previousCategoryIds,
                    ...newlyAddedCategoryIds
                ];
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle) {
                    const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                    // only keep featured in categories list with update categories
                    const featuredInCategories = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allCategoryIds, existingFeaturedInCategoryIds);
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            featuredInCategories: featuredInCategories,
                            categories: allCategoryIds,
                            isBusy: false
                        }
                    };
                }
                return state;
            }
        case 0, $ffNrT.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle) {
                    const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                    // only keep featured in categories list with update categories
                    const featuredInCategories = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(categoryIds, existingFeaturedInCategoryIds);
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            featuredInCategories: featuredInCategories,
                            categories: categoryIds,
                            isBusy: false
                        }
                    };
                }
                return state;
            }
        case 0, $4VDwv.BROWSE_KNOWLEDGE_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload.results));
        case 0, $hsOR7.SEARCH_ARTICLES_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload));
        case 0, $la4EY.FETCH_ARTICLE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (state[action.payload.id] && state[action.payload.id].error) {
                const newState = {
                    ...state
                };
                // Remove the article from state if it had an error when fetching again
                delete newState[action.payload.id];
                return newState;
            }
            return state;
        case 0, $agxSw.FETCH_ARTICLE_SUCCESS:
            {
                const { payload: payload } = action;
                const categories = payload.categories ? {
                    categories: payload.categories.map((category)=>category.id)
                } : {};
                const featuredInCategories = payload.featuredInCategories ? {
                    featuredInCategories: payload.featuredInCategories
                } : {};
                const labels = payload.labels?.length ? payload.labels.map(({ id: id, label: label, name: name })=>({
                        id: id,
                        label: label,
                        name: name
                    })) : [];
                const labelState = {
                    labels: labels,
                    isLoading: false,
                    addLabelError: false
                };
                const { labels: existingLabels, isEditable: isEditable, ...payloadWithoutLabels } = payload;
                const articleState = {
                    ...payloadWithoutLabels,
                    ...categories,
                    ...featuredInCategories,
                    labelState: labelState,
                    isEditable: false
                };
                return {
                    ...state,
                    [action.payload.id]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state[action.payload.id], articleState)
                };
            }
        case 0, $4C8gV.FETCH_ARTICLE_FAILURE:
            return {
                ...state,
                [action.payload.id]: {
                    error: action.payload.error
                }
            };
        case 0, $8j0bg.ADD_LABELS_TO_ARTICLE_SUCCESS:
            {
                const { articleId: articleId, labels: labels } = action.payload;
                const existingArticle = state[articleId];
                if (existingArticle) {
                    const updatedLabels = labels.length ? labels.map(({ id: id, label: label, name: name })=>({
                            id: id,
                            label: label,
                            name: name
                        })) : [];
                    const labelState = {
                        labels: updatedLabels,
                        isLoading: false,
                        addLabelError: false
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $9aNfZ.REMOVE_LABEL_FROM_ARTICLE_SUCCESS:
            {
                const { label: label, articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const labelState = existingArticle.labelState || {};
                    const existingLabels = labelState.labels || [];
                    const updatedLabels = existingLabels?.length ? existingLabels.filter(({ label: existingLabel })=>label !== existingLabel) : [];
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: {
                                labels: updatedLabels,
                                isLoading: false,
                                addLabelError: false
                            }
                        }
                    };
                }
                return state;
            }
        case 0, $e8y9X.ADD_LABELS_TO_ARTICLE_FAILURE:
            {
                const { articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle && existingArticle.labelState) {
                    const existingLabels = existingArticle.labelState.labels || [];
                    const labelState = {
                        labels: existingLabels,
                        isLoading: false,
                        addLabelError: true
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $l1APE.REMOVE_LABEL_FROM_ARTICLE:
        case 0, $80A0Z.ADD_LABELS_TO_ARTICLE:
            {
                const { articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle && existingArticle.labelState) {
                    const existingLabels = existingArticle.labelState.labels || [];
                    const labelState = {
                        labels: existingLabels,
                        isLoading: true,
                        addLabelError: false
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $iHUHp.REMOVE_LABEL_FROM_ARTICLE_FAILURE:
            {
                const { articleId: articleId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const existingArticle = state[articleId];
                if (existingArticle && existingArticle.labelState) {
                    const existingLabels = existingArticle.labelState.labels || [];
                    const labelState = {
                        labels: existingLabels,
                        isLoading: false,
                        addLabelError: false
                    };
                    return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            labelState: labelState
                        }
                    };
                }
                return state;
            }
        case 0, $fTBH5.SET_ARTICLE_EDIT_PERMISSION:
            {
                const { articleId: articleId, isEditable: isEditable } = action.payload;
                const existingArticle = state[articleId];
                if (existingArticle) return {
                    ...state,
                    [articleId]: {
                        ...existingArticle,
                        isEditable: isEditable
                    }
                };
                return state;
            }
        default:
            return state;
    }
};

});
parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});


parcelRegister("hqULQ", function(module, exports) {

$parcel$export(module.exports, "removeHighlightText", () => $483996128e1ce34e$export$4fe678a311e29d1a);
const $483996128e1ce34e$export$4fe678a311e29d1a = (text)=>text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');

});

parcelRegister("iMgsY", function(module, exports) {

$parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_FAILURE", () => $e6e2e62b66b39b7e$export$30c079f32002614a);
const $e6e2e62b66b39b7e$export$30c079f32002614a = 'state.actions.remove-article-from-category-failure.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE';
const $e6e2e62b66b39b7e$export$9c7b80de1b92cc2 = (payload)=>({
        payload: payload,
        type: $e6e2e62b66b39b7e$export$30c079f32002614a
    });

});

parcelRegister("e4spq", function(module, exports) {

$parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS", () => $1b3b33db699d8db2$export$8bab89f0adf16580);
const $1b3b33db699d8db2$export$8bab89f0adf16580 = 'state.actions.remove-article-from-category-success.REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS';
const $1b3b33db699d8db2$export$37035f42efedefca = (payload)=>({
        type: $1b3b33db699d8db2$export$8bab89f0adf16580,
        payload: payload
    });

});

parcelRegister("3pXRi", function(module, exports) {

$parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY", () => $df3a27bd08a194ec$export$ffc4687de776860c);
$parcel$export(module.exports, "removeArticleFromCategory", () => $df3a27bd08a194ec$export$b6002acecf935894);
const $df3a27bd08a194ec$export$ffc4687de776860c = 'state.actions.remove-article-from-category.REMOVE_ARTICLE_FROM_CATEGORY';
const $df3a27bd08a194ec$export$b6002acecf935894 = (payload)=>({
        payload: payload,
        type: $df3a27bd08a194ec$export$ffc4687de776860c
    });

});

parcelRegister("hsOR7", function(module, exports) {

$parcel$export(module.exports, "SEARCH_ARTICLES_SUCCESS", () => $4257b84175002daa$export$b377bab65795997b);
const $4257b84175002daa$export$b377bab65795997b = 'state.actions.search-articles-success.SEARCH_ARTICLES_SUCCESS';
const $4257b84175002daa$export$327940e72204ca9b = (payload)=>({
        type: $4257b84175002daa$export$b377bab65795997b,
        payload: payload
    });

});


parcelRegister("5ev1t", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $22d8828255293e73$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $22d8828255293e73$export$2e2bcd8739ae039);

var $16dzj = parcelRequire("16dzj");

var $33YKl = parcelRequire("33YKl");

var $4VDwv = parcelRequire("4VDwv");

var $kHzxc = parcelRequire("kHzxc");

var $0523Q = parcelRequire("0523Q");

var $ffNrT = parcelRequire("ffNrT");
const $22d8828255293e73$export$49d5fc8cba920a0 = {
    limit: 20
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$22d8828255293e73$export$2e2bcd8739ae039 = (state = $22d8828255293e73$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $ffNrT.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { categoryIds: categoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                if (categoryIds) {
                    const newState = {
                        ...state
                    };
                    const categoryIdsNeededCacheClear = (0, (/*@__PURE__*/$parcel$interopDefault($16dzj)))(categoryIds, previousCategoryIds);
                    categoryIdsNeededCacheClear.forEach((categoryId)=>{
                        if (newState[categoryId]) newState[categoryId].shouldClearCacheOnNextFetch = true;
                    });
                    return newState;
                }
                return state;
            }
        case 0, $0523Q.CLEAR_BROWSE:
            {
                const newState = {
                    ...state
                };
                delete newState[action.payload];
                return newState;
            }
        case 0, $kHzxc.BROWSE_KNOWLEDGE:
            if (state[action.payload.id] && state[action.payload.id].pages[`${action.payload.page}`] && // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'string[] | GenericError'.
            state[action.payload.id].pages[`${action.payload.page}`].error) {
                const newState = {
                    ...state,
                    loading: true
                };
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ loading: boolean; limit: number; }'.
                delete newState[action.payload.id].pages[`${action.payload.page}`];
                // @ts-expect-error - TS2322 - Type '{ loading: boolean; limit: number; }' is not assignable to type 'BrowseState'.
                return newState;
            }
            if (state[action.payload.id] && state[action.payload.id].shouldClearCacheOnNextFetch) {
                const newState = {
                    ...state,
                    loading: true,
                    [action.payload.id]: {
                        ...state[action.payload.id],
                        shouldClearCacheOnNextFetch: false,
                        pages: {}
                    }
                };
                // @ts-expect-error - TS2322 - Type '{ [x: string]: boolean | BrowseCategoryState | { shouldClearCacheOnNextFetch: boolean; pages: {}; totalSize: number; nextCursor?: string | undefined; prevCursor?: string | undefined; previousPagePath?: string | undefined; categoriesSupported: boolean; }; loading: boolean; limit: number; }' is not assignable to type 'BrowseState'.
                return newState;
            }
            // @ts-expect-error - TS2322 - Type '{ loading: true; limit: number; }' is not assignable to type 'BrowseState'.
            return {
                ...state,
                loading: true
            };
        case 0, $33YKl.BROWSE_KNOWLEDGE_FAILURE:
            // eslint-disable-next-line no-case-declarations
            const newFailureState = {
                ...state,
                loading: false,
                [action.payload.id]: {
                    pages: {
                        [`${action.payload.page}`]: {
                            error: action.payload.error
                        }
                    }
                }
            };
            // @ts-expect-error - TS2322 - Type '{ readonly [x: string]: false | BrowseCategoryState | { readonly pages: { readonly [x: string]: { readonly error: GenericErrorObject; }; }; }; readonly loading: false; readonly limit: number; }' is not assignable to type 'BrowseState'.
            return newFailureState;
        case 0, $4VDwv.BROWSE_KNOWLEDGE_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const newSuccessState = {
                ...state,
                loading: false,
                [action.payload.id]: {
                    totalSize: action.payload.totalSize,
                    categoriesSupported: action.payload.categoriesSupported,
                    pages: {
                        ...state[action.payload.id] ? state[action.payload.id].pages : {},
                        [`${action.payload.page}`]: action.payload.results.map((article)=>article.id)
                    },
                    nextCursor: action.payload.nextCursor || '',
                    prevCursor: action.payload.prevCursor || ''
                }
            };
            // @ts-expect-error - TS2322 - Type '{ readonly [x: string]: false | BrowseCategoryState | { readonly nextCursor: string; readonly prevCursor: string; readonly totalSize: number; readonly categoriesSupported: boolean; readonly pages: { ...; }; }; readonly loading: false; readonly limit: number; }' is not assignable to type 'BrowseState'.
            return newSuccessState;
        default:
            return state;
    }
};

});
parcelRegister("16dzj", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
    return $7txx8($2GdQn(arrays, $f3SOL));
});
module.exports = $0cd0e06461d5e057$var$xor;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("0523Q", function(module, exports) {

$parcel$export(module.exports, "CLEAR_BROWSE", () => $bf00c744d75604af$export$6795bd145eb16b7e);
const $bf00c744d75604af$export$6795bd145eb16b7e = 'state.actions.clear-browse.CLEAR_BROWSE';
const $bf00c744d75604af$export$862ad1bcf49b6105 = (categoryId)=>({
        type: $bf00c744d75604af$export$6795bd145eb16b7e,
        payload: categoryId
    });

});


parcelRegister("aCUFo", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $67411d71966dddb0$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $67411d71966dddb0$export$2e2bcd8739ae039);

var $4VDwv = parcelRequire("4VDwv");

var $agxSw = parcelRequire("agxSw");

var $4COnH = parcelRequire("4COnH");

var $7gdJb = parcelRequire("7gdJb");

var $jpaaK = parcelRequire("jpaaK");

var $hsOR7 = parcelRequire("hsOR7");
const $67411d71966dddb0$export$49d5fc8cba920a0 = {
    isLoaded: false,
    categories: [],
    isCategoriesSupported: false
};
const $67411d71966dddb0$var$reduceCategoriesFromArticles = (articles, existingCategories)=>{
    const categories = [
        ...existingCategories
    ];
    articles // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, article)=>acc.concat(article.categories), []).forEach((category)=>{
        if (category && !categories.find((existingCategory)=>category.id === existingCategory.id)) categories.push(category);
    });
    return categories;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67411d71966dddb0$export$2e2bcd8739ae039 = (state = $67411d71966dddb0$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $7gdJb.FETCH_CATEGORIES_SUCCESS:
            return {
                categories: action.payload.categories,
                isCategoriesSupported: action.payload.categoriesSupported,
                isLoaded: true
            };
        case 0, $4COnH.FETCH_CATEGORIES_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoaded: true
            };
        case 0, $jpaaK.FETCH_CATEGORIES:
            {
                // Maintain existing categories and set loading state to true
                const newState = {
                    ...state,
                    isLoaded: false
                };
                delete newState.error;
                return newState;
            }
        case 0, $4VDwv.BROWSE_KNOWLEDGE_SUCCESS:
            {
                const newState = {
                    ...state,
                    categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload.results, state.categories)
                };
                return newState;
            }
        case 0, $hsOR7.SEARCH_ARTICLES_SUCCESS:
            {
                const newState = {
                    ...state,
                    categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload, state.categories)
                };
                return newState;
            }
        case 0, $agxSw.FETCH_ARTICLE_SUCCESS:
            {
                const newState = {
                    ...state,
                    categories: $67411d71966dddb0$var$reduceCategoriesFromArticles([
                        action.payload
                    ], state.categories)
                };
                return newState;
            }
        default:
            return state;
    }
};

});

parcelRegister("jsmdo", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $8ca7f66155305974$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $8ca7f66155305974$export$2e2bcd8739ae039);

var $eIzL1 = parcelRequire("eIzL1");

var $dtw6v = parcelRequire("dtw6v");

var $bHD2d = parcelRequire("bHD2d");

var $k9iYw = parcelRequire("k9iYw");
const $8ca7f66155305974$export$49d5fc8cba920a0 = {
    linkedState: 'loading'
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8ca7f66155305974$export$2e2bcd8739ae039 = (state = $8ca7f66155305974$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $dtw6v.FETCH_KB_HUB_SUCCESS:
            {
                const { projectKey: _, ...data } = action.payload;
                return {
                    id: data.id,
                    confluenceUrl: (0, $k9iYw.removeTrailingSlash)(data.baseUrl),
                    spaceKey: data.spaceKey,
                    linkedState: 'linked'
                };
            }
        case 0, $eIzL1.FETCH_KB_HUB_FAILURE:
            if (action.payload.error.key === 'sd.kb.link.error.link.not.found') // Confluence was either not linked, or no space was linked yet.
            return {
                linkedState: 'unlinked'
            };
            return {
                messageKey: action.payload.error.key,
                linkedState: 'error'
            };
        case 0, $bHD2d.SET_KB_HUB:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("bHD2d", function(module, exports) {

$parcel$export(module.exports, "SET_KB_HUB", () => $35c3183d0ed1f802$export$5d4aeddc17f0cd0f);
$parcel$export(module.exports, "setKbHub", () => $35c3183d0ed1f802$export$3f646e047bd99e08);
const $35c3183d0ed1f802$export$5d4aeddc17f0cd0f = 'state.actions.set-knowledge-hub.SET_KB_HUB';
const $35c3183d0ed1f802$export$3f646e047bd99e08 = (payload)=>({
        type: $35c3183d0ed1f802$export$5d4aeddc17f0cd0f,
        payload: payload
    });

});

parcelRegister("k9iYw", function(module, exports) {

$parcel$export(module.exports, "removeTrailingSlash", () => $f5e36f4cfb7d0348$export$b6d465111d914331);
const $f5e36f4cfb7d0348$export$b6d465111d914331 = (str)=>str.replace(/\/$/, '');

});


parcelRegister("3h2aI", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $c0be59ff1e3dfebc$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $c0be59ff1e3dfebc$export$2e2bcd8739ae039);

var $azjdP = parcelRequire("azjdP");

var $jzG6G = parcelRequire("jzG6G");

var $goH2j = parcelRequire("goH2j");
const $c0be59ff1e3dfebc$export$49d5fc8cba920a0 = {
    linkedSpaces: {
        data: [],
        error: null,
        loading: false
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c0be59ff1e3dfebc$export$2e2bcd8739ae039 = (state = $c0be59ff1e3dfebc$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $goH2j.FETCH_LINKED_SPACES:
            return {
                ...state,
                linkedSpaces: {
                    data: [],
                    error: null,
                    loading: true
                }
            };
        case 0, $jzG6G.FETCH_LINKED_SPACE_SUCCESS:
            return {
                ...state,
                linkedSpaces: {
                    error: null,
                    loading: false,
                    data: action.payload.spaces
                }
            };
        case 0, $azjdP.FETCH_LINKED_SPACES_FAILURE:
            return {
                ...state,
                linkedSpaces: {
                    loading: false,
                    data: [],
                    error: action.payload.error
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("Z19DZ", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $26d4397e7607d8a4$export$49d5fc8cba920a0);
$parcel$export(module.exports, "topicsReducer", () => $26d4397e7607d8a4$export$198e0b23084f1505);

var $gWFyQ = parcelRequire("gWFyQ");

var $9TXr0 = parcelRequire("9TXr0");

var $9LHpK = parcelRequire("9LHpK");

var $15yEh = parcelRequire("15yEh");

var $6IPCs = parcelRequire("6IPCs");

var $f70Hn = parcelRequire("f70Hn");
const $26d4397e7607d8a4$export$49d5fc8cba920a0 = {
    topics: []
};
const $26d4397e7607d8a4$export$198e0b23084f1505 = (state = $26d4397e7607d8a4$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $9TXr0.FETCH_SUGGESTED_TOPICS_SUCCESS:
            return {
                ...state,
                topics: action.payload.topics
            };
        case 0, $6IPCs.FETCH_AI_DRAFT_CONTENT_SUCCESS:
            return {
                ...state,
                topics: state.topics.map((topic)=>topic.topicId === action.payload.topicId ? {
                        ...topic,
                        aiDraftPreview: {
                            loading: false,
                            error: null,
                            data: action.payload.content
                        }
                    } : topic)
            };
        case 0, $f70Hn.FETCH_AI_DRAFT_CONTENT_FAILURE:
            return {
                ...state,
                topics: state.topics.map((topic)=>topic.topicId === action.payload.topicId ? {
                        ...topic,
                        aiDraftPreview: {
                            loading: false,
                            error: action.payload.error,
                            data: null
                        }
                    } : topic)
            };
        case 0, $15yEh.FETCH_AI_DRAFT_CONTENT:
        case 0, $9LHpK.FETCH_SUGGESTED_TOPICS:
        case 0, $gWFyQ.FETCH_SUGGESTED_TOPICS_FAILURE:
        default:
            return state;
    }
};

});


parcelRegister("lJvk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fc5aff003b114a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultState", () => $61fc5aff003b114a$export$49d5fc8cba920a0);

var $3f2cs = parcelRequire("3f2cs");

var $daO3a = parcelRequire("daO3a");
var $61fc5aff003b114a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    articles: $daO3a.default
});
const $61fc5aff003b114a$export$49d5fc8cba920a0 = {
    articles: (0, $daO3a.defaultState)
};

});
parcelRegister("daO3a", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $ffb3ac562043eddf$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $ffb3ac562043eddf$export$2e2bcd8739ae039);

var $5sKH1 = parcelRequire("5sKH1");

var $5XgTr = parcelRequire("5XgTr");

var $6ovlC = parcelRequire("6ovlC");

var $9fA8j = parcelRequire("9fA8j");

var $5ZGnB = parcelRequire("5ZGnB");

var $6zk4x = parcelRequire("6zk4x");

var $ffNrT = parcelRequire("ffNrT");

var $19Gv3 = parcelRequire("19Gv3");

var $fQZG5 = parcelRequire("fQZG5");
const $ffb3ac562043eddf$export$49d5fc8cba920a0 = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffb3ac562043eddf$export$2e2bcd8739ae039 = (state = $ffb3ac562043eddf$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $6ovlC.ADD_CATEGORIES_FOR_ARTICLE:
        case 0, $19Gv3.UPDATE_CATEGORIES_FOR_ARTICLE:
            {
                const { categoryIds: categoryIds, articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        isShowingBulkCategoryAdder: !!(state[articleId] && state[articleId].isShowingBulkCategoryAdder),
                        categoriesInBulkCategoryAdder: state[articleId] ? state[articleId].categoriesInBulkCategoryAdder : [],
                        categoryIds: categoryIds
                    }
                };
            }
        case 0, $ffNrT.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
        case 0, $5XgTr.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
            {
                const { articleId: articleId } = action.payload;
                const newState = {
                    ...state
                };
                delete newState[articleId];
                return newState;
            }
        case 0, $6zk4x.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
        case 0, $5sKH1.ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
            {
                const { failedCategoryIds: failedCategoryIds, errorMessage: errorMessage, articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        failedCategoryIds: failedCategoryIds,
                        error: errorMessage
                    }
                };
            }
        case 0, $5ZGnB.SHOW_BULK_CATEGORY_ADDER:
            {
                const { articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        isShowingBulkCategoryAdder: true
                    }
                };
            }
        case 0, $9fA8j.HIDE_BULK_CATEGORY_ADDER:
            {
                const { articleId: articleId } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        isShowingBulkCategoryAdder: false,
                        categoriesInBulkCategoryAdder: []
                    }
                };
            }
        case 0, $fQZG5.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER:
            {
                const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                return {
                    ...state,
                    [articleId]: {
                        ...state[articleId],
                        categoriesInBulkCategoryAdder: categoryIds
                    }
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("9fA8j", function(module, exports) {

$parcel$export(module.exports, "HIDE_BULK_CATEGORY_ADDER", () => $ed66b70bc3006a26$export$63cec6f97de61b9a);
$parcel$export(module.exports, "hideBulkCategoryAdder", () => $ed66b70bc3006a26$export$541e941f3628edb2);
const $ed66b70bc3006a26$export$63cec6f97de61b9a = 'state.actions.hide-bulk-category-adder.HIDE_BULK_CATEGORY_ADDER';
const $ed66b70bc3006a26$export$541e941f3628edb2 = (payload)=>({
        payload: payload,
        type: $ed66b70bc3006a26$export$63cec6f97de61b9a
    });

});

parcelRegister("5ZGnB", function(module, exports) {

$parcel$export(module.exports, "SHOW_BULK_CATEGORY_ADDER", () => $27a097cc2a8fd1f3$export$848c1458a48faa31);
$parcel$export(module.exports, "showBulkCategoryAdder", () => $27a097cc2a8fd1f3$export$aea09bcda8ca9577);
const $27a097cc2a8fd1f3$export$848c1458a48faa31 = 'state.actions.show-bulk-category-adder.SHOW_BULK_CATEGORY_ADDER';
const $27a097cc2a8fd1f3$export$aea09bcda8ca9577 = (payload)=>({
        payload: payload,
        type: $27a097cc2a8fd1f3$export$848c1458a48faa31
    });

});

parcelRegister("fQZG5", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER", () => $3b0b6b45936d49fc$export$e08673e3855cdb43);
$parcel$export(module.exports, "updateCategoriesInBulkCategoryAdder", () => $3b0b6b45936d49fc$export$f603b0637b290a5e);
const $3b0b6b45936d49fc$export$e08673e3855cdb43 = 'state.actions.update-categories-in-bulk-category-adder.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER';
const $3b0b6b45936d49fc$export$f603b0637b290a5e = (payload)=>({
        payload: payload,
        type: $3b0b6b45936d49fc$export$e08673e3855cdb43
    });

});





parcelRegister("7FkcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01143916800e31c$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $7gdJb = parcelRequire("7gdJb");

var $bHD2d = parcelRequire("bHD2d");

var $8WLSX = parcelRequire("8WLSX");
var $f01143916800e31c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(()=>({}), {
    onSetKbHub: (0, $bHD2d.setKbHub),
    setCategoriesData: (0, $7gdJb.fetchCategoriesSuccess)
})((0, $8WLSX.default));

});
parcelRegister("8WLSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8de5c2338e3adc79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $8de5c2338e3adc79$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.onSetKbHub();
        this.setCategoriesData();
    }
    componentDidUpdate() {
        this.onSetKbHub();
        this.setCategoriesData();
    }
    onSetKbHub() {
        const { onSetKbHub: onSetKbHub, setCategoriesData: setCategoriesData, children: children, categories: categories, isCategoriesSupported: isCategoriesSupported, ...confluenceLink } = this.props;
        onSetKbHub(confluenceLink);
    }
    setCategoriesData() {
        const { setCategoriesData: setCategoriesData, categories: categories, isCategoriesSupported: isCategoriesSupported } = this.props;
        setCategoriesData({
            categories: // TODO modernisation fix-types
            categories,
            categoriesSupported: isCategoriesSupported
        });
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("6GLlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e4a0c92f65aa33$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $9noxX = parcelRequire("9noxX");

var $e9YVH = parcelRequire("e9YVH");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $cYaqS = parcelRequire("cYaqS");
const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cYaqS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e9YVH.toPackageName)(appName),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, children))));
var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $aTz47 = parcelRequire("aTz47");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $7c914880cb332728$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aTz47 = parcelRequire("aTz47");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $3s0xG = parcelRequire("3s0xG");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7xBz2 = parcelRequire("7xBz2");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundDocumentTitleJsm : (0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundTitle : (0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundAction : (0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $32M8E.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $aatTc.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $7xBz2.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $lAOer.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $lAOer.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $lAOer.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $lAOer.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $2s57o.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $fzUGr = parcelRequire("fzUGr");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzUGr.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $2s57o.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("fzUGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a96956312d74a20$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $la5nd = parcelRequire("la5nd");

var $jhA2F = parcelRequire("jhA2F");

var $bEVVW = parcelRequire("bEVVW");

var $gCl68 = parcelRequire("gCl68");
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $0a96956312d74a20$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const theme = (0, $5uXOq.useMemo)(()=>(0, $jhA2F.getCodeBlockTheme)(numLines), [
        numLines
    ]);
    const getStyles = (0, $5uXOq.useMemo)(()=>(0, $jhA2F.getCodeBlockStyles)(theme), [
        theme
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
        highlightedStartText,
        highlightedEndText,
        showLineNumbers,
        shouldWrapLongLines,
        getStyles
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $la5nd.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $bEVVW.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gCl68.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        css: styles,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text
    });
});
$0a96956312d74a20$var$CodeBlock.displayName = 'CodeBlock';
var $0a96956312d74a20$export$2e2bcd8739ae039 = $0a96956312d74a20$var$CodeBlock;

});
parcelRegister("la5nd", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $d16fc758e2d4acef$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $d16fc758e2d4acef$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $d16fc758e2d4acef$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("jhA2F", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $612757b728dd1aa7$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $612757b728dd1aa7$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $612757b728dd1aa7$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2bzvJ = parcelRequire("2bzvJ");

var $k4iY2 = parcelRequire("k4iY2");
const $612757b728dd1aa7$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $612757b728dd1aa7$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $2bzvJ.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $2bzvJ.SPACING}px !important`,
        paddingLeft: (0, $2bzvJ.SPACING),
        marginRight: (0, $2bzvJ.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $612757b728dd1aa7$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
/**
 * Styles applied at the root element level, common across code/codeblock
 */ const $612757b728dd1aa7$var$getBaseCodeStyles = (theme)=>({
        fontSize: (0, $2bzvJ.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $2bzvJ.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $612757b728dd1aa7$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $2bzvJ.SPACING}px 0` : (0, $2bzvJ.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $2bzvJ.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$612757b728dd1aa7$var$getBaseCodeStyles(theme),
            ...$612757b728dd1aa7$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $612757b728dd1aa7$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $2bzvJ.SPACING}px !important`,
                marginRight: `-${0, $2bzvJ.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $2bzvJ.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $2bzvJ.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $2bzvJ.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $2bzvJ.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $2bzvJ.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $2bzvJ.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $2bzvJ.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $2bzvJ.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $2bzvJ.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $612757b728dd1aa7$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $k4iY2.getBaseTheme)();
    const baseStyles = $612757b728dd1aa7$var$getBaseCodeStyles(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $612757b728dd1aa7$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $k4iY2.getBaseTheme)(),
        ...(0, $k4iY2.getColorPalette)(),
        lineNumberWidth: maxLines ? $612757b728dd1aa7$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("2bzvJ", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $951cda86c3f7ec2a$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $951cda86c3f7ec2a$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $951cda86c3f7ec2a$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $951cda86c3f7ec2a$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $951cda86c3f7ec2a$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $951cda86c3f7ec2a$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $951cda86c3f7ec2a$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $b4a3S = parcelRequire("b4a3S");
const $951cda86c3f7ec2a$export$431ac46d758d98c8 = 12;
const $951cda86c3f7ec2a$export$8e3c04032121c606 = '20px';
const $951cda86c3f7ec2a$export$c8b5dc30e9f2b86e = '4px';
const $951cda86c3f7ec2a$export$82ea42e772d49e5b = (0, $b4a3S.gridSize)();
const $951cda86c3f7ec2a$export$eeeea0ff98e06fff = $951cda86c3f7ec2a$export$82ea42e772d49e5b * 2;
const $951cda86c3f7ec2a$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $951cda86c3f7ec2a$export$1758fda69688282e = '--ds--code--bg-color';
const $951cda86c3f7ec2a$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("k4iY2", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $4e08fe6f3ebd682e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $4e08fe6f3ebd682e$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $zbAwE = parcelRequire("zbAwE");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $4e08fe6f3ebd682e$var$T800 = '#067384';
const $4e08fe6f3ebd682e$var$Y1100 = '#7A5D1A';
const $4e08fe6f3ebd682e$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $zbAwE.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$3e51e8f1440314ba})`
    });
const $4e08fe6f3ebd682e$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$a7f8c6b391092279$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$4e08fe6f3ebd682e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$a7f8c6b391092279$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$4e08fe6f3ebd682e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$a7f8c6b391092279$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$4e08fe6f3ebd682e$var$Y1100})`
    };
});
const $4e08fe6f3ebd682e$var$getTheme = ()=>({
        ...$4e08fe6f3ebd682e$export$4464aa303b3e4fda(),
        ...$4e08fe6f3ebd682e$export$fe2a6478976e8b17()
    });
var $4e08fe6f3ebd682e$export$2e2bcd8739ae039 = $4e08fe6f3ebd682e$var$getTheme;

});


parcelRegister("bEVVW", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $4fed610104ef97c9$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $fTglf = parcelRequire("fTglf");
const $4fed610104ef97c9$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $fTglf.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("fTglf", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $c6e245aeba898e2e$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $c6e245aeba898e2e$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("gCl68", function(module, exports) {

$parcel$export(module.exports, "default", () => $868e310e7b464206$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $6HXiV = parcelRequire("6HXiV");
var $868e310e7b464206$export$2e2bcd8739ae039 = (0, $6HXiV.default);

});
parcelRegister("6HXiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f9107b8996345e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $25Oq3 = parcelRequire("25Oq3");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $23f9107b8996345e$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $25Oq3.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $23f9107b8996345e$var$asyncGenerator = $23f9107b8996345e$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $23f9107b8996345e$export$2e2bcd8739ae039 = $23f9107b8996345e$var$asyncGenerator;

});
parcelRegister("25Oq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3f60eeac7eb983$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jPgP9 = parcelRequire("jPgP9");

var $39BkO = parcelRequire("39BkO");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $3a3f60eeac7eb983$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $jPgP9.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39BkO.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $3a3f60eeac7eb983$export$2e2bcd8739ae039 = $3a3f60eeac7eb983$var$Highlight;

});
parcelRegister("jPgP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f127a4a907a87e$export$2e2bcd8739ae039);

var $3MiM2 = parcelRequire("3MiM2");

var $1BFv0 = parcelRequire("1BFv0");

var $fQLWH = parcelRequire("fQLWH");

var $gmwnr = parcelRequire("gmwnr");
const $83f127a4a907a87e$var$newLineRegex = /\n/g;
function $83f127a4a907a87e$var$getNewLines(str) {
    return str.match($83f127a4a907a87e$var$newLineRegex);
}
function $83f127a4a907a87e$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $gmwnr.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $3MiM2.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $fQLWH.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $83f127a4a907a87e$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $1BFv0.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $1BFv0.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("3MiM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c5ea60b42d5d4bb$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");

var $54p18 = parcelRequire("54p18");
function $5c5ea60b42d5d4bb$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $1BFv0.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $54p18.default)(lineNumber));
            return children;
        }
    };
}
var $5c5ea60b42d5d4bb$export$2e2bcd8739ae039 = $5c5ea60b42d5d4bb$var$createLineGenerator;

});
parcelRegister("1BFv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $172b8b54beacc18d$export$2e2bcd8739ae039);

var $54p18 = parcelRequire("54p18");
function $172b8b54beacc18d$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $54p18.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $54p18.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("54p18", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834caf662eda994$export$2e2bcd8739ae039);
function $3834caf662eda994$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("fQLWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c252c59a03fc27$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");
function $59c252c59a03fc27$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $1BFv0.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $59c252c59a03fc27$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("gmwnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e0821c048da7b0$export$2e2bcd8739ae039);
function $e0e0821c048da7b0$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("39BkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50830aca1ec5f8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dMYCB = parcelRequire("dMYCB");
function $b50830aca1ec5f8b$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dMYCB.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("dMYCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde6b95e25c7a358$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $UXrz9 = parcelRequire("UXrz9");

var $lmODa = parcelRequire("lmODa");

var $gBK9d = parcelRequire("gBK9d");
function $dde6b95e25c7a358$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $dde6b95e25c7a358$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $lmODa.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $UXrz9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $gBK9d.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $dde6b95e25c7a358$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("UXrz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fb86ced30fc4f0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $eMkc6 = parcelRequire("eMkc6");
function $f6fb86ced30fc4f0$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: label,
        tag: $f6fb86ced30fc4f0$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $f6fb86ced30fc4f0$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("eMkc6", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $6a3ad388ce84f83d$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $cBCgC = parcelRequire("cBCgC");
const $6a3ad388ce84f83d$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $6a3ad388ce84f83d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $6a3ad388ce84f83d$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cBCgC.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("lmODa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfe4bd40045326b$export$2e2bcd8739ae039);
const $8dfe4bd40045326b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $8dfe4bd40045326b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($8dfe4bd40045326b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gBK9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17e0d9de8ef9bb6$export$2e2bcd8739ae039);

var $dMYCB = parcelRequire("dMYCB");
function $b17e0d9de8ef9bb6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dMYCB.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $86vzA = parcelRequire("86vzA");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($86vzA))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $5KCCi = parcelRequire("5KCCi");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    },
    customerHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm",
        "defaultMessage": "Customer hub not found - Service project"
    },
    customerHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-title",
        "defaultMessage": "This customer hub isn't available"
    },
    customerHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-action",
        "defaultMessage": "View a list of all customer hubs"
    }
});

});





parcelRegister("e33py", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $ae40b537a934bf9c$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $ae40b537a934bf9c$export$c7841d2c1c13065e);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $2BHCj = parcelRequire("2BHCj");
const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${subsection} - ${formatMessage((0, $2BHCj.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $2BHCj.default)[section])} - ${formatMessage((0, $2BHCj.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
        title: title
    });
};
const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, $9sGI6.default)($ae40b537a934bf9c$export$155581e8dc02007a, {
    DocumentTitle: (0, $id7K0.DocumentTitle)
});
var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;

});
parcelRegister("2BHCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7eb5ce3479323e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "External resources"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    },
    helpCenterForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
        "defaultMessage": "Forms"
    },
    helpCenterDetails: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-details",
        "defaultMessage": "Details"
    },
    virtualAgentAiAnswers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
        "defaultMessage": "Atlassian Intelligence answers"
    },
    virtualAgentPerformance: {
        "id": "servicedesk-spa-commons.common.utils.document-title.performance",
        "defaultMessage": "Performance"
    },
    customerAccess: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-access",
        "defaultMessage": "Customer access"
    },
    articles: {
        "id": "servicedesk-spa-commons.common.utils.document-title.articles",
        "defaultMessage": "Articles"
    },
    createArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.create-article",
        "defaultMessage": "Create articles"
    },
    viewArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-article",
        "defaultMessage": "View article"
    },
    supportWebsite: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website",
        "defaultMessage": "Support website"
    },
    supportWebsiteOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-overview",
        "defaultMessage": "Support website overview"
    },
    supportWebsitePages: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-pages",
        "defaultMessage": "Support website pages"
    },
    viewsSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-settings",
        "defaultMessage": "Views Settings"
    },
    customerServiceAgentOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-overview",
        "defaultMessage": "Customer Service Agent"
    },
    customerServiceAgentKnowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-knowledge",
        "defaultMessage": "Customer Service Agent Knowledge"
    },
    customerServiceAgentReview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-review",
        "defaultMessage": "Customer Service Agent Review"
    },
    customerServiceAgentSimulator: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-simulator",
        "defaultMessage": "Customer Service Agent Test"
    }
});

});


parcelRegister("6FTcZ", function(module, exports) {

$parcel$export(module.exports, "useKbConfluenceContext", () => $5955acba1bcddf7a$export$a8450b4f39918e6d);

var $5uXOq = parcelRequire("5uXOq");

var $bjZiV = parcelRequire("bjZiV");

var $2YP9W = parcelRequire("2YP9W");
const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, $bjZiV.kbConfluenceContextResource);
const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $2YP9W.useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};
var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;

});

parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8jaNf = parcelRequire("8jaNf");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page = (0, $8jaNf.default), children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8jaNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0dbbbc94fbed9b4$export$2e2bcd8739ae039);

var $9DqAW = parcelRequire("9DqAW");

var $cigQb = parcelRequire("cigQb");

var $4KBRy = parcelRequire("4KBRy");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$b0dbbbc94fbed9b4$export$2e2bcd8739ae039 = (0, $9DqAW.default);

});
parcelRegister("9DqAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7afc820429f3d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");
function $6f7afc820429f3d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f7afc820429f3d0$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $6f7afc820429f3d0$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $6f7afc820429f3d0$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $6f7afc820429f3d0$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $6f7afc820429f3d0$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $6f7afc820429f3d0$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $6f7afc820429f3d0$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $ggIgZ.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6f7afc820429f3d0$var$pageContentStyles
    }, children)));
};
var $6f7afc820429f3d0$export$2e2bcd8739ae039 = $6f7afc820429f3d0$var$Page;

});






//# sourceMappingURL=async-servicedesk-knowledge-hub-browse-all-articles.25683133.js.map
